//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseAPI {
  constructor(protected configuration: Configuration) {}

  getBaseUrl(prefix: string, baseUrl: string) {
    const finalBaseUrl = baseUrl || this.configuration.basePath || BASE_PATH;

    return `${finalBaseUrl}${prefix}`;
  }

  async transformOptions(options: RequestInit): Promise<RequestInit> {
    if (options.headers) {
      let apiKey: string;
      if (this.configuration.apiKeyPromise) {
        apiKey = await this.configuration.apiKeyPromise();
      } else {
        apiKey = this.configuration.apiKey;
      }
      (options.headers as any)["authorization"] = apiKey;
      if (this.configuration.headers) {
        options.headers = {
          ...options.headers,
          ...this.configuration.headers,
        };
      }
      for (const middleware of this.configuration.middlewares) {
        options = (await middleware.pre(options)) || options;
      }
    }

    return Promise.resolve(options);
  }

  async transformResult(
    url: string,
    response: Response,
    processor: (response: Response) => Promise<any>
  ): Promise<any> {
    // is there middlware in configuration
    for (const middleware of this.configuration.middlewares) {
      response = (await middleware.post(response)) || response;
    }

    return processor(response);
  }
}

export interface IActionGroupApi {

    getActionGroup(actionGroupId?: number | undefined, x_Version?: string | null | undefined): Promise<EditActionGroupDto>;

    saveActionGroup(dto: EditActionGroupDto, x_Version?: string | null | undefined): Promise<number>;

    deleteActionGroup(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getActionGroupsTree(x_Version?: string | null | undefined): Promise<ActionGroupTreeItem[]>;

    baseSearch(sObj: ActionGroupSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGroupGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ActionGroupApi extends BaseAPI implements IActionGroupApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getActionGroup(actionGroupId?: number | undefined, x_Version?: string | null | undefined): Promise<EditActionGroupDto> {
        let url_ = this.baseUrl + "/api/ActionGroup?";
        if (actionGroupId === null)
            throw new globalThis.Error("The parameter 'actionGroupId' cannot be null.");
        else if (actionGroupId !== undefined)
            url_ += "actionGroupId=" + encodeURIComponent("" + actionGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActionGroup(_response));
        });
    }

    protected processGetActionGroup(response: Response): Promise<EditActionGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditActionGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditActionGroupDto>(null as any);
    }

    saveActionGroup(dto: EditActionGroupDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ActionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveActionGroup(_response));
        });
    }

    protected processSaveActionGroup(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteActionGroup(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ActionGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteActionGroup(_response));
        });
    }

    protected processDeleteActionGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getActionGroupsTree(x_Version?: string | null | undefined): Promise<ActionGroupTreeItem[]> {
        let url_ = this.baseUrl + "/api/ActionGroup/action-group-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActionGroupsTree(_response));
        });
    }

    protected processGetActionGroupsTree(response: Response): Promise<ActionGroupTreeItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActionGroupTreeItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionGroupTreeItem[]>(null as any);
    }

    baseSearch(sObj: ActionGroupSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGroupGridDto> {
        let url_ = this.baseUrl + "/api/ActionGroup/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfActionGroupGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfActionGroupGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfActionGroupGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ActionGroup/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/ActionGroup/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IActionRoleApi {

    getAction(actionId?: number | undefined, x_Version?: string | null | undefined): Promise<EditActionDto>;

    saveAction(dto: EditActionDto, x_Version?: string | null | undefined): Promise<number>;

    updateActionRole(dto: UpdateActionRoleDto, x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(sObj: ActionRoleSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ActionRoleApi extends BaseAPI implements IActionRoleApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAction(actionId?: number | undefined, x_Version?: string | null | undefined): Promise<EditActionDto> {
        let url_ = this.baseUrl + "/api/ActionRole?";
        if (actionId === null)
            throw new globalThis.Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAction(_response));
        });
    }

    protected processGetAction(response: Response): Promise<EditActionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditActionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditActionDto>(null as any);
    }

    saveAction(dto: EditActionDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ActionRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveAction(_response));
        });
    }

    protected processSaveAction(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateActionRole(dto: UpdateActionRoleDto, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ActionRole/UpdateActionRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateActionRole(_response));
        });
    }

    protected processUpdateActionRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(sObj: ActionRoleSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGridDto> {
        let url_ = this.baseUrl + "/api/ActionRole/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfActionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ActionRole/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/ActionRole/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IAgentApi {

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<AgentEditDto>;

    save(dto: AgentEditDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    getAgentSuperiorsData(id?: number | undefined, x_Version?: string | null | undefined): Promise<AgentSuperiorDataDto>;

    export(searchQuery: SearchQueryOfAgentSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse>;

    agentIsLinkedToDossier(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    canSeeAgentInfo(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    baseSearch(searchQuery: SearchQueryOfAgentSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfAgentGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class AgentApi extends BaseAPI implements IAgentApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<AgentEditDto> {
        let url_ = this.baseUrl + "/api/Agent?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<AgentEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentEditDto>(null as any);
    }

    save(dto: AgentEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Agent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Agent/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    getAgentSuperiorsData(id?: number | undefined, x_Version?: string | null | undefined): Promise<AgentSuperiorDataDto> {
        let url_ = this.baseUrl + "/api/Agent/agent-sup-data?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAgentSuperiorsData(_response));
        });
    }

    protected processGetAgentSuperiorsData(response: Response): Promise<AgentSuperiorDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentSuperiorDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentSuperiorDataDto>(null as any);
    }

    export(searchQuery: SearchQueryOfAgentSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Agent/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    agentIsLinkedToDossier(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Agent/agent-is-linked-to-dossier?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAgentIsLinkedToDossier(_response));
        });
    }

    protected processAgentIsLinkedToDossier(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    canSeeAgentInfo(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Agent/can-see-agent-info?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCanSeeAgentInfo(_response));
        });
    }

    protected processCanSeeAgentInfo(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfAgentSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfAgentGridDto> {
        let url_ = this.baseUrl + "/api/Agent/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfAgentGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAgentGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAgentGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Agent/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Agent/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IAgentFunctionApi {

    save(dto: AgentFunctionEditDto, x_Version?: string | null | undefined): Promise<number>;

    delete(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveSpeciality(dto: AgentFunctionSpecialityEditDto, x_Version?: string | null | undefined): Promise<number>;

    getAgentFunctions(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<AgentFunctionsEditDto>;

    saveAgentFunctions(dto: AgentFunctionsEditDto, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfAgentFunctionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfAgentFunctionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class AgentFunctionApi extends BaseAPI implements IAgentFunctionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    save(dto: AgentFunctionEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AgentFunction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AgentFunction?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveSpeciality(dto: AgentFunctionSpecialityEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AgentFunction/save-speciality";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSpeciality(_response));
        });
    }

    protected processSaveSpeciality(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAgentFunctions(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<AgentFunctionsEditDto> {
        let url_ = this.baseUrl + "/api/AgentFunction/get-functions?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAgentFunctions(_response));
        });
    }

    protected processGetAgentFunctions(response: Response): Promise<AgentFunctionsEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentFunctionsEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentFunctionsEditDto>(null as any);
    }

    saveAgentFunctions(dto: AgentFunctionsEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AgentFunction/save-functions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveAgentFunctions(_response));
        });
    }

    protected processSaveAgentFunctions(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfAgentFunctionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfAgentFunctionGridDto> {
        let url_ = this.baseUrl + "/api/AgentFunction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfAgentFunctionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAgentFunctionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAgentFunctionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/AgentFunction/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/AgentFunction/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IAssessementDossierApi {

    searchArchived(searchQuery: SearchQueryOfArchivedDossierCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfArchivedDossierGridDto>;

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<AssessementDossierEditDto>;

    save(dto: AssessementDossierEditDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    updateJobInterviewDate(dto: UpdateJobInterviewDateDto, x_Version?: string | null | undefined): Promise<number>;

    updateOperationalInterviewDate(dto: UpdateOperationalInterviewDateDto, x_Version?: string | null | undefined): Promise<number>;

    getNewCycleNumberByAgent(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    getNewCycleDateByAgent(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<Date>;

    getNewCycleInfoByAgent(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<NewCycleInfoDto>;

    getAgentIdByDossier(id?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    getDossierStatus(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<string>;

    closeCycleAndChangeMention(dto: CloseDossierDto, x_Version?: string | null | undefined): Promise<number>;

    closeCycle(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    putDossierOnHold(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    cancelCycle(dto: CancelDossierDto, x_Version?: string | null | undefined): Promise<number>;

    canSeeDossierInfo(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    isDossierEditable(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    canCreateOperationalInterview(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    isJobInterviewSigned(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    getMostRecentItwDate(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<MostRecentItwDto>;

    export(searchQuery: SearchQueryOfAssessementDossierCriterias, x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfAssessementDossierCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfAssessementDossierGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class AssessementDossierApi extends BaseAPI implements IAssessementDossierApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    searchArchived(searchQuery: SearchQueryOfArchivedDossierCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfArchivedDossierGridDto> {
        let url_ = this.baseUrl + "/api/AssessementDossier/search-archived";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchArchived(_response));
        });
    }

    protected processSearchArchived(response: Response): Promise<PaginatedResultsOfArchivedDossierGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfArchivedDossierGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfArchivedDossierGridDto>(null as any);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<AssessementDossierEditDto> {
        let url_ = this.baseUrl + "/api/AssessementDossier?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<AssessementDossierEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessementDossierEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessementDossierEditDto>(null as any);
    }

    save(dto: AssessementDossierEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessementDossier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/AssessementDossier/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    updateJobInterviewDate(dto: UpdateJobInterviewDateDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessementDossier/update-job-interview-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateJobInterviewDate(_response));
        });
    }

    protected processUpdateJobInterviewDate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateOperationalInterviewDate(dto: UpdateOperationalInterviewDateDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessementDossier/update-operational-interview-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateOperationalInterviewDate(_response));
        });
    }

    protected processUpdateOperationalInterviewDate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getNewCycleNumberByAgent(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessementDossier/new-cycle-number-by-agent?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewCycleNumberByAgent(_response));
        });
    }

    protected processGetNewCycleNumberByAgent(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getNewCycleDateByAgent(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<Date> {
        let url_ = this.baseUrl + "/api/AssessementDossier/new-cycle-date-by-agent?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewCycleDateByAgent(_response));
        });
    }

    protected processGetNewCycleDateByAgent(response: Response): Promise<Date> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date>(null as any);
    }

    getNewCycleInfoByAgent(agentId?: number | undefined, x_Version?: string | null | undefined): Promise<NewCycleInfoDto> {
        let url_ = this.baseUrl + "/api/AssessementDossier/new-cycle-info-by-agent?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewCycleInfoByAgent(_response));
        });
    }

    protected processGetNewCycleInfoByAgent(response: Response): Promise<NewCycleInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewCycleInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewCycleInfoDto>(null as any);
    }

    getAgentIdByDossier(id?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessementDossier/agent-by-dossier?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAgentIdByDossier(_response));
        });
    }

    protected processGetAgentIdByDossier(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDossierStatus(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/AssessementDossier/dossier-status?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDossierStatus(_response));
        });
    }

    protected processGetDossierStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    closeCycleAndChangeMention(dto: CloseDossierDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessementDossier/close-cycle-with-mention";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseCycleAndChangeMention(_response));
        });
    }

    protected processCloseCycleAndChangeMention(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    closeCycle(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessementDossier/close-cycle?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseCycle(_response));
        });
    }

    protected processCloseCycle(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    putDossierOnHold(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessementDossier/put-dossier-on-hold?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPutDossierOnHold(_response));
        });
    }

    protected processPutDossierOnHold(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    cancelCycle(dto: CancelDossierDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessementDossier/cancel-cycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelCycle(_response));
        });
    }

    protected processCancelCycle(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    canSeeDossierInfo(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AssessementDossier/can-see-dossier-info?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCanSeeDossierInfo(_response));
        });
    }

    protected processCanSeeDossierInfo(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isDossierEditable(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AssessementDossier/is-dossier-editable?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDossierEditable(_response));
        });
    }

    protected processIsDossierEditable(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    canCreateOperationalInterview(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AssessementDossier/can-create-operational-interview?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCanCreateOperationalInterview(_response));
        });
    }

    protected processCanCreateOperationalInterview(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isJobInterviewSigned(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AssessementDossier/is-job-interview-signed?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsJobInterviewSigned(_response));
        });
    }

    protected processIsJobInterviewSigned(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getMostRecentItwDate(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<MostRecentItwDto> {
        let url_ = this.baseUrl + "/api/AssessementDossier/get-most-recent-itw-date?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMostRecentItwDate(_response));
        });
    }

    protected processGetMostRecentItwDate(response: Response): Promise<MostRecentItwDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MostRecentItwDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MostRecentItwDto>(null as any);
    }

    export(searchQuery: SearchQueryOfAssessementDossierCriterias, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessementDossier/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfAssessementDossierCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfAssessementDossierGridDto> {
        let url_ = this.baseUrl + "/api/AssessementDossier/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfAssessementDossierGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAssessementDossierGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAssessementDossierGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/AssessementDossier/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/AssessementDossier/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ICancellationReasonApi {

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<CancellationReasonEditDto>;

    save(dto: CancellationReasonEditDto, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfCancellationReasonSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfCancellationReasonGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class CancellationReasonApi extends BaseAPI implements ICancellationReasonApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/CancellationReason/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<CancellationReasonEditDto> {
        let url_ = this.baseUrl + "/api/CancellationReason?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CancellationReasonEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancellationReasonEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancellationReasonEditDto>(null as any);
    }

    save(dto: CancellationReasonEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CancellationReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfCancellationReasonSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfCancellationReasonGridDto> {
        let url_ = this.baseUrl + "/api/CancellationReason/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCancellationReasonGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCancellationReasonGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCancellationReasonGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/CancellationReason/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/CancellationReason/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IDashboardApi {

    export(searchQuery: SearchQueryOfDashboardSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfDashboardSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDashboardGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class DashboardApi extends BaseAPI implements IDashboardApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    export(searchQuery: SearchQueryOfDashboardSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfDashboardSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDashboardGridDto> {
        let url_ = this.baseUrl + "/api/Dashboard/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDashboardGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDashboardGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDashboardGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Dashboard/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Dashboard/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IDataTranslationApi {

    updateTranslation(updateTranslationCommand: UpdateDataTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse>;

    export(x_Version?: string | null | undefined): Promise<FileResponse>;

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result>;

    getImportTemplate(x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfDataTranslationInfoSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDataTranslationGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class DataTranslationApi extends BaseAPI implements IDataTranslationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    updateTranslation(updateTranslationCommand: UpdateDataTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DataTranslation/UpdateTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTranslationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTranslation(_response));
        });
    }

    protected processUpdateTranslation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DataTranslation/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DataTranslation/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getImportTemplate(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DataTranslation/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImportTemplate(_response));
        });
    }

    protected processGetImportTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfDataTranslationInfoSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDataTranslationGridDto> {
        let url_ = this.baseUrl + "/api/DataTranslation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDataTranslationGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDataTranslationGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDataTranslationGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DataTranslation/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/DataTranslation/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IDossierDocumentApi {

    getListByDossier(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<DossierDocumentGridDto[]>;

    uploadFile(file: DocumentDto, dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    downloadFile(relativeUrl?: string | null | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;
}

export class DossierDocumentApi extends BaseAPI implements IDossierDocumentApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getListByDossier(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<DossierDocumentGridDto[]> {
        let url_ = this.baseUrl + "/api/DossierDocument/get-list-by-dossier?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetListByDossier(_response));
        });
    }

    protected processGetListByDossier(response: Response): Promise<DossierDocumentGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DossierDocumentGridDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DossierDocumentGridDto[]>(null as any);
    }

    uploadFile(file: DocumentDto, dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DossierDocument/upload-document?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadFile(relativeUrl?: string | null | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DossierDocument/download-file?";
        if (relativeUrl !== undefined && relativeUrl !== null)
            url_ += "relativeUrl=" + encodeURIComponent("" + relativeUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IDossierTasksApi {

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<DossierTaskEditDto>;

    closeTask(id?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    createDossierTask(dossierId?: number | undefined, eTaskCode?: ETaskCode | undefined, operationalInterviewId?: number | null | undefined, x_Version?: string | null | undefined): Promise<number>;

    signJobInterviewAndCloseTask(id?: number | undefined, sign?: boolean | undefined, x_Version?: string | null | undefined): Promise<number>;

    signAndCloseOperationalInterview(dossierTaskId?: number | undefined, operationalInterviewId?: number | undefined, sign?: boolean | undefined, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfDossierTaskSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDossierTaskGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class DossierTasksApi extends BaseAPI implements IDossierTasksApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<DossierTaskEditDto> {
        let url_ = this.baseUrl + "/api/DossierTasks?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DossierTaskEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DossierTaskEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DossierTaskEditDto>(null as any);
    }

    closeTask(id?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DossierTasks/close-task?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseTask(_response));
        });
    }

    protected processCloseTask(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createDossierTask(dossierId?: number | undefined, eTaskCode?: ETaskCode | undefined, operationalInterviewId?: number | null | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DossierTasks/update-dossier-status?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        if (eTaskCode === null)
            throw new globalThis.Error("The parameter 'eTaskCode' cannot be null.");
        else if (eTaskCode !== undefined)
            url_ += "eTaskCode=" + encodeURIComponent("" + eTaskCode) + "&";
        if (operationalInterviewId !== undefined && operationalInterviewId !== null)
            url_ += "operationalInterviewId=" + encodeURIComponent("" + operationalInterviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDossierTask(_response));
        });
    }

    protected processCreateDossierTask(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    signJobInterviewAndCloseTask(id?: number | undefined, sign?: boolean | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DossierTasks/sign-and-close?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (sign === null)
            throw new globalThis.Error("The parameter 'sign' cannot be null.");
        else if (sign !== undefined)
            url_ += "sign=" + encodeURIComponent("" + sign) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSignJobInterviewAndCloseTask(_response));
        });
    }

    protected processSignJobInterviewAndCloseTask(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    signAndCloseOperationalInterview(dossierTaskId?: number | undefined, operationalInterviewId?: number | undefined, sign?: boolean | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DossierTasks/sign-and-close-operational-interview?";
        if (dossierTaskId === null)
            throw new globalThis.Error("The parameter 'dossierTaskId' cannot be null.");
        else if (dossierTaskId !== undefined)
            url_ += "dossierTaskId=" + encodeURIComponent("" + dossierTaskId) + "&";
        if (operationalInterviewId === null)
            throw new globalThis.Error("The parameter 'operationalInterviewId' cannot be null.");
        else if (operationalInterviewId !== undefined)
            url_ += "operationalInterviewId=" + encodeURIComponent("" + operationalInterviewId) + "&";
        if (sign === null)
            throw new globalThis.Error("The parameter 'sign' cannot be null.");
        else if (sign !== undefined)
            url_ += "sign=" + encodeURIComponent("" + sign) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSignAndCloseOperationalInterview(_response));
        });
    }

    protected processSignAndCloseOperationalInterview(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfDossierTaskSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDossierTaskGridDto> {
        let url_ = this.baseUrl + "/api/DossierTasks/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDossierTaskGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDossierTaskGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDossierTaskGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DossierTasks/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/DossierTasks/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IEvaluationInterviewApi {

    getByDossierId(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<EvaluationInterviewEditDto>;

    save(dto: EvaluationInterviewEditDto, x_Version?: string | null | undefined): Promise<number>;

    createReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, eTaskCode?: ETaskCode | null | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    downloadReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getAnnexeFile(x_Version?: string | null | undefined): Promise<FileResponse>;
}

export class EvaluationInterviewApi extends BaseAPI implements IEvaluationInterviewApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getByDossierId(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<EvaluationInterviewEditDto> {
        let url_ = this.baseUrl + "/api/EvaluationInterview?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDossierId(_response));
        });
    }

    protected processGetByDossierId(response: Response): Promise<EvaluationInterviewEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EvaluationInterviewEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvaluationInterviewEditDto>(null as any);
    }

    save(dto: EvaluationInterviewEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/EvaluationInterview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, eTaskCode?: ETaskCode | null | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EvaluationInterview/create-report?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (empty === null)
            throw new globalThis.Error("The parameter 'empty' cannot be null.");
        else if (empty !== undefined)
            url_ += "empty=" + encodeURIComponent("" + empty) + "&";
        if (asPdf === null)
            throw new globalThis.Error("The parameter 'asPdf' cannot be null.");
        else if (asPdf !== undefined)
            url_ += "asPdf=" + encodeURIComponent("" + asPdf) + "&";
        if (eTaskCode !== undefined && eTaskCode !== null)
            url_ += "eTaskCode=" + encodeURIComponent("" + eTaskCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateReport(_response));
        });
    }

    protected processCreateReport(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    downloadReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/EvaluationInterview/download-report?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (empty === null)
            throw new globalThis.Error("The parameter 'empty' cannot be null.");
        else if (empty !== undefined)
            url_ += "empty=" + encodeURIComponent("" + empty) + "&";
        if (asPdf === null)
            throw new globalThis.Error("The parameter 'asPdf' cannot be null.");
        else if (asPdf !== undefined)
            url_ += "asPdf=" + encodeURIComponent("" + asPdf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadReport(_response));
        });
    }

    protected processDownloadReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAnnexeFile(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/EvaluationInterview/get-annexe-file";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAnnexeFile(_response));
        });
    }

    protected processGetAnnexeFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFormQuestionApi {

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<FormQuestionEditDto>;

    save(dto: FormQuestionEditDto, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfFormQuestionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFormQuestionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class FormQuestionApi extends BaseAPI implements IFormQuestionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/FormQuestion/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<FormQuestionEditDto> {
        let url_ = this.baseUrl + "/api/FormQuestion?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FormQuestionEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormQuestionEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestionEditDto>(null as any);
    }

    save(dto: FormQuestionEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/FormQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfFormQuestionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFormQuestionGridDto> {
        let url_ = this.baseUrl + "/api/FormQuestion/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfFormQuestionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfFormQuestionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfFormQuestionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/FormQuestion/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/FormQuestion/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IFormQuestionOperationalApi {

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<FormQuestionOperationalEditDto>;

    save(dto: FormQuestionOperationalEditDto, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfFormQuestionOperationalSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFormQuestionOperationalGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class FormQuestionOperationalApi extends BaseAPI implements IFormQuestionOperationalApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/FormQuestionOperational/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<FormQuestionOperationalEditDto> {
        let url_ = this.baseUrl + "/api/FormQuestionOperational?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FormQuestionOperationalEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormQuestionOperationalEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestionOperationalEditDto>(null as any);
    }

    save(dto: FormQuestionOperationalEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/FormQuestionOperational";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfFormQuestionOperationalSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFormQuestionOperationalGridDto> {
        let url_ = this.baseUrl + "/api/FormQuestionOperational/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfFormQuestionOperationalGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfFormQuestionOperationalGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfFormQuestionOperationalGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/FormQuestionOperational/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/FormQuestionOperational/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IFunctionalDirectorApi {

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<FunctionalDirectorEditDto>;

    save(dto: FunctionalDirectorEditDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfFunctionalDirectorSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFunctionalDirectorGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class FunctionalDirectorApi extends BaseAPI implements IFunctionalDirectorApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<FunctionalDirectorEditDto> {
        let url_ = this.baseUrl + "/api/FunctionalDirector?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FunctionalDirectorEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FunctionalDirectorEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FunctionalDirectorEditDto>(null as any);
    }

    save(dto: FunctionalDirectorEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/FunctionalDirector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/FunctionalDirector/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfFunctionalDirectorSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFunctionalDirectorGridDto> {
        let url_ = this.baseUrl + "/api/FunctionalDirector/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfFunctionalDirectorGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfFunctionalDirectorGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfFunctionalDirectorGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/FunctionalDirector/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/FunctionalDirector/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IFunctionApi {

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditFunctionDto>;

    save(dto: EditFunctionDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfFunctionSearchCrtieria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFunctionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class FunctionApi extends BaseAPI implements IFunctionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditFunctionDto> {
        let url_ = this.baseUrl + "/api/Function?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<EditFunctionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditFunctionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditFunctionDto>(null as any);
    }

    save(dto: EditFunctionDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Function";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Function/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfFunctionSearchCrtieria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFunctionGridDto> {
        let url_ = this.baseUrl + "/api/Function/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfFunctionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfFunctionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfFunctionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Function/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Function/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IGradeFunctionApi {

    baseSearch(searchQuery: SearchQueryOfGradeFunctionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfGradeFunctionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class GradeFunctionApi extends BaseAPI implements IGradeFunctionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(searchQuery: SearchQueryOfGradeFunctionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfGradeFunctionGridDto> {
        let url_ = this.baseUrl + "/api/GradeFunction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfGradeFunctionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfGradeFunctionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfGradeFunctionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/GradeFunction/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/GradeFunction/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IJobInterviewApi {

    getByDossierId(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<JobInterviewEditDto>;

    save(dto: JobInterviewEditDto, x_Version?: string | null | undefined): Promise<number>;

    saveComment(dto: JobInterviewCommentDto, x_Version?: string | null | undefined): Promise<number>;

    canShowN2Comment(jobInterviewId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    createReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, eTaskCode?: ETaskCode | null | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    downloadReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    downloadPdfReport(id?: number | undefined, empty?: boolean | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getAnnexeFile(x_Version?: string | null | undefined): Promise<FileResponse>;

    getFormationFile(x_Version?: string | null | undefined): Promise<FileResponse>;

    canEditJobInterview(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean>;
}

export class JobInterviewApi extends BaseAPI implements IJobInterviewApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getByDossierId(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<JobInterviewEditDto> {
        let url_ = this.baseUrl + "/api/JobInterview?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDossierId(_response));
        });
    }

    protected processGetByDossierId(response: Response): Promise<JobInterviewEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobInterviewEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobInterviewEditDto>(null as any);
    }

    save(dto: JobInterviewEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/JobInterview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveComment(dto: JobInterviewCommentDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/JobInterview/save-comment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveComment(_response));
        });
    }

    protected processSaveComment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    canShowN2Comment(jobInterviewId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/JobInterview/can-show-comment?";
        if (jobInterviewId === null)
            throw new globalThis.Error("The parameter 'jobInterviewId' cannot be null.");
        else if (jobInterviewId !== undefined)
            url_ += "jobInterviewId=" + encodeURIComponent("" + jobInterviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCanShowN2Comment(_response));
        });
    }

    protected processCanShowN2Comment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, eTaskCode?: ETaskCode | null | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/JobInterview/create-report?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (empty === null)
            throw new globalThis.Error("The parameter 'empty' cannot be null.");
        else if (empty !== undefined)
            url_ += "empty=" + encodeURIComponent("" + empty) + "&";
        if (asPdf === null)
            throw new globalThis.Error("The parameter 'asPdf' cannot be null.");
        else if (asPdf !== undefined)
            url_ += "asPdf=" + encodeURIComponent("" + asPdf) + "&";
        if (eTaskCode !== undefined && eTaskCode !== null)
            url_ += "eTaskCode=" + encodeURIComponent("" + eTaskCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateReport(_response));
        });
    }

    protected processCreateReport(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    downloadReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/JobInterview/download-report?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (empty === null)
            throw new globalThis.Error("The parameter 'empty' cannot be null.");
        else if (empty !== undefined)
            url_ += "empty=" + encodeURIComponent("" + empty) + "&";
        if (asPdf === null)
            throw new globalThis.Error("The parameter 'asPdf' cannot be null.");
        else if (asPdf !== undefined)
            url_ += "asPdf=" + encodeURIComponent("" + asPdf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadReport(_response));
        });
    }

    protected processDownloadReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadPdfReport(id?: number | undefined, empty?: boolean | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/JobInterview/download-pdf-report?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (empty === null)
            throw new globalThis.Error("The parameter 'empty' cannot be null.");
        else if (empty !== undefined)
            url_ += "empty=" + encodeURIComponent("" + empty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadPdfReport(_response));
        });
    }

    protected processDownloadPdfReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAnnexeFile(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/JobInterview/get-annexe-file";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAnnexeFile(_response));
        });
    }

    protected processGetAnnexeFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFormationFile(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/JobInterview/get-formation-file";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormationFile(_response));
        });
    }

    protected processGetFormationFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    canEditJobInterview(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/JobInterview/can-edit-job-interview?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCanEditJobInterview(_response));
        });
    }

    protected processCanEditJobInterview(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IJobInterviewDateApi {

    baseSearch(searchQuery: SearchQueryOfJobInterviewDateSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfJobInterviewDateGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class JobInterviewDateApi extends BaseAPI implements IJobInterviewDateApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(searchQuery: SearchQueryOfJobInterviewDateSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfJobInterviewDateGridDto> {
        let url_ = this.baseUrl + "/api/JobInterviewDate/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfJobInterviewDateGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJobInterviewDateGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJobInterviewDateGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/JobInterviewDate/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/JobInterviewDate/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IJobInterviewFormQuestionApi {

    save(dto: JobInterviewFormQuestionGridDto, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfJobInterviewFormQuestionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfJobInterviewFormQuestionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class JobInterviewFormQuestionApi extends BaseAPI implements IJobInterviewFormQuestionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    save(dto: JobInterviewFormQuestionGridDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/JobInterviewFormQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfJobInterviewFormQuestionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfJobInterviewFormQuestionGridDto> {
        let url_ = this.baseUrl + "/api/JobInterviewFormQuestion/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfJobInterviewFormQuestionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJobInterviewFormQuestionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJobInterviewFormQuestionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/JobInterviewFormQuestion/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/JobInterviewFormQuestion/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ILanguageApi {

    getLanguages(x_Version?: string | null | undefined): Promise<LanguageDto[]>;
}

export class LanguageApi extends BaseAPI implements ILanguageApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getLanguages(x_Version?: string | null | undefined): Promise<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/Language";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLanguages(_response));
        });
    }

    protected processGetLanguages(response: Response): Promise<LanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto[]>(null as any);
    }
}

export interface IMentionApi {

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<MentionEditDto>;

    save(dto: MentionEditDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfMentionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMentionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class MentionApi extends BaseAPI implements IMentionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<MentionEditDto> {
        let url_ = this.baseUrl + "/api/Mention?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<MentionEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MentionEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MentionEditDto>(null as any);
    }

    save(dto: MentionEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Mention";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Mention/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfMentionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMentionGridDto> {
        let url_ = this.baseUrl + "/api/Mention/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMentionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMentionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMentionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Mention/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Mention/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IObjectiveQuestionApi {

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<ObjectiveQuestionEditDto>;

    save(dto: ObjectiveQuestionEditDto, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfObjectiveQuestionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfObjectiveQuestionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ObjectiveQuestionApi extends BaseAPI implements IObjectiveQuestionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/ObjectiveQuestion/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<ObjectiveQuestionEditDto> {
        let url_ = this.baseUrl + "/api/ObjectiveQuestion?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ObjectiveQuestionEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectiveQuestionEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ObjectiveQuestionEditDto>(null as any);
    }

    save(dto: ObjectiveQuestionEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ObjectiveQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfObjectiveQuestionSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfObjectiveQuestionGridDto> {
        let url_ = this.baseUrl + "/api/ObjectiveQuestion/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfObjectiveQuestionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfObjectiveQuestionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfObjectiveQuestionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ObjectiveQuestion/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/ObjectiveQuestion/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IOperationalInterviewApi {

    get(operationalInterviewId?: number | undefined, dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<OperationalInterviewEditDto>;

    save(dto: OperationalInterviewEditDto, x_Version?: string | null | undefined): Promise<number>;

    createReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, eTaskCode?: ETaskCode | null | undefined, x_Version?: string | null | undefined): Promise<string | null>;

    downloadReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfOperationalInterviewSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfOperationalInterviewGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class OperationalInterviewApi extends BaseAPI implements IOperationalInterviewApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(operationalInterviewId?: number | undefined, dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<OperationalInterviewEditDto> {
        let url_ = this.baseUrl + "/api/OperationalInterview?";
        if (operationalInterviewId === null)
            throw new globalThis.Error("The parameter 'operationalInterviewId' cannot be null.");
        else if (operationalInterviewId !== undefined)
            url_ += "operationalInterviewId=" + encodeURIComponent("" + operationalInterviewId) + "&";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<OperationalInterviewEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalInterviewEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperationalInterviewEditDto>(null as any);
    }

    save(dto: OperationalInterviewEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/OperationalInterview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, eTaskCode?: ETaskCode | null | undefined, x_Version?: string | null | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/OperationalInterview/create-report?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (empty === null)
            throw new globalThis.Error("The parameter 'empty' cannot be null.");
        else if (empty !== undefined)
            url_ += "empty=" + encodeURIComponent("" + empty) + "&";
        if (asPdf === null)
            throw new globalThis.Error("The parameter 'asPdf' cannot be null.");
        else if (asPdf !== undefined)
            url_ += "asPdf=" + encodeURIComponent("" + asPdf) + "&";
        if (eTaskCode !== undefined && eTaskCode !== null)
            url_ += "eTaskCode=" + encodeURIComponent("" + eTaskCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateReport(_response));
        });
    }

    protected processCreateReport(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    downloadReport(id?: number | undefined, empty?: boolean | undefined, asPdf?: boolean | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/OperationalInterview/download-report?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (empty === null)
            throw new globalThis.Error("The parameter 'empty' cannot be null.");
        else if (empty !== undefined)
            url_ += "empty=" + encodeURIComponent("" + empty) + "&";
        if (asPdf === null)
            throw new globalThis.Error("The parameter 'asPdf' cannot be null.");
        else if (asPdf !== undefined)
            url_ += "asPdf=" + encodeURIComponent("" + asPdf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadReport(_response));
        });
    }

    protected processDownloadReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfOperationalInterviewSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfOperationalInterviewGridDto> {
        let url_ = this.baseUrl + "/api/OperationalInterview/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfOperationalInterviewGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfOperationalInterviewGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfOperationalInterviewGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/OperationalInterview/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/OperationalInterview/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IOperationalInterviewDateApi {

    baseSearch(searchQuery: SearchQueryOfOperationalInterviewDateSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfOperationalInterviewDateGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class OperationalInterviewDateApi extends BaseAPI implements IOperationalInterviewDateApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(searchQuery: SearchQueryOfOperationalInterviewDateSearchCriterias, x_Version?: string | null | undefined): Promise<PaginatedResultsOfOperationalInterviewDateGridDto> {
        let url_ = this.baseUrl + "/api/OperationalInterviewDate/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfOperationalInterviewDateGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfOperationalInterviewDateGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfOperationalInterviewDateGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/OperationalInterviewDate/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/OperationalInterviewDate/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IReferentialApi {

    actions(alreadyUsedActionIds: number[], x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    languages(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    roles(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    grades(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    cadres(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    functions(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    gradeStatuses(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    agents(exceptAgentDossierId?: number | null | undefined, exceptAgentId?: number | null | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    genders(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    mentions(activeOnly?: boolean | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    gradeSubStatuses(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    functionalDirectors(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    formTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    agentByDossier(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    levels(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    evaluations(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    cancellationReasons(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    cycleTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    positions(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ReferentialApi extends BaseAPI implements IReferentialApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    actions(alreadyUsedActionIds: number[], x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alreadyUsedActionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActions(_response));
        });
    }

    protected processActions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    languages(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLanguages(_response));
        });
    }

    protected processLanguages(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    roles(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles(_response));
        });
    }

    protected processRoles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    grades(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/grades";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGrades(_response));
        });
    }

    protected processGrades(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    cadres(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/cadres";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCadres(_response));
        });
    }

    protected processCadres(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    functions(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/functions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFunctions(_response));
        });
    }

    protected processFunctions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    gradeStatuses(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/grades-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGradeStatuses(_response));
        });
    }

    protected processGradeStatuses(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    agents(exceptAgentDossierId?: number | null | undefined, exceptAgentId?: number | null | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/agents?";
        if (exceptAgentDossierId !== undefined && exceptAgentDossierId !== null)
            url_ += "exceptAgentDossierId=" + encodeURIComponent("" + exceptAgentDossierId) + "&";
        if (exceptAgentId !== undefined && exceptAgentId !== null)
            url_ += "exceptAgentId=" + encodeURIComponent("" + exceptAgentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAgents(_response));
        });
    }

    protected processAgents(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    genders(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/genders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenders(_response));
        });
    }

    protected processGenders(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    mentions(activeOnly?: boolean | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/mentions?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMentions(_response));
        });
    }

    protected processMentions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    gradeSubStatuses(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/grades-sub-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGradeSubStatuses(_response));
        });
    }

    protected processGradeSubStatuses(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    functionalDirectors(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/functional-director";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFunctionalDirectors(_response));
        });
    }

    protected processFunctionalDirectors(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    formTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/form-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFormTypes(_response));
        });
    }

    protected processFormTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    agentByDossier(dossierId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/agent-by-dossier?";
        if (dossierId === null)
            throw new globalThis.Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAgentByDossier(_response));
        });
    }

    protected processAgentByDossier(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    levels(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/levels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLevels(_response));
        });
    }

    protected processLevels(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    evaluations(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/evaluations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEvaluations(_response));
        });
    }

    protected processEvaluations(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    cancellationReasons(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/cancellation-reason";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancellationReasons(_response));
        });
    }

    protected processCancellationReasons(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    cycleTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/cycle-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCycleTypes(_response));
        });
    }

    protected processCycleTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    positions(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/position";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPositions(_response));
        });
    }

    protected processPositions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISearchCriteriaApi {

    getSearchCriteriaById(id: number, x_Version?: string | null | undefined): Promise<EditSearchCriteriaDto>;

    getSearchCriterias(userId?: number | null | undefined, x_Version?: string | null | undefined): Promise<EditSearchCriteriaDto[]>;

    saveSearchCriteria(dto: EditSearchCriteriaDto, x_Version?: string | null | undefined): Promise<number>;

    deleteSearchCriteria(name: string, x_Version?: string | null | undefined): Promise<FileResponse>;
}

export class SearchCriteriaApi extends BaseAPI implements ISearchCriteriaApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getSearchCriteriaById(id: number, x_Version?: string | null | undefined): Promise<EditSearchCriteriaDto> {
        let url_ = this.baseUrl + "/api/SearchCriteria/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriteriaById(_response));
        });
    }

    protected processGetSearchCriteriaById(response: Response): Promise<EditSearchCriteriaDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditSearchCriteriaDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSearchCriteriaDto>(null as any);
    }

    getSearchCriterias(userId?: number | null | undefined, x_Version?: string | null | undefined): Promise<EditSearchCriteriaDto[]> {
        let url_ = this.baseUrl + "/api/SearchCriteria?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<EditSearchCriteriaDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EditSearchCriteriaDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSearchCriteriaDto[]>(null as any);
    }

    saveSearchCriteria(dto: EditSearchCriteriaDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/SearchCriteria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSearchCriteria(_response));
        });
    }

    protected processSaveSearchCriteria(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteSearchCriteria(name: string, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SearchCriteria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(name);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSearchCriteria(_response));
        });
    }

    protected processDeleteSearchCriteria(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISubstitutionApi {

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<SubstitutionEditDto>;

    save(dto: SubstitutionEditDto, x_Version?: string | null | undefined): Promise<number>;

    deleteSubstitution(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfSubstitutionSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSubstitutionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class SubstitutionApi extends BaseAPI implements ISubstitutionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<SubstitutionEditDto> {
        let url_ = this.baseUrl + "/api/Substitution?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SubstitutionEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubstitutionEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubstitutionEditDto>(null as any);
    }

    save(dto: SubstitutionEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Substitution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteSubstitution(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Substitution?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSubstitution(_response));
        });
    }

    protected processDeleteSubstitution(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Substitution/display-name?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfSubstitutionSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSubstitutionGridDto> {
        let url_ = this.baseUrl + "/api/Substitution/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSubstitutionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSubstitutionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSubstitutionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Substitution/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Substitution/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISystemApi {

    get(x_Version?: string | null | undefined): Promise<SystemInfoDto>;

    getExposedTypes(x_Version?: string | null | undefined): Promise<ExposedTypes>;

    geFrontendSettings(x_Version?: string | null | undefined): Promise<FrontendSettings>;
}

export class SystemApi extends BaseAPI implements ISystemApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(x_Version?: string | null | undefined): Promise<SystemInfoDto> {
        let url_ = this.baseUrl + "/api/System";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SystemInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemInfoDto>(null as any);
    }

    getExposedTypes(x_Version?: string | null | undefined): Promise<ExposedTypes> {
        let url_ = this.baseUrl + "/api/System/exposed-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExposedTypes(_response));
        });
    }

    protected processGetExposedTypes(response: Response): Promise<ExposedTypes> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExposedTypes.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExposedTypes>(null as any);
    }

    geFrontendSettings(x_Version?: string | null | undefined): Promise<FrontendSettings> {
        let url_ = this.baseUrl + "/api/System/fe-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeFrontendSettings(_response));
        });
    }

    protected processGeFrontendSettings(response: Response): Promise<FrontendSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrontendSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrontendSettings>(null as any);
    }
}

export interface ITranslationCodeApi {

    baseSearch(searchQuery: SearchQueryOfTranslationCodeSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationCodeDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class TranslationCodeApi extends BaseAPI implements ITranslationCodeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(searchQuery: SearchQueryOfTranslationCodeSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationCodeDto> {
        let url_ = this.baseUrl + "/api/TranslationCode/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTranslationCodeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTranslationCodeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTranslationCodeDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/TranslationCode/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/TranslationCode/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ITranslationApi {

    getTranslationsGET(languageCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<TranslationDto[]>;

    getTranslationsPOST(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<TranslationDto[]>;

    saveTranslation(languageCode: string, dto: SaveTranslationDto, x_Version?: string | null | undefined): Promise<void>;

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse>;

    export(x_Version?: string | null | undefined): Promise<FileResponse>;

    deleteTranslationCode(translationCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result>;

    baseSearch(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class TranslationApi extends BaseAPI implements ITranslationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getTranslationsGET(languageCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<TranslationDto[]> {
        let url_ = this.baseUrl + "/api/Translation?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslationsGET(_response));
        });
    }

    protected processGetTranslationsGET(response: Response): Promise<TranslationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TranslationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationDto[]>(null as any);
    }

    getTranslationsPOST(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<TranslationDto[]> {
        let url_ = this.baseUrl + "/api/Translation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslationsPOST(_response));
        });
    }

    protected processGetTranslationsPOST(response: Response): Promise<TranslationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TranslationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationDto[]>(null as any);
    }

    saveTranslation(languageCode: string, dto: SaveTranslationDto, x_Version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Translation/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new globalThis.Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveTranslation(_response));
        });
    }

    protected processSaveTranslation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Translation/UpdateTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTranslationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTranslation(_response));
        });
    }

    protected processUpdateTranslation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Translation/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTranslationCode(translationCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Translation/DeleteCode?";
        if (translationCode !== undefined && translationCode !== null)
            url_ += "translationCode=" + encodeURIComponent("" + translationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTranslationCode(_response));
        });
    }

    protected processDeleteTranslationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Translation/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationDto> {
        let url_ = this.baseUrl + "/api/Translation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTranslationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTranslationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTranslationDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Translation/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Translation/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IUserActionApi {

    baseSearch(sObj: UserActionSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserActionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class UserActionApi extends BaseAPI implements IUserActionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: UserActionSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserActionGridDto> {
        let url_ = this.baseUrl + "/api/UserAction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfUserActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserActionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/UserAction/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/UserAction/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IUserApi {

    getUser(id: number, x_Version?: string | null | undefined): Promise<EditUserDto>;

    deleteUser(id: number, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveUser(dto: EditUserDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id: number, x_Version?: string | null | undefined): Promise<string>;

    profile(x_Version?: string | null | undefined): Promise<UserProfileDto>;

    exportUserList(searchQuery: SearchQueryOfUserSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfUserSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class UserApi extends BaseAPI implements IUserApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUser(id: number, x_Version?: string | null | undefined): Promise<EditUserDto> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUser(_response));
        });
    }

    protected processGetUser(response: Response): Promise<EditUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditUserDto>(null as any);
    }

    deleteUser(id: number, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteUser(_response));
        });
    }

    protected processDeleteUser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveUser(dto: EditUserDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveUser(_response));
        });
    }

    protected processSaveUser(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id: number, x_Version?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/User/display-name/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    profile(x_Version?: string | null | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/User/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProfile(_response));
        });
    }

    protected processProfile(response: Response): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    exportUserList(searchQuery: SearchQueryOfUserSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/export-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportUserList(_response));
        });
    }

    protected processExportUserList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfUserSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserGridDto> {
        let url_ = this.baseUrl + "/api/User/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfUserGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/User/criterias?";
        if (includeListsValues === null)
            throw new globalThis.Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/User/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new globalThis.Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IHealthCheckApi {

    getHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;

    getStartupHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;

    getReadyHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;

    getLiveHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;
}

export class HealthCheckApi extends BaseAPI implements IHealthCheckApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthCheck(_response));
        });
    }

    protected processGetHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getStartupHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/startup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStartupHealthCheck(_response));
        });
    }

    protected processGetStartupHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getReadyHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/ready";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReadyHealthCheck(_response));
        });
    }

    protected processGetReadyHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getLiveHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLiveHealthCheck(_response));
        });
    }

    protected processGetLiveHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }
}

export interface IApiKeyApi {

    getApiKey(clientName?: string | null | undefined, x_Version?: string | null | undefined): Promise<ClientApiKey>;
}

export class ApiKeyApi extends BaseAPI implements IApiKeyApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getApiKey(clientName?: string | null | undefined, x_Version?: string | null | undefined): Promise<ClientApiKey> {
        let url_ = this.baseUrl + "/apikey?";
        if (clientName !== undefined && clientName !== null)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApiKey(_response));
        });
    }

    protected processGetApiKey(response: Response): Promise<ClientApiKey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientApiKey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientApiKey>(null as any);
    }
}

export class EditActionGroupDto implements IEditActionGroupDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    parentActionGroupId?: number | undefined;

    constructor(data?: IEditActionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
            this.parentActionGroupId = _data["parentActionGroupId"];
        }
    }

    static fromJS(data: any): EditActionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditActionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["parentActionGroupId"] = this.parentActionGroupId;
        return data;
    }

    clone(): EditActionGroupDto {
        const json = this.toJSON();
        let result = new EditActionGroupDto();
        result.init(json);
        return result;
    }
}

export interface IEditActionGroupDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    parentActionGroupId?: number | undefined;
}

export class EntityDto implements IEntityDto {
    id?: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): EntityDto {
        const json = this.toJSON();
        let result = new EntityDto();
        result.init(json);
        return result;
    }
}

export interface IEntityDto {
    id?: number;
}

export class DataTranslationDto extends EntityDto implements IDataTranslationDto {
    dataTranslationValues?: DataTranslationValueDto[] | undefined;

    constructor(data?: IDataTranslationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dataTranslationValues"])) {
                this.dataTranslationValues = [] as any;
                for (let item of _data["dataTranslationValues"])
                    this.dataTranslationValues!.push(DataTranslationValueDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DataTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataTranslationValues)) {
            data["dataTranslationValues"] = [];
            for (let item of this.dataTranslationValues)
                data["dataTranslationValues"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationDto {
        const json = this.toJSON();
        let result = new DataTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationDto extends IEntityDto {
    dataTranslationValues?: DataTranslationValueDto[] | undefined;
}

export class DataTranslationValueDto extends EntityDto implements IDataTranslationValueDto {
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;

    constructor(data?: IDataTranslationValueDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
        }
    }

    static override fromJS(data: any): DataTranslationValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationValueDto {
        const json = this.toJSON();
        let result = new DataTranslationValueDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationValueDto extends IEntityDto {
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;
}

export class ActionGroupTreeItem implements IActionGroupTreeItem {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    children?: ActionGroupTreeItem[] | undefined;

    constructor(data?: IActionGroupTreeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ActionGroupTreeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionGroupTreeItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGroupTreeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionGroupTreeItem {
        const json = this.toJSON();
        let result = new ActionGroupTreeItem();
        result.init(json);
        return result;
    }
}

export interface IActionGroupTreeItem {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    children?: ActionGroupTreeItem[] | undefined;
}

export class PaginatedResultsOfActionGroupGridDto implements IPaginatedResultsOfActionGroupGridDto {
    totalCount?: number;
    results?: ActionGroupGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfActionGroupGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActionGroupGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfActionGroupGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfActionGroupGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfActionGroupGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfActionGroupGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfActionGroupGridDto {
    totalCount?: number;
    results?: ActionGroupGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ActionGroupGridDto implements IActionGroupGridDto {

    constructor(data?: IActionGroupGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ActionGroupGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGroupGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ActionGroupGridDto {
        const json = this.toJSON();
        let result = new ActionGroupGridDto();
        result.init(json);
        return result;
    }
}

export interface IActionGroupGridDto {
}

export class AggregateResult implements IAggregateResult {
    valueDouble?: number | undefined;
    valueDec?: number | undefined;
    valueFloat?: number | undefined;
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;

    constructor(data?: IAggregateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueDouble = _data["valueDouble"];
            this.valueDec = _data["valueDec"];
            this.valueFloat = _data["valueFloat"];
            this.key = _data["key"];
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AggregateResult {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueDouble"] = this.valueDouble;
        data["valueDec"] = this.valueDec;
        data["valueFloat"] = this.valueFloat;
        data["key"] = this.key;
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): AggregateResult {
        const json = this.toJSON();
        let result = new AggregateResult();
        result.init(json);
        return result;
    }
}

export interface IAggregateResult {
    valueDouble?: number | undefined;
    valueDec?: number | undefined;
    valueFloat?: number | undefined;
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;
}

export class FilterSearch implements IFilterSearch {
    filter?: string | undefined;

    constructor(data?: IFilterSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FilterSearch {
        data = typeof data === 'object' ? data : {};
        let result = new FilterSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }

    clone(): FilterSearch {
        const json = this.toJSON();
        let result = new FilterSearch();
        result.init(json);
        return result;
    }
}

export interface IFilterSearch {
    filter?: string | undefined;
}

export class PaginatedSearch extends FilterSearch implements IPaginatedSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: any | undefined;

    constructor(data?: IPaginatedSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortKey"])) {
                this.sortKey = [] as any;
                for (let item of _data["sortKey"])
                    this.sortKey!.push(item);
            }
            if (Array.isArray(_data["aggregateKeys"])) {
                this.aggregateKeys = [] as any;
                for (let item of _data["aggregateKeys"])
                    this.aggregateKeys!.push(AggregateKeyInfo.fromJS(item));
            }
            this.forceSkip = _data["forceSkip"];
            this.forceTake = _data["forceTake"];
            this.parameters = _data["parameters"];
        }
    }

    static override fromJS(data: any): PaginatedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortKey)) {
            data["sortKey"] = [];
            for (let item of this.sortKey)
                data["sortKey"].push(item);
        }
        if (Array.isArray(this.aggregateKeys)) {
            data["aggregateKeys"] = [];
            for (let item of this.aggregateKeys)
                data["aggregateKeys"].push(item ? item.toJSON() : undefined as any);
        }
        data["forceSkip"] = this.forceSkip;
        data["forceTake"] = this.forceTake;
        data["parameters"] = this.parameters;
        super.toJSON(data);
        return data;
    }

    clone(): PaginatedSearch {
        const json = this.toJSON();
        let result = new PaginatedSearch();
        result.init(json);
        return result;
    }
}

export interface IPaginatedSearch extends IFilterSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: any | undefined;
}

export class ActionGroupSearchDto extends PaginatedSearch implements IActionGroupSearchDto {

    constructor(data?: IActionGroupSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ActionGroupSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGroupSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ActionGroupSearchDto {
        const json = this.toJSON();
        let result = new ActionGroupSearchDto();
        result.init(json);
        return result;
    }
}

export interface IActionGroupSearchDto extends IPaginatedSearch {
}

export class AggregateKeyInfo implements IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;

    constructor(data?: IAggregateKeyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.aggregateType = _data["aggregateType"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AggregateKeyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateKeyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["aggregateType"] = this.aggregateType;
        data["text"] = this.text;
        return data;
    }

    clone(): AggregateKeyInfo {
        const json = this.toJSON();
        let result = new AggregateKeyInfo();
        result.init(json);
        return result;
    }
}

export interface IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;
}

export enum EAggregateType {
    Sum = "Sum",
    Avg = "Avg",
    Min = "Min",
    Max = "Max",
}

export class FilterCriteriaInfo implements IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;

    constructor(data?: IFilterCriteriaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criteria = _data["criteria"];
            this.type = _data["type"];
            if (Array.isArray(_data["searchModes"])) {
                this.searchModes = [] as any;
                for (let item of _data["searchModes"])
                    this.searchModes!.push(item);
            }
            this.defaultSearchMode = _data["defaultSearchMode"];
            if (Array.isArray(_data["listValues"])) {
                this.listValues = [] as any;
                for (let item of _data["listValues"])
                    this.listValues!.push(SelectItem.fromJS(item));
            }
            this.isMultipleOr = _data["isMultipleOr"];
        }
    }

    static fromJS(data: any): FilterCriteriaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCriteriaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria;
        data["type"] = this.type;
        if (Array.isArray(this.searchModes)) {
            data["searchModes"] = [];
            for (let item of this.searchModes)
                data["searchModes"].push(item);
        }
        data["defaultSearchMode"] = this.defaultSearchMode;
        if (Array.isArray(this.listValues)) {
            data["listValues"] = [];
            for (let item of this.listValues)
                data["listValues"].push(item ? item.toJSON() : undefined as any);
        }
        data["isMultipleOr"] = this.isMultipleOr;
        return data;
    }

    clone(): FilterCriteriaInfo {
        const json = this.toJSON();
        let result = new FilterCriteriaInfo();
        result.init(json);
        return result;
    }
}

export interface IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;
}

export enum ECriteriaType {
    Text = "Text",
    List = "List",
    Date = "Date",
    Boolean = "Boolean",
    Numeric = "Numeric",
    Float = "Float",
}

export abstract class ValueObject implements IValueObject {

    constructor(data?: IValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ValueObject {
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }
}

export interface IValueObject {
}

export class SelectItem extends ValueObject implements ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;

    constructor(data?: ISelectItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idValue = _data["idValue"];
            this.displayValue = _data["displayValue"];
        }
    }

    static override fromJS(data: any): SelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idValue"] = this.idValue;
        data["displayValue"] = this.displayValue;
        super.toJSON(data);
        return data;
    }

    clone(): SelectItem {
        const json = this.toJSON();
        let result = new SelectItem();
        result.init(json);
        return result;
    }
}

export interface ISelectItem extends IValueObject {
    idValue?: string | undefined;
    displayValue?: string | undefined;
}

export class ReferentialItemDto extends SelectItem implements IReferentialItemDto {
    keyValue?: string | undefined;
    additionalDisplayValue?: string | undefined;

    constructor(data?: IReferentialItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keyValue = _data["keyValue"];
            this.additionalDisplayValue = _data["additionalDisplayValue"];
        }
    }

    static override fromJS(data: any): ReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentialItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyValue"] = this.keyValue;
        data["additionalDisplayValue"] = this.additionalDisplayValue;
        super.toJSON(data);
        return data;
    }

    clone(): ReferentialItemDto {
        const json = this.toJSON();
        let result = new ReferentialItemDto();
        result.init(json);
        return result;
    }
}

export interface IReferentialItemDto extends ISelectItem {
    keyValue?: string | undefined;
    additionalDisplayValue?: string | undefined;
}

export class EditActionDto implements IEditActionDto {
    id?: number;
    code?: ActionCode;
    name?: string | undefined;
    actionGroupId?: number | undefined;

    constructor(data?: IEditActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.actionGroupId = _data["actionGroupId"];
        }
    }

    static fromJS(data: any): EditActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["actionGroupId"] = this.actionGroupId;
        return data;
    }

    clone(): EditActionDto {
        const json = this.toJSON();
        let result = new EditActionDto();
        result.init(json);
        return result;
    }
}

export interface IEditActionDto {
    id?: number;
    code?: ActionCode;
    name?: string | undefined;
    actionGroupId?: number | undefined;
}

export enum ActionCode {
    ManageJobs = "ManageJobs",
    ViewActionGroup = "ViewActionGroup",
    EditActionGroup = "EditActionGroup",
    ViewRoles = "ViewRoles",
    EditRoles = "EditRoles",
    EditDataTranslations = "EditDataTranslations",
    ViewCriterias = "ViewCriterias",
    EditCriterias = "EditCriterias",
    EditTranslations = "EditTranslations",
    ViewUserActions = "ViewUserActions",
    EditUserActions = "EditUserActions",
    ViewUser = "ViewUser",
    EditUser = "EditUser",
    ExportUsers = "ExportUsers",
    EditAgent = "EditAgent",
    ViewAgent = "ViewAgent",
    ViewAgentFunctions = "ViewAgentFunctions",
    ViewGradeFunctions = "ViewGradeFunctions",
    EditGradeFunctions = "EditGradeFunctions",
    EditAgentFunction = "EditAgentFunction",
    DeleteAgentFunction = "DeleteAgentFunction",
    ViewDossier = "ViewDossier",
    EditDossier = "EditDossier",
    ViewJobInterviewDateHistory = "ViewJobInterviewDateHistory",
    ViewOperationalInterviewDateHistory = "ViewOperationalInterviewDateHistory",
    ViewMention = "ViewMention",
    EditMention = "EditMention",
    ViewFormQuestion = "ViewFormQuestion",
    EditFormQuestion = "EditFormQuestion",
    EditJobInterviewFormQuestion = "EditJobInterviewFormQuestion",
    ViewJobInterview = "ViewJobInterview",
    EditJobInterview = "EditJobInterview",
    ExportAgents = "ExportAgents",
    ViewOperationalInterview = "ViewOperationalInterview",
    EditOperationalInterview = "EditOperationalInterview",
    SignInterview = "SignInterview",
    ViewDashboard = "ViewDashboard",
    ViewFunction = "ViewFunction",
    EditFunction = "EditFunction",
    EditFunctionalDirector = "EditFunctionalDirector",
    ViewFunctionalDirector = "ViewFunctionalDirector",
    ViewSubstitution = "ViewSubstitution",
    EditSubstitution = "EditSubstitution",
    ViewObjectiveQuestion = "ViewObjectiveQuestion",
    EditObjectiveQuestion = "EditObjectiveQuestion",
    UploadFunctionFile = "UploadFunctionFile",
    ViewDossierDocument = "ViewDossierDocument",
    UploadDossierDocument = "UploadDossierDocument",
    DownloadDossierFile = "DownloadDossierFile",
    ViewEvaluationInterview = "ViewEvaluationInterview",
    EditEvaluationInterview = "EditEvaluationInterview",
    CloseCycle = "CloseCycle",
    ExportDossiers = "ExportDossiers",
    CancelCycle = "CancelCycle",
    ViewCancellationReason = "ViewCancellationReason",
    EditCancellationReason = "EditCancellationReason",
}

export class UpdateActionRoleDto implements IUpdateActionRoleDto {
    roleId?: number;
    actionId?: number;
    isActive?: boolean;

    constructor(data?: IUpdateActionRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.actionId = _data["actionId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateActionRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActionRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["actionId"] = this.actionId;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateActionRoleDto {
        const json = this.toJSON();
        let result = new UpdateActionRoleDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateActionRoleDto {
    roleId?: number;
    actionId?: number;
    isActive?: boolean;
}

export class PaginatedResultsOfActionGridDto implements IPaginatedResultsOfActionGridDto {
    totalCount?: number;
    results?: ActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfActionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfActionGridDto {
    totalCount?: number;
    results?: ActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ActionGridDto implements IActionGridDto {
    id?: number;
    actionName?: string | undefined;
    code?: ActionCode;
    actionGroup?: string | undefined;
    actionRoles?: ActionRoleDto[] | undefined;
    dataTranslation?: DataTranslationDto | undefined;

    constructor(data?: IActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionName = _data["actionName"];
            this.code = _data["code"];
            this.actionGroup = _data["actionGroup"];
            if (Array.isArray(_data["actionRoles"])) {
                this.actionRoles = [] as any;
                for (let item of _data["actionRoles"])
                    this.actionRoles!.push(ActionRoleDto.fromJS(item));
            }
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionName"] = this.actionName;
        data["code"] = this.code;
        data["actionGroup"] = this.actionGroup;
        if (Array.isArray(this.actionRoles)) {
            data["actionRoles"] = [];
            for (let item of this.actionRoles)
                data["actionRoles"].push(item ? item.toJSON() : undefined as any);
        }
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionGridDto {
        const json = this.toJSON();
        let result = new ActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IActionGridDto {
    id?: number;
    actionName?: string | undefined;
    code?: ActionCode;
    actionGroup?: string | undefined;
    actionRoles?: ActionRoleDto[] | undefined;
    dataTranslation?: DataTranslationDto | undefined;
}

export class ActionRoleDto implements IActionRoleDto {
    id?: number;
    roleName?: string | undefined;
    actionId?: number;
    roleId?: number;
    code?: UserRoles;
    actionCode?: ActionCode;

    constructor(data?: IActionRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleName = _data["roleName"];
            this.actionId = _data["actionId"];
            this.roleId = _data["roleId"];
            this.code = _data["code"];
            this.actionCode = _data["actionCode"];
        }
    }

    static fromJS(data: any): ActionRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleName"] = this.roleName;
        data["actionId"] = this.actionId;
        data["roleId"] = this.roleId;
        data["code"] = this.code;
        data["actionCode"] = this.actionCode;
        return data;
    }

    clone(): ActionRoleDto {
        const json = this.toJSON();
        let result = new ActionRoleDto();
        result.init(json);
        return result;
    }
}

export interface IActionRoleDto {
    id?: number;
    roleName?: string | undefined;
    actionId?: number;
    roleId?: number;
    code?: UserRoles;
    actionCode?: ActionCode;
}

export enum UserRoles {
    SuperAdmin = "SuperAdmin",
    Admin = "Admin",
    User = "User",
    Agent = "Agent",
}

export class ActionRoleSearchDto extends PaginatedSearch implements IActionRoleSearchDto {
    parentActionGroupId?: number | undefined;

    constructor(data?: IActionRoleSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentActionGroupId = _data["parentActionGroupId"];
        }
    }

    static override fromJS(data: any): ActionRoleSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRoleSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentActionGroupId"] = this.parentActionGroupId;
        super.toJSON(data);
        return data;
    }

    clone(): ActionRoleSearchDto {
        const json = this.toJSON();
        let result = new ActionRoleSearchDto();
        result.init(json);
        return result;
    }
}

export interface IActionRoleSearchDto extends IPaginatedSearch {
    parentActionGroupId?: number | undefined;
}

export class AgentEditDto implements IAgentEditDto {
    id?: number;
    name?: string | undefined;
    firstname?: string | undefined;
    sex?: ESex;
    nationalRegistrationNumber?: string | undefined;
    email?: string | undefined;
    gradeId?: number;
    gradeStartDate?: Date;
    cadreId?: number;
    gradeStatusId?: number;
    gradeSubStatusId?: number | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    directionId?: number | undefined;
    mentionId?: number | undefined;
    isActive?: boolean;
    hasSkillCertificate?: boolean;
    affectation?: string | undefined;

    constructor(data?: IAgentEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.sex = _data["sex"];
            this.nationalRegistrationNumber = _data["nationalRegistrationNumber"];
            this.email = _data["email"];
            this.gradeId = _data["gradeId"];
            this.gradeStartDate = _data["gradeStartDate"] ? new Date(_data["gradeStartDate"].toString()) : undefined as any;
            this.cadreId = _data["cadreId"];
            this.gradeStatusId = _data["gradeStatusId"];
            this.gradeSubStatusId = _data["gradeSubStatusId"];
            this.agentN1Id = _data["agentN1Id"];
            this.agentN2Id = _data["agentN2Id"];
            this.directionId = _data["directionId"];
            this.mentionId = _data["mentionId"];
            this.isActive = _data["isActive"];
            this.hasSkillCertificate = _data["hasSkillCertificate"];
            this.affectation = _data["affectation"];
        }
    }

    static fromJS(data: any): AgentEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["sex"] = this.sex;
        data["nationalRegistrationNumber"] = this.nationalRegistrationNumber;
        data["email"] = this.email;
        data["gradeId"] = this.gradeId;
        data["gradeStartDate"] = this.gradeStartDate ? this.gradeStartDate.toISOString() : undefined as any;
        data["cadreId"] = this.cadreId;
        data["gradeStatusId"] = this.gradeStatusId;
        data["gradeSubStatusId"] = this.gradeSubStatusId;
        data["agentN1Id"] = this.agentN1Id;
        data["agentN2Id"] = this.agentN2Id;
        data["directionId"] = this.directionId;
        data["mentionId"] = this.mentionId;
        data["isActive"] = this.isActive;
        data["hasSkillCertificate"] = this.hasSkillCertificate;
        data["affectation"] = this.affectation;
        return data;
    }

    clone(): AgentEditDto {
        const json = this.toJSON();
        let result = new AgentEditDto();
        result.init(json);
        return result;
    }
}

export interface IAgentEditDto {
    id?: number;
    name?: string | undefined;
    firstname?: string | undefined;
    sex?: ESex;
    nationalRegistrationNumber?: string | undefined;
    email?: string | undefined;
    gradeId?: number;
    gradeStartDate?: Date;
    cadreId?: number;
    gradeStatusId?: number;
    gradeSubStatusId?: number | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    directionId?: number | undefined;
    mentionId?: number | undefined;
    isActive?: boolean;
    hasSkillCertificate?: boolean;
    affectation?: string | undefined;
}

export enum ESex {
    M = "M",
    F = "F",
}

export class DisplayNameDto implements IDisplayNameDto {
    text?: string | undefined;
    id?: number | undefined;
    translatated?: string | undefined;

    constructor(data?: IDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.id = _data["id"];
            this.translatated = _data["translatated"];
        }
    }

    static fromJS(data: any): DisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["id"] = this.id;
        data["translatated"] = this.translatated;
        return data;
    }

    clone(): DisplayNameDto {
        const json = this.toJSON();
        let result = new DisplayNameDto();
        result.init(json);
        return result;
    }
}

export interface IDisplayNameDto {
    text?: string | undefined;
    id?: number | undefined;
    translatated?: string | undefined;
}

export class AgentSuperiorDataDto implements IAgentSuperiorDataDto {
    id?: number;
    gradeId?: number;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;

    constructor(data?: IAgentSuperiorDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gradeId = _data["gradeId"];
            this.agentN1Id = _data["agentN1Id"];
            this.agentN2Id = _data["agentN2Id"];
        }
    }

    static fromJS(data: any): AgentSuperiorDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentSuperiorDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gradeId"] = this.gradeId;
        data["agentN1Id"] = this.agentN1Id;
        data["agentN2Id"] = this.agentN2Id;
        return data;
    }

    clone(): AgentSuperiorDataDto {
        const json = this.toJSON();
        let result = new AgentSuperiorDataDto();
        result.init(json);
        return result;
    }
}

export interface IAgentSuperiorDataDto {
    id?: number;
    gradeId?: number;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
}

export class SearchQueryOfAgentSearchCriteria implements ISearchQueryOfAgentSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AgentSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfAgentSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? AgentSearchCriteria.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfAgentSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfAgentSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfAgentSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfAgentSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfAgentSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AgentSearchCriteria | undefined;
}

export abstract class AbstractSearchExpression implements IAbstractSearchExpression {
    expressionOperator?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IAbstractSearchExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "AbstractSearchExpression";
    }

    init(_data?: any) {
        if (_data) {
            this.expressionOperator = _data["expressionOperator"];
        }
    }

    static fromJS(data: any): AbstractSearchExpression {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "condition") {
            let result = new ConditionSearchExpression();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "group") {
            let result = new GroupSearchExpression();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AbstractSearchExpression' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["expressionOperator"] = this.expressionOperator;
        return data;
    }

    clone(): AbstractSearchExpression {
        throw new Error("The abstract class 'AbstractSearchExpression' cannot be instantiated.");
    }
}

export interface IAbstractSearchExpression {
    expressionOperator?: string | undefined;
}

export class ConditionSearchExpression extends AbstractSearchExpression implements IConditionSearchExpression {
    field?: string | undefined;
    value?: string | undefined;

    constructor(data?: IConditionSearchExpression) {
        super(data);
        this._discriminator = "condition";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.field = _data["field"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ConditionSearchExpression {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionSearchExpression();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): ConditionSearchExpression {
        const json = this.toJSON();
        let result = new ConditionSearchExpression();
        result.init(json);
        return result;
    }
}

export interface IConditionSearchExpression extends IAbstractSearchExpression {
    field?: string | undefined;
    value?: string | undefined;
}

export class GroupSearchExpression extends AbstractSearchExpression implements IGroupSearchExpression {
    expressions?: AbstractSearchExpression[] | undefined;

    constructor(data?: IGroupSearchExpression) {
        super(data);
        this._discriminator = "group";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["expressions"])) {
                this.expressions = [] as any;
                for (let item of _data["expressions"])
                    this.expressions!.push(AbstractSearchExpression.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GroupSearchExpression {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSearchExpression();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expressions)) {
            data["expressions"] = [];
            for (let item of this.expressions)
                data["expressions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): GroupSearchExpression {
        const json = this.toJSON();
        let result = new GroupSearchExpression();
        result.init(json);
        return result;
    }
}

export interface IGroupSearchExpression extends IAbstractSearchExpression {
    expressions?: AbstractSearchExpression[] | undefined;
}

export class Searchable implements ISearchable {
    filter?: string | undefined;

    constructor(data?: ISearchable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): Searchable {
        data = typeof data === 'object' ? data : {};
        let result = new Searchable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }

    clone(): Searchable {
        const json = this.toJSON();
        let result = new Searchable();
        result.init(json);
        return result;
    }
}

export interface ISearchable {
    filter?: string | undefined;
}

export class PaginatedSearchable extends Searchable implements IPaginatedSearchable {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;

    constructor(data?: IPaginatedSearchable) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortKey"])) {
                this.sortKey = [] as any;
                for (let item of _data["sortKey"])
                    this.sortKey!.push(item);
            }
            if (Array.isArray(_data["aggregateKeys"])) {
                this.aggregateKeys = [] as any;
                for (let item of _data["aggregateKeys"])
                    this.aggregateKeys!.push(AggregateKeyInfo.fromJS(item));
            }
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static override fromJS(data: any): PaginatedSearchable {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedSearchable();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortKey)) {
            data["sortKey"] = [];
            for (let item of this.sortKey)
                data["sortKey"].push(item);
        }
        if (Array.isArray(this.aggregateKeys)) {
            data["aggregateKeys"] = [];
            for (let item of this.aggregateKeys)
                data["aggregateKeys"].push(item ? item.toJSON() : undefined as any);
        }
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data;
    }

    clone(): PaginatedSearchable {
        const json = this.toJSON();
        let result = new PaginatedSearchable();
        result.init(json);
        return result;
    }
}

export interface IPaginatedSearchable extends ISearchable {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export class AgentSearchCriteria extends PaginatedSearchable implements IAgentSearchCriteria {

    constructor(data?: IAgentSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AgentSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new AgentSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): AgentSearchCriteria {
        const json = this.toJSON();
        let result = new AgentSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IAgentSearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfAgentGridDto implements IPaginatedResultsOfAgentGridDto {
    totalCount?: number;
    results?: AgentGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfAgentGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AgentGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfAgentGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfAgentGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfAgentGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfAgentGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfAgentGridDto {
    totalCount?: number;
    results?: AgentGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class AgentGridDto implements IAgentGridDto {
    id?: number;
    name?: string | undefined;
    firstname?: string | undefined;
    sex?: string | undefined;
    nationalRegistrationNumber?: string | undefined;
    grade?: string | undefined;
    cadre?: string | undefined;
    gradeStatus?: string | undefined;
    gradeSubStatus?: string | undefined;
    direction?: string | undefined;
    nPlus1Name?: string | undefined;
    nPlus2Name?: string | undefined;
    email?: string | undefined;
    mention?: string | undefined;
    gradeId?: number;
    gradeStartDate?: Date;
    cadreId?: number;
    gradeStatusId?: number;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    assignmentId?: number | undefined;
    serviceId?: number | undefined;
    mentionId?: number | undefined;
    isActive?: boolean;
    agentFunctionIds?: number[] | undefined;
    agentFunctionNames?: string[] | undefined;
    agentFunctions?: string | undefined;

    constructor(data?: IAgentGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.sex = _data["sex"];
            this.nationalRegistrationNumber = _data["nationalRegistrationNumber"];
            this.grade = _data["grade"];
            this.cadre = _data["cadre"];
            this.gradeStatus = _data["gradeStatus"];
            this.gradeSubStatus = _data["gradeSubStatus"];
            this.direction = _data["direction"];
            this.nPlus1Name = _data["nPlus1Name"];
            this.nPlus2Name = _data["nPlus2Name"];
            this.email = _data["email"];
            this.mention = _data["mention"];
            this.gradeId = _data["gradeId"];
            this.gradeStartDate = _data["gradeStartDate"] ? new Date(_data["gradeStartDate"].toString()) : undefined as any;
            this.cadreId = _data["cadreId"];
            this.gradeStatusId = _data["gradeStatusId"];
            this.agentN1Id = _data["agentN1Id"];
            this.agentN2Id = _data["agentN2Id"];
            this.assignmentId = _data["assignmentId"];
            this.serviceId = _data["serviceId"];
            this.mentionId = _data["mentionId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["agentFunctionIds"])) {
                this.agentFunctionIds = [] as any;
                for (let item of _data["agentFunctionIds"])
                    this.agentFunctionIds!.push(item);
            }
            if (Array.isArray(_data["agentFunctionNames"])) {
                this.agentFunctionNames = [] as any;
                for (let item of _data["agentFunctionNames"])
                    this.agentFunctionNames!.push(item);
            }
            this.agentFunctions = _data["agentFunctions"];
        }
    }

    static fromJS(data: any): AgentGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["sex"] = this.sex;
        data["nationalRegistrationNumber"] = this.nationalRegistrationNumber;
        data["grade"] = this.grade;
        data["cadre"] = this.cadre;
        data["gradeStatus"] = this.gradeStatus;
        data["gradeSubStatus"] = this.gradeSubStatus;
        data["direction"] = this.direction;
        data["nPlus1Name"] = this.nPlus1Name;
        data["nPlus2Name"] = this.nPlus2Name;
        data["email"] = this.email;
        data["mention"] = this.mention;
        data["gradeId"] = this.gradeId;
        data["gradeStartDate"] = this.gradeStartDate ? this.gradeStartDate.toISOString() : undefined as any;
        data["cadreId"] = this.cadreId;
        data["gradeStatusId"] = this.gradeStatusId;
        data["agentN1Id"] = this.agentN1Id;
        data["agentN2Id"] = this.agentN2Id;
        data["assignmentId"] = this.assignmentId;
        data["serviceId"] = this.serviceId;
        data["mentionId"] = this.mentionId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.agentFunctionIds)) {
            data["agentFunctionIds"] = [];
            for (let item of this.agentFunctionIds)
                data["agentFunctionIds"].push(item);
        }
        if (Array.isArray(this.agentFunctionNames)) {
            data["agentFunctionNames"] = [];
            for (let item of this.agentFunctionNames)
                data["agentFunctionNames"].push(item);
        }
        data["agentFunctions"] = this.agentFunctions;
        return data;
    }

    clone(): AgentGridDto {
        const json = this.toJSON();
        let result = new AgentGridDto();
        result.init(json);
        return result;
    }
}

export interface IAgentGridDto {
    id?: number;
    name?: string | undefined;
    firstname?: string | undefined;
    sex?: string | undefined;
    nationalRegistrationNumber?: string | undefined;
    grade?: string | undefined;
    cadre?: string | undefined;
    gradeStatus?: string | undefined;
    gradeSubStatus?: string | undefined;
    direction?: string | undefined;
    nPlus1Name?: string | undefined;
    nPlus2Name?: string | undefined;
    email?: string | undefined;
    mention?: string | undefined;
    gradeId?: number;
    gradeStartDate?: Date;
    cadreId?: number;
    gradeStatusId?: number;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    assignmentId?: number | undefined;
    serviceId?: number | undefined;
    mentionId?: number | undefined;
    isActive?: boolean;
    agentFunctionIds?: number[] | undefined;
    agentFunctionNames?: string[] | undefined;
    agentFunctions?: string | undefined;
}

export class AgentFunctionEditDto implements IAgentFunctionEditDto {
    id?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;

    constructor(data?: IAgentFunctionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isPerformed = _data["isPerformed"];
            this.isHasTechAbilities = _data["isHasTechAbilities"];
        }
    }

    static fromJS(data: any): AgentFunctionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFunctionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isPerformed"] = this.isPerformed;
        data["isHasTechAbilities"] = this.isHasTechAbilities;
        return data;
    }

    clone(): AgentFunctionEditDto {
        const json = this.toJSON();
        let result = new AgentFunctionEditDto();
        result.init(json);
        return result;
    }
}

export interface IAgentFunctionEditDto {
    id?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
}

export class AgentFunctionSpecialityEditDto implements IAgentFunctionSpecialityEditDto {
    id?: number;
    isChecked?: boolean;

    constructor(data?: IAgentFunctionSpecialityEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): AgentFunctionSpecialityEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFunctionSpecialityEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isChecked"] = this.isChecked;
        return data;
    }

    clone(): AgentFunctionSpecialityEditDto {
        const json = this.toJSON();
        let result = new AgentFunctionSpecialityEditDto();
        result.init(json);
        return result;
    }
}

export interface IAgentFunctionSpecialityEditDto {
    id?: number;
    isChecked?: boolean;
}

export class AgentFunctionsEditDto implements IAgentFunctionsEditDto {
    id?: number;
    agentFunctions?: AgentFunctionGridDto[] | undefined;

    constructor(data?: IAgentFunctionsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["agentFunctions"])) {
                this.agentFunctions = [] as any;
                for (let item of _data["agentFunctions"])
                    this.agentFunctions!.push(AgentFunctionGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentFunctionsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFunctionsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.agentFunctions)) {
            data["agentFunctions"] = [];
            for (let item of this.agentFunctions)
                data["agentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AgentFunctionsEditDto {
        const json = this.toJSON();
        let result = new AgentFunctionsEditDto();
        result.init(json);
        return result;
    }
}

export interface IAgentFunctionsEditDto {
    id?: number;
    agentFunctions?: AgentFunctionGridDto[] | undefined;
}

export class AgentFunctionGridDto implements IAgentFunctionGridDto {
    id?: number;
    functionId?: number;
    function?: string | undefined;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    agent?: string | undefined;
    specialities?: AgentFunctionSpecialityGridDto[] | undefined;
    requirement?: EFunctionRequirement;
    note?: string | undefined;
    functionalDirector?: string | undefined;
    order?: number;
    sharepointUrl?: string | undefined;

    constructor(data?: IAgentFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.functionId = _data["functionId"];
            this.function = _data["function"];
            this.isPerformed = _data["isPerformed"];
            this.isHasTechAbilities = _data["isHasTechAbilities"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"];
            if (Array.isArray(_data["specialities"])) {
                this.specialities = [] as any;
                for (let item of _data["specialities"])
                    this.specialities!.push(AgentFunctionSpecialityGridDto.fromJS(item));
            }
            this.requirement = _data["requirement"];
            this.note = _data["note"];
            this.functionalDirector = _data["functionalDirector"];
            this.order = _data["order"];
            this.sharepointUrl = _data["sharepointUrl"];
        }
    }

    static fromJS(data: any): AgentFunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["functionId"] = this.functionId;
        data["function"] = this.function;
        data["isPerformed"] = this.isPerformed;
        data["isHasTechAbilities"] = this.isHasTechAbilities;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent;
        if (Array.isArray(this.specialities)) {
            data["specialities"] = [];
            for (let item of this.specialities)
                data["specialities"].push(item ? item.toJSON() : undefined as any);
        }
        data["requirement"] = this.requirement;
        data["note"] = this.note;
        data["functionalDirector"] = this.functionalDirector;
        data["order"] = this.order;
        data["sharepointUrl"] = this.sharepointUrl;
        return data;
    }

    clone(): AgentFunctionGridDto {
        const json = this.toJSON();
        let result = new AgentFunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IAgentFunctionGridDto {
    id?: number;
    functionId?: number;
    function?: string | undefined;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    agent?: string | undefined;
    specialities?: AgentFunctionSpecialityGridDto[] | undefined;
    requirement?: EFunctionRequirement;
    note?: string | undefined;
    functionalDirector?: string | undefined;
    order?: number;
    sharepointUrl?: string | undefined;
}

export class AgentFunctionSpecialityGridDto implements IAgentFunctionSpecialityGridDto {
    id?: number;
    agentFunctionId?: number;
    specialityId?: number;
    code?: string | undefined;
    name?: string | undefined;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    hasDirection?: boolean;
    hasPosition?: boolean;

    constructor(data?: IAgentFunctionSpecialityGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentFunctionId = _data["agentFunctionId"];
            this.specialityId = _data["specialityId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isChecked = _data["isChecked"];
            this.functionalDirectorId = _data["functionalDirectorId"];
            this.positionId = _data["positionId"];
            this.hasDirection = _data["hasDirection"];
            this.hasPosition = _data["hasPosition"];
        }
    }

    static fromJS(data: any): AgentFunctionSpecialityGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFunctionSpecialityGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentFunctionId"] = this.agentFunctionId;
        data["specialityId"] = this.specialityId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isChecked"] = this.isChecked;
        data["functionalDirectorId"] = this.functionalDirectorId;
        data["positionId"] = this.positionId;
        data["hasDirection"] = this.hasDirection;
        data["hasPosition"] = this.hasPosition;
        return data;
    }

    clone(): AgentFunctionSpecialityGridDto {
        const json = this.toJSON();
        let result = new AgentFunctionSpecialityGridDto();
        result.init(json);
        return result;
    }
}

export interface IAgentFunctionSpecialityGridDto {
    id?: number;
    agentFunctionId?: number;
    specialityId?: number;
    code?: string | undefined;
    name?: string | undefined;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    hasDirection?: boolean;
    hasPosition?: boolean;
}

export enum EFunctionRequirement {
    Required = "Required",
    Optional = "Optional",
}

export class PaginatedResultsOfAgentFunctionGridDto implements IPaginatedResultsOfAgentFunctionGridDto {
    totalCount?: number;
    results?: AgentFunctionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfAgentFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AgentFunctionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfAgentFunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfAgentFunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfAgentFunctionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfAgentFunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfAgentFunctionGridDto {
    totalCount?: number;
    results?: AgentFunctionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SearchQueryOfAgentFunctionSearchCriterias implements ISearchQueryOfAgentFunctionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AgentFunctionSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfAgentFunctionSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? AgentFunctionSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfAgentFunctionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfAgentFunctionSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfAgentFunctionSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfAgentFunctionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfAgentFunctionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AgentFunctionSearchCriterias | undefined;
}

export class AgentFunctionSearchCriterias extends PaginatedSearchable implements IAgentFunctionSearchCriterias {
    agentId?: number | undefined;
    functionRequirement?: EFunctionRequirement | undefined;
    oneIsChecked?: boolean | undefined;

    constructor(data?: IAgentFunctionSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentId = _data["agentId"];
            this.functionRequirement = _data["functionRequirement"];
            this.oneIsChecked = _data["oneIsChecked"];
        }
    }

    static override fromJS(data: any): AgentFunctionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFunctionSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["functionRequirement"] = this.functionRequirement;
        data["oneIsChecked"] = this.oneIsChecked;
        super.toJSON(data);
        return data;
    }

    clone(): AgentFunctionSearchCriterias {
        const json = this.toJSON();
        let result = new AgentFunctionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IAgentFunctionSearchCriterias extends IPaginatedSearchable {
    agentId?: number | undefined;
    functionRequirement?: EFunctionRequirement | undefined;
    oneIsChecked?: boolean | undefined;
}

export class PaginatedResultsOfArchivedDossierGridDto implements IPaginatedResultsOfArchivedDossierGridDto {
    totalCount?: number;
    results?: ArchivedDossierGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfArchivedDossierGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ArchivedDossierGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfArchivedDossierGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfArchivedDossierGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfArchivedDossierGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfArchivedDossierGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfArchivedDossierGridDto {
    totalCount?: number;
    results?: ArchivedDossierGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ArchivedDossierGridDto implements IArchivedDossierGridDto {
    id?: number;
    agentId?: number;
    agentN1?: string | undefined;
    agentN2?: string | undefined;
    cycleStartDate?: Date | undefined;
    assessementInterviewStartDate?: Date | undefined;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    lastCycleMentionId?: number | undefined;
    lastCycleMention?: string | undefined;
    cycleNumber?: number;
    dossierStatusId?: number | undefined;
    dossierStatus?: string | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;

    constructor(data?: IArchivedDossierGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.agentN1 = _data["agentN1"];
            this.agentN2 = _data["agentN2"];
            this.cycleStartDate = _data["cycleStartDate"] ? new Date(_data["cycleStartDate"].toString()) : undefined as any;
            this.assessementInterviewStartDate = _data["assessementInterviewStartDate"] ? new Date(_data["assessementInterviewStartDate"].toString()) : undefined as any;
            this.jobInterviewDate = _data["jobInterviewDate"] ? new Date(_data["jobInterviewDate"].toString()) : undefined as any;
            this.operationalInterviewDate = _data["operationalInterviewDate"] ? new Date(_data["operationalInterviewDate"].toString()) : undefined as any;
            this.lastCycleMentionId = _data["lastCycleMentionId"];
            this.lastCycleMention = _data["lastCycleMention"];
            this.cycleNumber = _data["cycleNumber"];
            this.dossierStatusId = _data["dossierStatusId"];
            this.dossierStatus = _data["dossierStatus"];
            this.agentN1Id = _data["agentN1Id"];
            this.agentN2Id = _data["agentN2Id"];
        }
    }

    static fromJS(data: any): ArchivedDossierGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedDossierGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["agentN1"] = this.agentN1;
        data["agentN2"] = this.agentN2;
        data["cycleStartDate"] = this.cycleStartDate ? this.cycleStartDate.toISOString() : undefined as any;
        data["assessementInterviewStartDate"] = this.assessementInterviewStartDate ? this.assessementInterviewStartDate.toISOString() : undefined as any;
        data["jobInterviewDate"] = this.jobInterviewDate ? this.jobInterviewDate.toISOString() : undefined as any;
        data["operationalInterviewDate"] = this.operationalInterviewDate ? this.operationalInterviewDate.toISOString() : undefined as any;
        data["lastCycleMentionId"] = this.lastCycleMentionId;
        data["lastCycleMention"] = this.lastCycleMention;
        data["cycleNumber"] = this.cycleNumber;
        data["dossierStatusId"] = this.dossierStatusId;
        data["dossierStatus"] = this.dossierStatus;
        data["agentN1Id"] = this.agentN1Id;
        data["agentN2Id"] = this.agentN2Id;
        return data;
    }

    clone(): ArchivedDossierGridDto {
        const json = this.toJSON();
        let result = new ArchivedDossierGridDto();
        result.init(json);
        return result;
    }
}

export interface IArchivedDossierGridDto {
    id?: number;
    agentId?: number;
    agentN1?: string | undefined;
    agentN2?: string | undefined;
    cycleStartDate?: Date | undefined;
    assessementInterviewStartDate?: Date | undefined;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    lastCycleMentionId?: number | undefined;
    lastCycleMention?: string | undefined;
    cycleNumber?: number;
    dossierStatusId?: number | undefined;
    dossierStatus?: string | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
}

export class SearchQueryOfArchivedDossierCriterias implements ISearchQueryOfArchivedDossierCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ArchivedDossierCriterias | undefined;

    constructor(data?: ISearchQueryOfArchivedDossierCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? ArchivedDossierCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfArchivedDossierCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfArchivedDossierCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfArchivedDossierCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfArchivedDossierCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfArchivedDossierCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ArchivedDossierCriterias | undefined;
}

export class ArchivedDossierCriterias extends PaginatedSearchable implements IArchivedDossierCriterias {
    dossierId?: number;

    constructor(data?: IArchivedDossierCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dossierId = _data["dossierId"];
        }
    }

    static override fromJS(data: any): ArchivedDossierCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedDossierCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dossierId"] = this.dossierId;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivedDossierCriterias {
        const json = this.toJSON();
        let result = new ArchivedDossierCriterias();
        result.init(json);
        return result;
    }
}

export interface IArchivedDossierCriterias extends IPaginatedSearchable {
    dossierId?: number;
}

export class AssessementDossierEditDto implements IAssessementDossierEditDto {
    id?: number;
    agentId?: number;
    agentN1?: string | undefined;
    agentN2?: string | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    currentAgentN1Id?: number | undefined;
    currentAgentN2Id?: number | undefined;
    gradeId?: number | undefined;
    cycleStartDate?: Date;
    assessementInterviewStartDate?: Date | undefined;
    cycleNumber?: number;
    jobInterviewId?: number | undefined;
    cycleTypeId?: number | undefined;
    cycleType?: string | undefined;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    jobInterviewDates?: JobInterviewDateEditDto[] | undefined;
    operationalInterviewDates?: OperationalInterviewDate[] | undefined;
    remark?: string | undefined;
    lastCycleMentionId?: number | undefined;
    status?: string | undefined;
    statusCode?: EDossierStatus;
    sharepointUrl?: string | undefined;

    constructor(data?: IAssessementDossierEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.agentN1 = _data["agentN1"];
            this.agentN2 = _data["agentN2"];
            this.agentN1Id = _data["agentN1Id"];
            this.agentN2Id = _data["agentN2Id"];
            this.currentAgentN1Id = _data["currentAgentN1Id"];
            this.currentAgentN2Id = _data["currentAgentN2Id"];
            this.gradeId = _data["gradeId"];
            this.cycleStartDate = _data["cycleStartDate"] ? new Date(_data["cycleStartDate"].toString()) : undefined as any;
            this.assessementInterviewStartDate = _data["assessementInterviewStartDate"] ? new Date(_data["assessementInterviewStartDate"].toString()) : undefined as any;
            this.cycleNumber = _data["cycleNumber"];
            this.jobInterviewId = _data["jobInterviewId"];
            this.cycleTypeId = _data["cycleTypeId"];
            this.cycleType = _data["cycleType"];
            this.jobInterviewDate = _data["jobInterviewDate"] ? new Date(_data["jobInterviewDate"].toString()) : undefined as any;
            this.operationalInterviewDate = _data["operationalInterviewDate"] ? new Date(_data["operationalInterviewDate"].toString()) : undefined as any;
            if (Array.isArray(_data["jobInterviewDates"])) {
                this.jobInterviewDates = [] as any;
                for (let item of _data["jobInterviewDates"])
                    this.jobInterviewDates!.push(JobInterviewDateEditDto.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewDates"])) {
                this.operationalInterviewDates = [] as any;
                for (let item of _data["operationalInterviewDates"])
                    this.operationalInterviewDates!.push(OperationalInterviewDate.fromJS(item));
            }
            this.remark = _data["remark"];
            this.lastCycleMentionId = _data["lastCycleMentionId"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.sharepointUrl = _data["sharepointUrl"];
        }
    }

    static fromJS(data: any): AssessementDossierEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessementDossierEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["agentN1"] = this.agentN1;
        data["agentN2"] = this.agentN2;
        data["agentN1Id"] = this.agentN1Id;
        data["agentN2Id"] = this.agentN2Id;
        data["currentAgentN1Id"] = this.currentAgentN1Id;
        data["currentAgentN2Id"] = this.currentAgentN2Id;
        data["gradeId"] = this.gradeId;
        data["cycleStartDate"] = this.cycleStartDate ? this.cycleStartDate.toISOString() : undefined as any;
        data["assessementInterviewStartDate"] = this.assessementInterviewStartDate ? this.assessementInterviewStartDate.toISOString() : undefined as any;
        data["cycleNumber"] = this.cycleNumber;
        data["jobInterviewId"] = this.jobInterviewId;
        data["cycleTypeId"] = this.cycleTypeId;
        data["cycleType"] = this.cycleType;
        data["jobInterviewDate"] = this.jobInterviewDate ? this.jobInterviewDate.toISOString() : undefined as any;
        data["operationalInterviewDate"] = this.operationalInterviewDate ? this.operationalInterviewDate.toISOString() : undefined as any;
        if (Array.isArray(this.jobInterviewDates)) {
            data["jobInterviewDates"] = [];
            for (let item of this.jobInterviewDates)
                data["jobInterviewDates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewDates)) {
            data["operationalInterviewDates"] = [];
            for (let item of this.operationalInterviewDates)
                data["operationalInterviewDates"].push(item ? item.toJSON() : undefined as any);
        }
        data["remark"] = this.remark;
        data["lastCycleMentionId"] = this.lastCycleMentionId;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["sharepointUrl"] = this.sharepointUrl;
        return data;
    }

    clone(): AssessementDossierEditDto {
        const json = this.toJSON();
        let result = new AssessementDossierEditDto();
        result.init(json);
        return result;
    }
}

export interface IAssessementDossierEditDto {
    id?: number;
    agentId?: number;
    agentN1?: string | undefined;
    agentN2?: string | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    currentAgentN1Id?: number | undefined;
    currentAgentN2Id?: number | undefined;
    gradeId?: number | undefined;
    cycleStartDate?: Date;
    assessementInterviewStartDate?: Date | undefined;
    cycleNumber?: number;
    jobInterviewId?: number | undefined;
    cycleTypeId?: number | undefined;
    cycleType?: string | undefined;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    jobInterviewDates?: JobInterviewDateEditDto[] | undefined;
    operationalInterviewDates?: OperationalInterviewDate[] | undefined;
    remark?: string | undefined;
    lastCycleMentionId?: number | undefined;
    status?: string | undefined;
    statusCode?: EDossierStatus;
    sharepointUrl?: string | undefined;
}

export class JobInterviewDateEditDto implements IJobInterviewDateEditDto {
    id?: number;
    date?: Date;
    assessmentDossierId?: number;
    isCancelled?: boolean;
    cancelledReason?: string | undefined;

    constructor(data?: IJobInterviewDateEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.assessmentDossierId = _data["assessmentDossierId"];
            this.isCancelled = _data["isCancelled"];
            this.cancelledReason = _data["cancelledReason"];
        }
    }

    static fromJS(data: any): JobInterviewDateEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewDateEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["assessmentDossierId"] = this.assessmentDossierId;
        data["isCancelled"] = this.isCancelled;
        data["cancelledReason"] = this.cancelledReason;
        return data;
    }

    clone(): JobInterviewDateEditDto {
        const json = this.toJSON();
        let result = new JobInterviewDateEditDto();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewDateEditDto {
    id?: number;
    date?: Date;
    assessmentDossierId?: number;
    isCancelled?: boolean;
    cancelledReason?: string | undefined;
}

export abstract class EntityOfLong implements IEntityOfLong {
    id?: number;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IEntityOfLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): EntityOfLong {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityOfLong' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }

    clone(): EntityOfLong {
        throw new Error("The abstract class 'EntityOfLong' cannot be instantiated.");
    }
}

export interface IEntityOfLong {
    id?: number;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
}

export abstract class Entity extends EntityOfLong implements IEntity {

    constructor(data?: IEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Entity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Entity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): Entity {
        throw new Error("The abstract class 'Entity' cannot be instantiated.");
    }
}

export interface IEntity extends IEntityOfLong {
}

export class OperationalInterviewDate extends Entity implements IOperationalInterviewDate {
    date?: Date;
    assessmentDossierId?: number;
    reason?: string | undefined;
    assessmentDossier?: AssessementDossier | undefined;

    constructor(data?: IOperationalInterviewDate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.assessmentDossierId = _data["assessmentDossierId"];
            this.reason = _data["reason"];
            this.assessmentDossier = _data["assessmentDossier"] ? AssessementDossier.fromJS(_data["assessmentDossier"]) : undefined as any;
        }
    }

    static override fromJS(data: any): OperationalInterviewDate {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewDate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["assessmentDossierId"] = this.assessmentDossierId;
        data["reason"] = this.reason;
        data["assessmentDossier"] = this.assessmentDossier ? this.assessmentDossier.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): OperationalInterviewDate {
        const json = this.toJSON();
        let result = new OperationalInterviewDate();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewDate extends IEntity {
    date?: Date;
    assessmentDossierId?: number;
    reason?: string | undefined;
    assessmentDossier?: AssessementDossier | undefined;
}

export class AssessementDossier extends Entity implements IAssessementDossier {
    agentId?: number;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    cycleStartDate?: Date;
    assessementInterviewStartDate?: Date | undefined;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    lastCycleMentionId?: number | undefined;
    remark?: string | undefined;
    cycleNumber?: number;
    lastJobInterviewReportReminder?: Date | undefined;
    lastJobInterviewSigningReminder?: Date | undefined;
    lastOperationalInterviewReminder?: Date | undefined;
    lastOperationalInterviewReportReminder?: Date | undefined;
    lastEvaluationInterviewReminder?: Date | undefined;
    lastEvaluationInterviewReportReminder?: Date | undefined;
    dossierStatusId?: number | undefined;
    sharepointUrl?: string | undefined;
    cycleTypeId?: number | undefined;
    cancellationReasonId?: number | undefined;
    cancellationComment?: string | undefined;
    cycleType?: CycleType | undefined;
    dossierStatus?: DossierStatus | undefined;
    jobInterview?: JobInterview | undefined;
    evaluationInterview?: EvaluationInterview | undefined;
    agent?: Agent | undefined;
    agentN1?: Agent | undefined;
    agentN2?: Agent | undefined;
    lastCycleMention?: Mention | undefined;
    cancellationReason?: CancellationReason | undefined;
    jobInterviewDates?: JobInterviewDate[] | undefined;
    operationalInterviewDates?: OperationalInterviewDate[] | undefined;
    operationalInterviews?: OperationalInterview[] | undefined;
    dossierTasks?: DossierTasks[] | undefined;

    constructor(data?: IAssessementDossier) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentId = _data["agentId"];
            this.agentN1Id = _data["agentN1Id"];
            this.agentN2Id = _data["agentN2Id"];
            this.cycleStartDate = _data["cycleStartDate"] ? new Date(_data["cycleStartDate"].toString()) : undefined as any;
            this.assessementInterviewStartDate = _data["assessementInterviewStartDate"] ? new Date(_data["assessementInterviewStartDate"].toString()) : undefined as any;
            this.jobInterviewDate = _data["jobInterviewDate"] ? new Date(_data["jobInterviewDate"].toString()) : undefined as any;
            this.operationalInterviewDate = _data["operationalInterviewDate"] ? new Date(_data["operationalInterviewDate"].toString()) : undefined as any;
            this.lastCycleMentionId = _data["lastCycleMentionId"];
            this.remark = _data["remark"];
            this.cycleNumber = _data["cycleNumber"];
            this.lastJobInterviewReportReminder = _data["lastJobInterviewReportReminder"] ? new Date(_data["lastJobInterviewReportReminder"].toString()) : undefined as any;
            this.lastJobInterviewSigningReminder = _data["lastJobInterviewSigningReminder"] ? new Date(_data["lastJobInterviewSigningReminder"].toString()) : undefined as any;
            this.lastOperationalInterviewReminder = _data["lastOperationalInterviewReminder"] ? new Date(_data["lastOperationalInterviewReminder"].toString()) : undefined as any;
            this.lastOperationalInterviewReportReminder = _data["lastOperationalInterviewReportReminder"] ? new Date(_data["lastOperationalInterviewReportReminder"].toString()) : undefined as any;
            this.lastEvaluationInterviewReminder = _data["lastEvaluationInterviewReminder"] ? new Date(_data["lastEvaluationInterviewReminder"].toString()) : undefined as any;
            this.lastEvaluationInterviewReportReminder = _data["lastEvaluationInterviewReportReminder"] ? new Date(_data["lastEvaluationInterviewReportReminder"].toString()) : undefined as any;
            this.dossierStatusId = _data["dossierStatusId"];
            this.sharepointUrl = _data["sharepointUrl"];
            this.cycleTypeId = _data["cycleTypeId"];
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.cancellationComment = _data["cancellationComment"];
            this.cycleType = _data["cycleType"] ? CycleType.fromJS(_data["cycleType"]) : undefined as any;
            this.dossierStatus = _data["dossierStatus"] ? DossierStatus.fromJS(_data["dossierStatus"]) : undefined as any;
            this.jobInterview = _data["jobInterview"] ? JobInterview.fromJS(_data["jobInterview"]) : undefined as any;
            this.evaluationInterview = _data["evaluationInterview"] ? EvaluationInterview.fromJS(_data["evaluationInterview"]) : undefined as any;
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            this.agentN1 = _data["agentN1"] ? Agent.fromJS(_data["agentN1"]) : undefined as any;
            this.agentN2 = _data["agentN2"] ? Agent.fromJS(_data["agentN2"]) : undefined as any;
            this.lastCycleMention = _data["lastCycleMention"] ? Mention.fromJS(_data["lastCycleMention"]) : undefined as any;
            this.cancellationReason = _data["cancellationReason"] ? CancellationReason.fromJS(_data["cancellationReason"]) : undefined as any;
            if (Array.isArray(_data["jobInterviewDates"])) {
                this.jobInterviewDates = [] as any;
                for (let item of _data["jobInterviewDates"])
                    this.jobInterviewDates!.push(JobInterviewDate.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewDates"])) {
                this.operationalInterviewDates = [] as any;
                for (let item of _data["operationalInterviewDates"])
                    this.operationalInterviewDates!.push(OperationalInterviewDate.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviews"])) {
                this.operationalInterviews = [] as any;
                for (let item of _data["operationalInterviews"])
                    this.operationalInterviews!.push(OperationalInterview.fromJS(item));
            }
            if (Array.isArray(_data["dossierTasks"])) {
                this.dossierTasks = [] as any;
                for (let item of _data["dossierTasks"])
                    this.dossierTasks!.push(DossierTasks.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AssessementDossier {
        data = typeof data === 'object' ? data : {};
        let result = new AssessementDossier();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["agentN1Id"] = this.agentN1Id;
        data["agentN2Id"] = this.agentN2Id;
        data["cycleStartDate"] = this.cycleStartDate ? this.cycleStartDate.toISOString() : undefined as any;
        data["assessementInterviewStartDate"] = this.assessementInterviewStartDate ? this.assessementInterviewStartDate.toISOString() : undefined as any;
        data["jobInterviewDate"] = this.jobInterviewDate ? this.jobInterviewDate.toISOString() : undefined as any;
        data["operationalInterviewDate"] = this.operationalInterviewDate ? this.operationalInterviewDate.toISOString() : undefined as any;
        data["lastCycleMentionId"] = this.lastCycleMentionId;
        data["remark"] = this.remark;
        data["cycleNumber"] = this.cycleNumber;
        data["lastJobInterviewReportReminder"] = this.lastJobInterviewReportReminder ? this.lastJobInterviewReportReminder.toISOString() : undefined as any;
        data["lastJobInterviewSigningReminder"] = this.lastJobInterviewSigningReminder ? this.lastJobInterviewSigningReminder.toISOString() : undefined as any;
        data["lastOperationalInterviewReminder"] = this.lastOperationalInterviewReminder ? this.lastOperationalInterviewReminder.toISOString() : undefined as any;
        data["lastOperationalInterviewReportReminder"] = this.lastOperationalInterviewReportReminder ? this.lastOperationalInterviewReportReminder.toISOString() : undefined as any;
        data["lastEvaluationInterviewReminder"] = this.lastEvaluationInterviewReminder ? this.lastEvaluationInterviewReminder.toISOString() : undefined as any;
        data["lastEvaluationInterviewReportReminder"] = this.lastEvaluationInterviewReportReminder ? this.lastEvaluationInterviewReportReminder.toISOString() : undefined as any;
        data["dossierStatusId"] = this.dossierStatusId;
        data["sharepointUrl"] = this.sharepointUrl;
        data["cycleTypeId"] = this.cycleTypeId;
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["cancellationComment"] = this.cancellationComment;
        data["cycleType"] = this.cycleType ? this.cycleType.toJSON() : undefined as any;
        data["dossierStatus"] = this.dossierStatus ? this.dossierStatus.toJSON() : undefined as any;
        data["jobInterview"] = this.jobInterview ? this.jobInterview.toJSON() : undefined as any;
        data["evaluationInterview"] = this.evaluationInterview ? this.evaluationInterview.toJSON() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["agentN1"] = this.agentN1 ? this.agentN1.toJSON() : undefined as any;
        data["agentN2"] = this.agentN2 ? this.agentN2.toJSON() : undefined as any;
        data["lastCycleMention"] = this.lastCycleMention ? this.lastCycleMention.toJSON() : undefined as any;
        data["cancellationReason"] = this.cancellationReason ? this.cancellationReason.toJSON() : undefined as any;
        if (Array.isArray(this.jobInterviewDates)) {
            data["jobInterviewDates"] = [];
            for (let item of this.jobInterviewDates)
                data["jobInterviewDates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewDates)) {
            data["operationalInterviewDates"] = [];
            for (let item of this.operationalInterviewDates)
                data["operationalInterviewDates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviews)) {
            data["operationalInterviews"] = [];
            for (let item of this.operationalInterviews)
                data["operationalInterviews"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dossierTasks)) {
            data["dossierTasks"] = [];
            for (let item of this.dossierTasks)
                data["dossierTasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AssessementDossier {
        const json = this.toJSON();
        let result = new AssessementDossier();
        result.init(json);
        return result;
    }
}

export interface IAssessementDossier extends IEntity {
    agentId?: number;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    cycleStartDate?: Date;
    assessementInterviewStartDate?: Date | undefined;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    lastCycleMentionId?: number | undefined;
    remark?: string | undefined;
    cycleNumber?: number;
    lastJobInterviewReportReminder?: Date | undefined;
    lastJobInterviewSigningReminder?: Date | undefined;
    lastOperationalInterviewReminder?: Date | undefined;
    lastOperationalInterviewReportReminder?: Date | undefined;
    lastEvaluationInterviewReminder?: Date | undefined;
    lastEvaluationInterviewReportReminder?: Date | undefined;
    dossierStatusId?: number | undefined;
    sharepointUrl?: string | undefined;
    cycleTypeId?: number | undefined;
    cancellationReasonId?: number | undefined;
    cancellationComment?: string | undefined;
    cycleType?: CycleType | undefined;
    dossierStatus?: DossierStatus | undefined;
    jobInterview?: JobInterview | undefined;
    evaluationInterview?: EvaluationInterview | undefined;
    agent?: Agent | undefined;
    agentN1?: Agent | undefined;
    agentN2?: Agent | undefined;
    lastCycleMention?: Mention | undefined;
    cancellationReason?: CancellationReason | undefined;
    jobInterviewDates?: JobInterviewDate[] | undefined;
    operationalInterviewDates?: OperationalInterviewDate[] | undefined;
    operationalInterviews?: OperationalInterview[] | undefined;
    dossierTasks?: DossierTasks[] | undefined;
}

export class CycleType extends Entity implements ICycleType {
    code?: ECycleType;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    assessementDossiers?: AssessementDossier[] | undefined;

    constructor(data?: ICycleType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["assessementDossiers"])) {
                this.assessementDossiers = [] as any;
                for (let item of _data["assessementDossiers"])
                    this.assessementDossiers!.push(AssessementDossier.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CycleType {
        data = typeof data === 'object' ? data : {};
        let result = new CycleType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.assessementDossiers)) {
            data["assessementDossiers"] = [];
            for (let item of this.assessementDossiers)
                data["assessementDossiers"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CycleType {
        const json = this.toJSON();
        let result = new CycleType();
        result.init(json);
        return result;
    }
}

export interface ICycleType extends IEntity {
    code?: ECycleType;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    assessementDossiers?: AssessementDossier[] | undefined;
}

export enum ECycleType {
    Short = "Short",
    Long = "Long",
}

export abstract class DataTranslation extends Entity implements IDataTranslation {

    constructor(data?: IDataTranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DataTranslation {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DataTranslation' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslation {
        throw new Error("The abstract class 'DataTranslation' cannot be instantiated.");
    }
}

export interface IDataTranslation extends IEntity {
}

export class DataTranslationOfLanguage extends DataTranslation implements IDataTranslationOfLanguage {
    dataTranslationValues?: DataTranslationValueOfLanguage[] | undefined;

    constructor(data?: IDataTranslationOfLanguage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dataTranslationValues"])) {
                this.dataTranslationValues = [] as any;
                for (let item of _data["dataTranslationValues"])
                    this.dataTranslationValues!.push(DataTranslationValueOfLanguage.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DataTranslationOfLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationOfLanguage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataTranslationValues)) {
            data["dataTranslationValues"] = [];
            for (let item of this.dataTranslationValues)
                data["dataTranslationValues"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationOfLanguage {
        const json = this.toJSON();
        let result = new DataTranslationOfLanguage();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationOfLanguage extends IDataTranslation {
    dataTranslationValues?: DataTranslationValueOfLanguage[] | undefined;
}

export class DataTranslationValueOfLanguage extends Entity implements IDataTranslationValueOfLanguage {
    text?: string | undefined;
    languageId?: number;
    dataTranslationId?: number;
    language?: Language | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;

    constructor(data?: IDataTranslationValueOfLanguage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.dataTranslationId = _data["dataTranslationId"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : undefined as any;
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
        }
    }

    static override fromJS(data: any): DataTranslationValueOfLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationValueOfLanguage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["dataTranslationId"] = this.dataTranslationId;
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationValueOfLanguage {
        const json = this.toJSON();
        let result = new DataTranslationValueOfLanguage();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationValueOfLanguage extends IEntity {
    text?: string | undefined;
    languageId?: number;
    dataTranslationId?: number;
    language?: Language | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
}

export abstract class LanguageBase extends Entity implements ILanguageBase {
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ILanguageBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): LanguageBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'LanguageBase' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }

    clone(): LanguageBase {
        throw new Error("The abstract class 'LanguageBase' cannot be instantiated.");
    }
}

export interface ILanguageBase extends IEntity {
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;
}

export class Language extends LanguageBase implements ILanguage {
    orderIndex?: number;
    translations?: Translation[] | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;

    constructor(data?: ILanguage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderIndex = _data["orderIndex"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(Translation.fromJS(item));
            }
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
        }
    }

    static override fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderIndex"] = this.orderIndex;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : undefined as any);
        }
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): Language {
        const json = this.toJSON();
        let result = new Language();
        result.init(json);
        return result;
    }
}

export interface ILanguage extends ILanguageBase {
    orderIndex?: number;
    translations?: Translation[] | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
}

export class Translation extends Entity implements ITranslation {
    languageId?: number;
    translationCodeId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    translationCode?: TranslationCode | undefined;

    constructor(data?: ITranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.translationCodeId = _data["translationCodeId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : undefined as any;
            this.translationCode = _data["translationCode"] ? TranslationCode.fromJS(_data["translationCode"]) : undefined as any;
        }
    }

    static override fromJS(data: any): Translation {
        data = typeof data === 'object' ? data : {};
        let result = new Translation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["translationCodeId"] = this.translationCodeId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        data["translationCode"] = this.translationCode ? this.translationCode.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): Translation {
        const json = this.toJSON();
        let result = new Translation();
        result.init(json);
        return result;
    }
}

export interface ITranslation extends IEntity {
    languageId?: number;
    translationCodeId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    translationCode?: TranslationCode | undefined;
}

export class TranslationCode extends Entity implements ITranslationCode {
    code?: string | undefined;
    translations?: Translation[] | undefined;

    constructor(data?: ITranslationCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(Translation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TranslationCode {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TranslationCode {
        const json = this.toJSON();
        let result = new TranslationCode();
        result.init(json);
        return result;
    }
}

export interface ITranslationCode extends IEntity {
    code?: string | undefined;
    translations?: Translation[] | undefined;
}

export class DossierStatus extends Entity implements IDossierStatus {
    code?: EDossierStatus;
    order?: number;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    dossiers?: AssessementDossier[] | undefined;

    constructor(data?: IDossierStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.order = _data["order"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["dossiers"])) {
                this.dossiers = [] as any;
                for (let item of _data["dossiers"])
                    this.dossiers!.push(AssessementDossier.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DossierStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DossierStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["order"] = this.order;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.dossiers)) {
            data["dossiers"] = [];
            for (let item of this.dossiers)
                data["dossiers"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): DossierStatus {
        const json = this.toJSON();
        let result = new DossierStatus();
        result.init(json);
        return result;
    }
}

export interface IDossierStatus extends IEntity {
    code?: EDossierStatus;
    order?: number;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    dossiers?: AssessementDossier[] | undefined;
}

export enum EDossierStatus {
    Error = "Error",
    EntretienFonctionDateEntretienADefinir = "EntretienFonctionDateEntretienADefinir",
    EntretienFonctionEntretienConfirme = "EntretienFonctionEntretienConfirme",
    EntretienFonctionSigneEnvoye = "EntretienFonctionSigneEnvoye",
    EntretienFonctionnementEntretienConfirme = "EntretienFonctionnementEntretienConfirme",
    EntretienFonctionnementSigneEnvoye = "EntretienFonctionnementSigneEnvoye",
    EntretienEvaluationEntretienConfirme = "EntretienEvaluationEntretienConfirme",
    EntretienEvaluationSigneEnvoye = "EntretienEvaluationSigneEnvoye",
    OnHold = "OnHold",
    Cancelled = "Cancelled",
    Closed = "Closed",
}

export class JobInterview extends Entity implements IJobInterview {
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    date?: Date | undefined;
    assessementDossierId?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    n2Comment?: string | undefined;
    jobInterviewAgentFunctions?: JobInterviewAgentFunction[] | undefined;
    formQuestionJobInterviews?: FormQuestionJobInterview[] | undefined;
    sfe?: Agent | undefined;
    agentN2?: Agent | undefined;
    assessementDossier?: AssessementDossier | undefined;
    jobInterviewObjectiveQuestions?: JobInterviewObjectiveQuestion[] | undefined;

    constructor(data?: IJobInterview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sfeId = _data["sfeId"];
            this.agentN2Id = _data["agentN2Id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.assessementDossierId = _data["assessementDossierId"];
            this.sfeSignatureDate = _data["sfeSignatureDate"] ? new Date(_data["sfeSignatureDate"].toString()) : undefined as any;
            this.mpSignatureDate = _data["mpSignatureDate"] ? new Date(_data["mpSignatureDate"].toString()) : undefined as any;
            this.nPlus2VisaDate = _data["nPlus2VisaDate"] ? new Date(_data["nPlus2VisaDate"].toString()) : undefined as any;
            this.n2Comment = _data["n2Comment"];
            if (Array.isArray(_data["jobInterviewAgentFunctions"])) {
                this.jobInterviewAgentFunctions = [] as any;
                for (let item of _data["jobInterviewAgentFunctions"])
                    this.jobInterviewAgentFunctions!.push(JobInterviewAgentFunction.fromJS(item));
            }
            if (Array.isArray(_data["formQuestionJobInterviews"])) {
                this.formQuestionJobInterviews = [] as any;
                for (let item of _data["formQuestionJobInterviews"])
                    this.formQuestionJobInterviews!.push(FormQuestionJobInterview.fromJS(item));
            }
            this.sfe = _data["sfe"] ? Agent.fromJS(_data["sfe"]) : undefined as any;
            this.agentN2 = _data["agentN2"] ? Agent.fromJS(_data["agentN2"]) : undefined as any;
            this.assessementDossier = _data["assessementDossier"] ? AssessementDossier.fromJS(_data["assessementDossier"]) : undefined as any;
            if (Array.isArray(_data["jobInterviewObjectiveQuestions"])) {
                this.jobInterviewObjectiveQuestions = [] as any;
                for (let item of _data["jobInterviewObjectiveQuestions"])
                    this.jobInterviewObjectiveQuestions!.push(JobInterviewObjectiveQuestion.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): JobInterview {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sfeId"] = this.sfeId;
        data["agentN2Id"] = this.agentN2Id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["assessementDossierId"] = this.assessementDossierId;
        data["sfeSignatureDate"] = this.sfeSignatureDate ? this.sfeSignatureDate.toISOString() : undefined as any;
        data["mpSignatureDate"] = this.mpSignatureDate ? this.mpSignatureDate.toISOString() : undefined as any;
        data["nPlus2VisaDate"] = this.nPlus2VisaDate ? this.nPlus2VisaDate.toISOString() : undefined as any;
        data["n2Comment"] = this.n2Comment;
        if (Array.isArray(this.jobInterviewAgentFunctions)) {
            data["jobInterviewAgentFunctions"] = [];
            for (let item of this.jobInterviewAgentFunctions)
                data["jobInterviewAgentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formQuestionJobInterviews)) {
            data["formQuestionJobInterviews"] = [];
            for (let item of this.formQuestionJobInterviews)
                data["formQuestionJobInterviews"].push(item ? item.toJSON() : undefined as any);
        }
        data["sfe"] = this.sfe ? this.sfe.toJSON() : undefined as any;
        data["agentN2"] = this.agentN2 ? this.agentN2.toJSON() : undefined as any;
        data["assessementDossier"] = this.assessementDossier ? this.assessementDossier.toJSON() : undefined as any;
        if (Array.isArray(this.jobInterviewObjectiveQuestions)) {
            data["jobInterviewObjectiveQuestions"] = [];
            for (let item of this.jobInterviewObjectiveQuestions)
                data["jobInterviewObjectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): JobInterview {
        const json = this.toJSON();
        let result = new JobInterview();
        result.init(json);
        return result;
    }
}

export interface IJobInterview extends IEntity {
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    date?: Date | undefined;
    assessementDossierId?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    n2Comment?: string | undefined;
    jobInterviewAgentFunctions?: JobInterviewAgentFunction[] | undefined;
    formQuestionJobInterviews?: FormQuestionJobInterview[] | undefined;
    sfe?: Agent | undefined;
    agentN2?: Agent | undefined;
    assessementDossier?: AssessementDossier | undefined;
    jobInterviewObjectiveQuestions?: JobInterviewObjectiveQuestion[] | undefined;
}

export class JobInterviewAgentFunction extends Entity implements IJobInterviewAgentFunction {
    functionId?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    jobInterviewId?: number;
    requirement?: EFunctionRequirement | undefined;
    jobInterview?: JobInterview | undefined;
    function?: Function | undefined;
    agent?: Agent | undefined;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterview[] | undefined;
    jobInterviewAgentFunctionSpeciality?: JobInterviewAgentFunctionSpeciality[] | undefined;

    constructor(data?: IJobInterviewAgentFunction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.functionId = _data["functionId"];
            this.isPerformed = _data["isPerformed"];
            this.isHasTechAbilities = _data["isHasTechAbilities"];
            this.agentId = _data["agentId"];
            this.jobInterviewId = _data["jobInterviewId"];
            this.requirement = _data["requirement"];
            this.jobInterview = _data["jobInterview"] ? JobInterview.fromJS(_data["jobInterview"]) : undefined as any;
            this.function = _data["function"] ? Function.fromJS(_data["function"]) : undefined as any;
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            if (Array.isArray(_data["formQuestionOperationalInterviews"])) {
                this.formQuestionOperationalInterviews = [] as any;
                for (let item of _data["formQuestionOperationalInterviews"])
                    this.formQuestionOperationalInterviews!.push(FormQuestionOperationalInterview.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewAgentFunctionSpeciality"])) {
                this.jobInterviewAgentFunctionSpeciality = [] as any;
                for (let item of _data["jobInterviewAgentFunctionSpeciality"])
                    this.jobInterviewAgentFunctionSpeciality!.push(JobInterviewAgentFunctionSpeciality.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): JobInterviewAgentFunction {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewAgentFunction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionId"] = this.functionId;
        data["isPerformed"] = this.isPerformed;
        data["isHasTechAbilities"] = this.isHasTechAbilities;
        data["agentId"] = this.agentId;
        data["jobInterviewId"] = this.jobInterviewId;
        data["requirement"] = this.requirement;
        data["jobInterview"] = this.jobInterview ? this.jobInterview.toJSON() : undefined as any;
        data["function"] = this.function ? this.function.toJSON() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        if (Array.isArray(this.formQuestionOperationalInterviews)) {
            data["formQuestionOperationalInterviews"] = [];
            for (let item of this.formQuestionOperationalInterviews)
                data["formQuestionOperationalInterviews"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewAgentFunctionSpeciality)) {
            data["jobInterviewAgentFunctionSpeciality"] = [];
            for (let item of this.jobInterviewAgentFunctionSpeciality)
                data["jobInterviewAgentFunctionSpeciality"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): JobInterviewAgentFunction {
        const json = this.toJSON();
        let result = new JobInterviewAgentFunction();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewAgentFunction extends IEntity {
    functionId?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    jobInterviewId?: number;
    requirement?: EFunctionRequirement | undefined;
    jobInterview?: JobInterview | undefined;
    function?: Function | undefined;
    agent?: Agent | undefined;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterview[] | undefined;
    jobInterviewAgentFunctionSpeciality?: JobInterviewAgentFunctionSpeciality[] | undefined;
}

export class Function extends Entity implements IFunction {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    functionalDirectorId?: number | undefined;
    sharepointUrl?: string | undefined;
    fileName?: string | undefined;
    note?: string | undefined;
    order?: number;
    functionalDirector?: FunctionalDirector | undefined;
    gradeFunctions?: GradeFunction[] | undefined;
    agentFunctions?: AgentFunction[] | undefined;
    jobInterviewAgentFunctions?: JobInterviewAgentFunction[] | undefined;
    operationalInterviewAgentFunctions?: OperationalInterviewAgentFunction[] | undefined;
    functionSpecialities?: FunctionSpeciality[] | undefined;

    constructor(data?: IFunction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.functionalDirectorId = _data["functionalDirectorId"];
            this.sharepointUrl = _data["sharepointUrl"];
            this.fileName = _data["fileName"];
            this.note = _data["note"];
            this.order = _data["order"];
            this.functionalDirector = _data["functionalDirector"] ? FunctionalDirector.fromJS(_data["functionalDirector"]) : undefined as any;
            if (Array.isArray(_data["gradeFunctions"])) {
                this.gradeFunctions = [] as any;
                for (let item of _data["gradeFunctions"])
                    this.gradeFunctions!.push(GradeFunction.fromJS(item));
            }
            if (Array.isArray(_data["agentFunctions"])) {
                this.agentFunctions = [] as any;
                for (let item of _data["agentFunctions"])
                    this.agentFunctions!.push(AgentFunction.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewAgentFunctions"])) {
                this.jobInterviewAgentFunctions = [] as any;
                for (let item of _data["jobInterviewAgentFunctions"])
                    this.jobInterviewAgentFunctions!.push(JobInterviewAgentFunction.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewAgentFunctions"])) {
                this.operationalInterviewAgentFunctions = [] as any;
                for (let item of _data["operationalInterviewAgentFunctions"])
                    this.operationalInterviewAgentFunctions!.push(OperationalInterviewAgentFunction.fromJS(item));
            }
            if (Array.isArray(_data["functionSpecialities"])) {
                this.functionSpecialities = [] as any;
                for (let item of _data["functionSpecialities"])
                    this.functionSpecialities!.push(FunctionSpeciality.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Function {
        data = typeof data === 'object' ? data : {};
        let result = new Function();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["functionalDirectorId"] = this.functionalDirectorId;
        data["sharepointUrl"] = this.sharepointUrl;
        data["fileName"] = this.fileName;
        data["note"] = this.note;
        data["order"] = this.order;
        data["functionalDirector"] = this.functionalDirector ? this.functionalDirector.toJSON() : undefined as any;
        if (Array.isArray(this.gradeFunctions)) {
            data["gradeFunctions"] = [];
            for (let item of this.gradeFunctions)
                data["gradeFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.agentFunctions)) {
            data["agentFunctions"] = [];
            for (let item of this.agentFunctions)
                data["agentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewAgentFunctions)) {
            data["jobInterviewAgentFunctions"] = [];
            for (let item of this.jobInterviewAgentFunctions)
                data["jobInterviewAgentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewAgentFunctions)) {
            data["operationalInterviewAgentFunctions"] = [];
            for (let item of this.operationalInterviewAgentFunctions)
                data["operationalInterviewAgentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.functionSpecialities)) {
            data["functionSpecialities"] = [];
            for (let item of this.functionSpecialities)
                data["functionSpecialities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Function {
        const json = this.toJSON();
        let result = new Function();
        result.init(json);
        return result;
    }
}

export interface IFunction extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    functionalDirectorId?: number | undefined;
    sharepointUrl?: string | undefined;
    fileName?: string | undefined;
    note?: string | undefined;
    order?: number;
    functionalDirector?: FunctionalDirector | undefined;
    gradeFunctions?: GradeFunction[] | undefined;
    agentFunctions?: AgentFunction[] | undefined;
    jobInterviewAgentFunctions?: JobInterviewAgentFunction[] | undefined;
    operationalInterviewAgentFunctions?: OperationalInterviewAgentFunction[] | undefined;
    functionSpecialities?: FunctionSpeciality[] | undefined;
}

export class FunctionalDirector extends Entity implements IFunctionalDirector {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    agentId?: number | undefined;
    agent?: Agent | undefined;
    agents?: Agent[] | undefined;
    functions?: Function[] | undefined;
    agentFunctionSpecialities?: AgentFunctionSpeciality[] | undefined;
    jobInterviewAgentFunctionSpecialities?: JobInterviewAgentFunctionSpeciality[] | undefined;

    constructor(data?: IFunctionalDirector) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(Agent.fromJS(item));
            }
            if (Array.isArray(_data["functions"])) {
                this.functions = [] as any;
                for (let item of _data["functions"])
                    this.functions!.push(Function.fromJS(item));
            }
            if (Array.isArray(_data["agentFunctionSpecialities"])) {
                this.agentFunctionSpecialities = [] as any;
                for (let item of _data["agentFunctionSpecialities"])
                    this.agentFunctionSpecialities!.push(AgentFunctionSpeciality.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewAgentFunctionSpecialities"])) {
                this.jobInterviewAgentFunctionSpecialities = [] as any;
                for (let item of _data["jobInterviewAgentFunctionSpecialities"])
                    this.jobInterviewAgentFunctionSpecialities!.push(JobInterviewAgentFunctionSpeciality.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FunctionalDirector {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalDirector();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.functions)) {
            data["functions"] = [];
            for (let item of this.functions)
                data["functions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.agentFunctionSpecialities)) {
            data["agentFunctionSpecialities"] = [];
            for (let item of this.agentFunctionSpecialities)
                data["agentFunctionSpecialities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewAgentFunctionSpecialities)) {
            data["jobInterviewAgentFunctionSpecialities"] = [];
            for (let item of this.jobInterviewAgentFunctionSpecialities)
                data["jobInterviewAgentFunctionSpecialities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FunctionalDirector {
        const json = this.toJSON();
        let result = new FunctionalDirector();
        result.init(json);
        return result;
    }
}

export interface IFunctionalDirector extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    agentId?: number | undefined;
    agent?: Agent | undefined;
    agents?: Agent[] | undefined;
    functions?: Function[] | undefined;
    agentFunctionSpecialities?: AgentFunctionSpeciality[] | undefined;
    jobInterviewAgentFunctionSpecialities?: JobInterviewAgentFunctionSpeciality[] | undefined;
}

export class Agent extends Entity implements IAgent {
    name?: string | undefined;
    firstname?: string | undefined;
    sex?: ESex;
    nationalRegistrationNumber?: string | undefined;
    email?: string | undefined;
    gradeId?: number;
    gradeStartDate?: Date;
    cadreId?: number;
    gradeStatusId?: number;
    gradeSubStatusId?: number | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    assignmentId?: number | undefined;
    directionId?: number | undefined;
    mentionId?: number | undefined;
    isActive?: boolean;
    hasSkillCertificate?: boolean;
    affectation?: string | undefined;
    lastZhcUpdate?: Date | undefined;
    fullName?: string | undefined;
    user?: User | undefined;
    agentN1?: Agent | undefined;
    agentN2?: Agent | undefined;
    grade?: Grade | undefined;
    cadre?: Cadre | undefined;
    gradeStatus?: GradeStatus | undefined;
    gradeSubStatus?: GradeSubStatus | undefined;
    mention?: Mention | undefined;
    direction?: FunctionalDirector | undefined;
    agentFunctions?: AgentFunction[] | undefined;
    jobInterviewAgentFunctions?: JobInterviewAgentFunction[] | undefined;
    operationalInterviewAgentFunctions?: OperationalInterviewAgentFunction[] | undefined;
    assessmentDossiers?: AssessementDossier[] | undefined;
    assessmentDossiersAsN1?: AssessementDossier[] | undefined;
    assessmentDossiersAsN2?: AssessementDossier[] | undefined;
    jobInterviewMps?: JobInterview[] | undefined;
    jobInterviewSfes?: JobInterview[] | undefined;
    jobInterviewAsN2?: JobInterview[] | undefined;
    operationalInterviewSfes?: OperationalInterview[] | undefined;
    operationalInterviewMps?: OperationalInterview[] | undefined;
    operationalInterviewAsN2?: OperationalInterview[] | undefined;
    dossierTasks?: DossierTasks[] | undefined;
    functionalDirector?: FunctionalDirector[] | undefined;
    evaluationInterviewSfes?: EvaluationInterview[] | undefined;
    evaluationInterviewAsN2?: EvaluationInterview[] | undefined;

    constructor(data?: IAgent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.sex = _data["sex"];
            this.nationalRegistrationNumber = _data["nationalRegistrationNumber"];
            this.email = _data["email"];
            this.gradeId = _data["gradeId"];
            this.gradeStartDate = _data["gradeStartDate"] ? new Date(_data["gradeStartDate"].toString()) : undefined as any;
            this.cadreId = _data["cadreId"];
            this.gradeStatusId = _data["gradeStatusId"];
            this.gradeSubStatusId = _data["gradeSubStatusId"];
            this.agentN1Id = _data["agentN1Id"];
            this.agentN2Id = _data["agentN2Id"];
            this.assignmentId = _data["assignmentId"];
            this.directionId = _data["directionId"];
            this.mentionId = _data["mentionId"];
            this.isActive = _data["isActive"];
            this.hasSkillCertificate = _data["hasSkillCertificate"];
            this.affectation = _data["affectation"];
            this.lastZhcUpdate = _data["lastZhcUpdate"] ? new Date(_data["lastZhcUpdate"].toString()) : undefined as any;
            this.fullName = _data["fullName"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.agentN1 = _data["agentN1"] ? Agent.fromJS(_data["agentN1"]) : undefined as any;
            this.agentN2 = _data["agentN2"] ? Agent.fromJS(_data["agentN2"]) : undefined as any;
            this.grade = _data["grade"] ? Grade.fromJS(_data["grade"]) : undefined as any;
            this.cadre = _data["cadre"] ? Cadre.fromJS(_data["cadre"]) : undefined as any;
            this.gradeStatus = _data["gradeStatus"] ? GradeStatus.fromJS(_data["gradeStatus"]) : undefined as any;
            this.gradeSubStatus = _data["gradeSubStatus"] ? GradeSubStatus.fromJS(_data["gradeSubStatus"]) : undefined as any;
            this.mention = _data["mention"] ? Mention.fromJS(_data["mention"]) : undefined as any;
            this.direction = _data["direction"] ? FunctionalDirector.fromJS(_data["direction"]) : undefined as any;
            if (Array.isArray(_data["agentFunctions"])) {
                this.agentFunctions = [] as any;
                for (let item of _data["agentFunctions"])
                    this.agentFunctions!.push(AgentFunction.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewAgentFunctions"])) {
                this.jobInterviewAgentFunctions = [] as any;
                for (let item of _data["jobInterviewAgentFunctions"])
                    this.jobInterviewAgentFunctions!.push(JobInterviewAgentFunction.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewAgentFunctions"])) {
                this.operationalInterviewAgentFunctions = [] as any;
                for (let item of _data["operationalInterviewAgentFunctions"])
                    this.operationalInterviewAgentFunctions!.push(OperationalInterviewAgentFunction.fromJS(item));
            }
            if (Array.isArray(_data["assessmentDossiers"])) {
                this.assessmentDossiers = [] as any;
                for (let item of _data["assessmentDossiers"])
                    this.assessmentDossiers!.push(AssessementDossier.fromJS(item));
            }
            if (Array.isArray(_data["assessmentDossiersAsN1"])) {
                this.assessmentDossiersAsN1 = [] as any;
                for (let item of _data["assessmentDossiersAsN1"])
                    this.assessmentDossiersAsN1!.push(AssessementDossier.fromJS(item));
            }
            if (Array.isArray(_data["assessmentDossiersAsN2"])) {
                this.assessmentDossiersAsN2 = [] as any;
                for (let item of _data["assessmentDossiersAsN2"])
                    this.assessmentDossiersAsN2!.push(AssessementDossier.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewMps"])) {
                this.jobInterviewMps = [] as any;
                for (let item of _data["jobInterviewMps"])
                    this.jobInterviewMps!.push(JobInterview.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewSfes"])) {
                this.jobInterviewSfes = [] as any;
                for (let item of _data["jobInterviewSfes"])
                    this.jobInterviewSfes!.push(JobInterview.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewAsN2"])) {
                this.jobInterviewAsN2 = [] as any;
                for (let item of _data["jobInterviewAsN2"])
                    this.jobInterviewAsN2!.push(JobInterview.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewSfes"])) {
                this.operationalInterviewSfes = [] as any;
                for (let item of _data["operationalInterviewSfes"])
                    this.operationalInterviewSfes!.push(OperationalInterview.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewMps"])) {
                this.operationalInterviewMps = [] as any;
                for (let item of _data["operationalInterviewMps"])
                    this.operationalInterviewMps!.push(OperationalInterview.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewAsN2"])) {
                this.operationalInterviewAsN2 = [] as any;
                for (let item of _data["operationalInterviewAsN2"])
                    this.operationalInterviewAsN2!.push(OperationalInterview.fromJS(item));
            }
            if (Array.isArray(_data["dossierTasks"])) {
                this.dossierTasks = [] as any;
                for (let item of _data["dossierTasks"])
                    this.dossierTasks!.push(DossierTasks.fromJS(item));
            }
            if (Array.isArray(_data["functionalDirector"])) {
                this.functionalDirector = [] as any;
                for (let item of _data["functionalDirector"])
                    this.functionalDirector!.push(FunctionalDirector.fromJS(item));
            }
            if (Array.isArray(_data["evaluationInterviewSfes"])) {
                this.evaluationInterviewSfes = [] as any;
                for (let item of _data["evaluationInterviewSfes"])
                    this.evaluationInterviewSfes!.push(EvaluationInterview.fromJS(item));
            }
            if (Array.isArray(_data["evaluationInterviewAsN2"])) {
                this.evaluationInterviewAsN2 = [] as any;
                for (let item of _data["evaluationInterviewAsN2"])
                    this.evaluationInterviewAsN2!.push(EvaluationInterview.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Agent {
        data = typeof data === 'object' ? data : {};
        let result = new Agent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["sex"] = this.sex;
        data["nationalRegistrationNumber"] = this.nationalRegistrationNumber;
        data["email"] = this.email;
        data["gradeId"] = this.gradeId;
        data["gradeStartDate"] = this.gradeStartDate ? this.gradeStartDate.toISOString() : undefined as any;
        data["cadreId"] = this.cadreId;
        data["gradeStatusId"] = this.gradeStatusId;
        data["gradeSubStatusId"] = this.gradeSubStatusId;
        data["agentN1Id"] = this.agentN1Id;
        data["agentN2Id"] = this.agentN2Id;
        data["assignmentId"] = this.assignmentId;
        data["directionId"] = this.directionId;
        data["mentionId"] = this.mentionId;
        data["isActive"] = this.isActive;
        data["hasSkillCertificate"] = this.hasSkillCertificate;
        data["affectation"] = this.affectation;
        data["lastZhcUpdate"] = this.lastZhcUpdate ? this.lastZhcUpdate.toISOString() : undefined as any;
        data["fullName"] = this.fullName;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["agentN1"] = this.agentN1 ? this.agentN1.toJSON() : undefined as any;
        data["agentN2"] = this.agentN2 ? this.agentN2.toJSON() : undefined as any;
        data["grade"] = this.grade ? this.grade.toJSON() : undefined as any;
        data["cadre"] = this.cadre ? this.cadre.toJSON() : undefined as any;
        data["gradeStatus"] = this.gradeStatus ? this.gradeStatus.toJSON() : undefined as any;
        data["gradeSubStatus"] = this.gradeSubStatus ? this.gradeSubStatus.toJSON() : undefined as any;
        data["mention"] = this.mention ? this.mention.toJSON() : undefined as any;
        data["direction"] = this.direction ? this.direction.toJSON() : undefined as any;
        if (Array.isArray(this.agentFunctions)) {
            data["agentFunctions"] = [];
            for (let item of this.agentFunctions)
                data["agentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewAgentFunctions)) {
            data["jobInterviewAgentFunctions"] = [];
            for (let item of this.jobInterviewAgentFunctions)
                data["jobInterviewAgentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewAgentFunctions)) {
            data["operationalInterviewAgentFunctions"] = [];
            for (let item of this.operationalInterviewAgentFunctions)
                data["operationalInterviewAgentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentDossiers)) {
            data["assessmentDossiers"] = [];
            for (let item of this.assessmentDossiers)
                data["assessmentDossiers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentDossiersAsN1)) {
            data["assessmentDossiersAsN1"] = [];
            for (let item of this.assessmentDossiersAsN1)
                data["assessmentDossiersAsN1"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentDossiersAsN2)) {
            data["assessmentDossiersAsN2"] = [];
            for (let item of this.assessmentDossiersAsN2)
                data["assessmentDossiersAsN2"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewMps)) {
            data["jobInterviewMps"] = [];
            for (let item of this.jobInterviewMps)
                data["jobInterviewMps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewSfes)) {
            data["jobInterviewSfes"] = [];
            for (let item of this.jobInterviewSfes)
                data["jobInterviewSfes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewAsN2)) {
            data["jobInterviewAsN2"] = [];
            for (let item of this.jobInterviewAsN2)
                data["jobInterviewAsN2"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewSfes)) {
            data["operationalInterviewSfes"] = [];
            for (let item of this.operationalInterviewSfes)
                data["operationalInterviewSfes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewMps)) {
            data["operationalInterviewMps"] = [];
            for (let item of this.operationalInterviewMps)
                data["operationalInterviewMps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewAsN2)) {
            data["operationalInterviewAsN2"] = [];
            for (let item of this.operationalInterviewAsN2)
                data["operationalInterviewAsN2"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dossierTasks)) {
            data["dossierTasks"] = [];
            for (let item of this.dossierTasks)
                data["dossierTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.functionalDirector)) {
            data["functionalDirector"] = [];
            for (let item of this.functionalDirector)
                data["functionalDirector"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.evaluationInterviewSfes)) {
            data["evaluationInterviewSfes"] = [];
            for (let item of this.evaluationInterviewSfes)
                data["evaluationInterviewSfes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.evaluationInterviewAsN2)) {
            data["evaluationInterviewAsN2"] = [];
            for (let item of this.evaluationInterviewAsN2)
                data["evaluationInterviewAsN2"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Agent {
        const json = this.toJSON();
        let result = new Agent();
        result.init(json);
        return result;
    }
}

export interface IAgent extends IEntity {
    name?: string | undefined;
    firstname?: string | undefined;
    sex?: ESex;
    nationalRegistrationNumber?: string | undefined;
    email?: string | undefined;
    gradeId?: number;
    gradeStartDate?: Date;
    cadreId?: number;
    gradeStatusId?: number;
    gradeSubStatusId?: number | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
    assignmentId?: number | undefined;
    directionId?: number | undefined;
    mentionId?: number | undefined;
    isActive?: boolean;
    hasSkillCertificate?: boolean;
    affectation?: string | undefined;
    lastZhcUpdate?: Date | undefined;
    fullName?: string | undefined;
    user?: User | undefined;
    agentN1?: Agent | undefined;
    agentN2?: Agent | undefined;
    grade?: Grade | undefined;
    cadre?: Cadre | undefined;
    gradeStatus?: GradeStatus | undefined;
    gradeSubStatus?: GradeSubStatus | undefined;
    mention?: Mention | undefined;
    direction?: FunctionalDirector | undefined;
    agentFunctions?: AgentFunction[] | undefined;
    jobInterviewAgentFunctions?: JobInterviewAgentFunction[] | undefined;
    operationalInterviewAgentFunctions?: OperationalInterviewAgentFunction[] | undefined;
    assessmentDossiers?: AssessementDossier[] | undefined;
    assessmentDossiersAsN1?: AssessementDossier[] | undefined;
    assessmentDossiersAsN2?: AssessementDossier[] | undefined;
    jobInterviewMps?: JobInterview[] | undefined;
    jobInterviewSfes?: JobInterview[] | undefined;
    jobInterviewAsN2?: JobInterview[] | undefined;
    operationalInterviewSfes?: OperationalInterview[] | undefined;
    operationalInterviewMps?: OperationalInterview[] | undefined;
    operationalInterviewAsN2?: OperationalInterview[] | undefined;
    dossierTasks?: DossierTasks[] | undefined;
    functionalDirector?: FunctionalDirector[] | undefined;
    evaluationInterviewSfes?: EvaluationInterview[] | undefined;
    evaluationInterviewAsN2?: EvaluationInterview[] | undefined;
}

export class User extends Entity implements IUser {
    login?: string | undefined;
    isActive?: boolean;
    hasApplicationAccess?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    lastConnection?: Date;
    agentId?: number | undefined;
    isGp?: boolean;
    agent?: Agent | undefined;
    userRoles?: UserRole[] | undefined;
    userActions?: UserAction[] | undefined;
    searchCriterias?: SearchCriteria[] | undefined;

    constructor(data?: IUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.login = _data["login"];
            this.isActive = _data["isActive"];
            this.hasApplicationAccess = _data["hasApplicationAccess"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.lastConnection = _data["lastConnection"] ? new Date(_data["lastConnection"].toString()) : undefined as any;
            this.agentId = _data["agentId"];
            this.isGp = _data["isGp"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["userActions"])) {
                this.userActions = [] as any;
                for (let item of _data["userActions"])
                    this.userActions!.push(UserAction.fromJS(item));
            }
            if (Array.isArray(_data["searchCriterias"])) {
                this.searchCriterias = [] as any;
                for (let item of _data["searchCriterias"])
                    this.searchCriterias!.push(SearchCriteria.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["isActive"] = this.isActive;
        data["hasApplicationAccess"] = this.hasApplicationAccess;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["lastConnection"] = this.lastConnection ? this.lastConnection.toISOString() : undefined as any;
        data["agentId"] = this.agentId;
        data["isGp"] = this.isGp;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userActions)) {
            data["userActions"] = [];
            for (let item of this.userActions)
                data["userActions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchCriterias)) {
            data["searchCriterias"] = [];
            for (let item of this.searchCriterias)
                data["searchCriterias"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser extends IEntity {
    login?: string | undefined;
    isActive?: boolean;
    hasApplicationAccess?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    lastConnection?: Date;
    agentId?: number | undefined;
    isGp?: boolean;
    agent?: Agent | undefined;
    userRoles?: UserRole[] | undefined;
    userActions?: UserAction[] | undefined;
    searchCriterias?: SearchCriteria[] | undefined;
}

export class UserRole extends Entity implements IUserRole {
    roleId?: number;
    userId?: number;
    role?: Role | undefined;
    user?: User | undefined;

    constructor(data?: IUserRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roleId = _data["roleId"];
            this.userId = _data["userId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : undefined as any;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
        }
    }

    static override fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["userId"] = this.userId;
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole extends IEntity {
    roleId?: number;
    userId?: number;
    role?: Role | undefined;
    user?: User | undefined;
}

export class Role extends Entity implements IRole {
    code?: UserRoles;
    isActive?: boolean | undefined;
    groupId?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    users?: User[] | undefined;
    actionRoles?: ActionRole[] | undefined;
    userRoles?: UserRole[] | undefined;

    constructor(data?: IRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.isActive = _data["isActive"];
            this.groupId = _data["groupId"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["actionRoles"])) {
                this.actionRoles = [] as any;
                for (let item of _data["actionRoles"])
                    this.actionRoles!.push(ActionRole.fromJS(item));
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["groupId"] = this.groupId;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.actionRoles)) {
            data["actionRoles"] = [];
            for (let item of this.actionRoles)
                data["actionRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Role {
        const json = this.toJSON();
        let result = new Role();
        result.init(json);
        return result;
    }
}

export interface IRole extends IEntity {
    code?: UserRoles;
    isActive?: boolean | undefined;
    groupId?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    users?: User[] | undefined;
    actionRoles?: ActionRole[] | undefined;
    userRoles?: UserRole[] | undefined;
}

export class ActionRole extends Entity implements IActionRole {
    roleId?: number;
    actionId?: number;
    role?: Role | undefined;
    action?: Action | undefined;

    constructor(data?: IActionRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roleId = _data["roleId"];
            this.actionId = _data["actionId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : undefined as any;
            this.action = _data["action"] ? Action.fromJS(_data["action"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ActionRole {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRole();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["actionId"] = this.actionId;
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        data["action"] = this.action ? this.action.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionRole {
        const json = this.toJSON();
        let result = new ActionRole();
        result.init(json);
        return result;
    }
}

export interface IActionRole extends IEntity {
    roleId?: number;
    actionId?: number;
    role?: Role | undefined;
    action?: Action | undefined;
}

export class Action extends Entity implements IAction {
    code?: ActionCode;
    actionRoles?: ActionRole[] | undefined;
    actionGroupId?: number | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    actionGroup?: ActionGroup | undefined;
    userActions?: UserAction[] | undefined;

    constructor(data?: IAction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            if (Array.isArray(_data["actionRoles"])) {
                this.actionRoles = [] as any;
                for (let item of _data["actionRoles"])
                    this.actionRoles!.push(ActionRole.fromJS(item));
            }
            this.actionGroupId = _data["actionGroupId"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.actionGroup = _data["actionGroup"] ? ActionGroup.fromJS(_data["actionGroup"]) : undefined as any;
            if (Array.isArray(_data["userActions"])) {
                this.userActions = [] as any;
                for (let item of _data["userActions"])
                    this.userActions!.push(UserAction.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Action {
        data = typeof data === 'object' ? data : {};
        let result = new Action();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (Array.isArray(this.actionRoles)) {
            data["actionRoles"] = [];
            for (let item of this.actionRoles)
                data["actionRoles"].push(item ? item.toJSON() : undefined as any);
        }
        data["actionGroupId"] = this.actionGroupId;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["actionGroup"] = this.actionGroup ? this.actionGroup.toJSON() : undefined as any;
        if (Array.isArray(this.userActions)) {
            data["userActions"] = [];
            for (let item of this.userActions)
                data["userActions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Action {
        const json = this.toJSON();
        let result = new Action();
        result.init(json);
        return result;
    }
}

export interface IAction extends IEntity {
    code?: ActionCode;
    actionRoles?: ActionRole[] | undefined;
    actionGroupId?: number | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    actionGroup?: ActionGroup | undefined;
    userActions?: UserAction[] | undefined;
}

export class ActionGroup extends Entity implements IActionGroup {
    parentActionGroupId?: number | undefined;
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    parentActionGroup?: ActionGroup | undefined;
    childActionGroups?: ActionGroup[] | undefined;
    actions?: Action[] | undefined;

    constructor(data?: IActionGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentActionGroupId = _data["parentActionGroupId"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.parentActionGroup = _data["parentActionGroup"] ? ActionGroup.fromJS(_data["parentActionGroup"]) : undefined as any;
            if (Array.isArray(_data["childActionGroups"])) {
                this.childActionGroups = [] as any;
                for (let item of _data["childActionGroups"])
                    this.childActionGroups!.push(ActionGroup.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(Action.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ActionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentActionGroupId"] = this.parentActionGroupId;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["parentActionGroup"] = this.parentActionGroup ? this.parentActionGroup.toJSON() : undefined as any;
        if (Array.isArray(this.childActionGroups)) {
            data["childActionGroups"] = [];
            for (let item of this.childActionGroups)
                data["childActionGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ActionGroup {
        const json = this.toJSON();
        let result = new ActionGroup();
        result.init(json);
        return result;
    }
}

export interface IActionGroup extends IEntity {
    parentActionGroupId?: number | undefined;
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    parentActionGroup?: ActionGroup | undefined;
    childActionGroups?: ActionGroup[] | undefined;
    actions?: Action[] | undefined;
}

export class UserAction extends Entity implements IUserAction {
    userId?: number;
    actionId?: number;
    authorizationCode?: AuthorizationCode;
    user?: User | undefined;
    action?: Action | undefined;

    constructor(data?: IUserAction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.actionId = _data["actionId"];
            this.authorizationCode = _data["authorizationCode"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.action = _data["action"] ? Action.fromJS(_data["action"]) : undefined as any;
        }
    }

    static override fromJS(data: any): UserAction {
        data = typeof data === 'object' ? data : {};
        let result = new UserAction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["actionId"] = this.actionId;
        data["authorizationCode"] = this.authorizationCode;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["action"] = this.action ? this.action.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): UserAction {
        const json = this.toJSON();
        let result = new UserAction();
        result.init(json);
        return result;
    }
}

export interface IUserAction extends IEntity {
    userId?: number;
    actionId?: number;
    authorizationCode?: AuthorizationCode;
    user?: User | undefined;
    action?: Action | undefined;
}

export enum AuthorizationCode {
    Allow = "Allow",
    Deny = "Deny",
}

export class SearchCriteria extends Entity implements ISearchCriteria {
    searchName?: string | undefined;
    jsonCriteria?: string | undefined;
    userId?: number | undefined;
    advanced?: boolean;
    user?: User | undefined;

    constructor(data?: ISearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchName = _data["searchName"];
            this.jsonCriteria = _data["jsonCriteria"];
            this.userId = _data["userId"];
            this.advanced = _data["advanced"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
        }
    }

    static override fromJS(data: any): SearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchName"] = this.searchName;
        data["jsonCriteria"] = this.jsonCriteria;
        data["userId"] = this.userId;
        data["advanced"] = this.advanced;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): SearchCriteria {
        const json = this.toJSON();
        let result = new SearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchCriteria extends IEntity {
    searchName?: string | undefined;
    jsonCriteria?: string | undefined;
    userId?: number | undefined;
    advanced?: boolean;
    user?: User | undefined;
}

export class Grade extends Entity implements IGrade {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    agents?: Agent[] | undefined;
    gradeCompetences?: GradeCompetence[] | undefined;
    gradeFunctions?: GradeFunction[] | undefined;
    formQuestionOperationals?: FormQuestionOperational[] | undefined;

    constructor(data?: IGrade) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(Agent.fromJS(item));
            }
            if (Array.isArray(_data["gradeCompetences"])) {
                this.gradeCompetences = [] as any;
                for (let item of _data["gradeCompetences"])
                    this.gradeCompetences!.push(GradeCompetence.fromJS(item));
            }
            if (Array.isArray(_data["gradeFunctions"])) {
                this.gradeFunctions = [] as any;
                for (let item of _data["gradeFunctions"])
                    this.gradeFunctions!.push(GradeFunction.fromJS(item));
            }
            if (Array.isArray(_data["formQuestionOperationals"])) {
                this.formQuestionOperationals = [] as any;
                for (let item of _data["formQuestionOperationals"])
                    this.formQuestionOperationals!.push(FormQuestionOperational.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Grade {
        data = typeof data === 'object' ? data : {};
        let result = new Grade();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gradeCompetences)) {
            data["gradeCompetences"] = [];
            for (let item of this.gradeCompetences)
                data["gradeCompetences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gradeFunctions)) {
            data["gradeFunctions"] = [];
            for (let item of this.gradeFunctions)
                data["gradeFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formQuestionOperationals)) {
            data["formQuestionOperationals"] = [];
            for (let item of this.formQuestionOperationals)
                data["formQuestionOperationals"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Grade {
        const json = this.toJSON();
        let result = new Grade();
        result.init(json);
        return result;
    }
}

export interface IGrade extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    agents?: Agent[] | undefined;
    gradeCompetences?: GradeCompetence[] | undefined;
    gradeFunctions?: GradeFunction[] | undefined;
    formQuestionOperationals?: FormQuestionOperational[] | undefined;
}

export class GradeCompetence extends Entity implements IGradeCompetence {
    competenceId?: number;
    gradeId?: number;
    level?: ELevel;
    isActive?: boolean;
    grade?: Grade | undefined;
    competence?: Competence | undefined;

    constructor(data?: IGradeCompetence) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.competenceId = _data["competenceId"];
            this.gradeId = _data["gradeId"];
            this.level = _data["level"];
            this.isActive = _data["isActive"];
            this.grade = _data["grade"] ? Grade.fromJS(_data["grade"]) : undefined as any;
            this.competence = _data["competence"] ? Competence.fromJS(_data["competence"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GradeCompetence {
        data = typeof data === 'object' ? data : {};
        let result = new GradeCompetence();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competenceId"] = this.competenceId;
        data["gradeId"] = this.gradeId;
        data["level"] = this.level;
        data["isActive"] = this.isActive;
        data["grade"] = this.grade ? this.grade.toJSON() : undefined as any;
        data["competence"] = this.competence ? this.competence.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): GradeCompetence {
        const json = this.toJSON();
        let result = new GradeCompetence();
        result.init(json);
        return result;
    }
}

export interface IGradeCompetence extends IEntity {
    competenceId?: number;
    gradeId?: number;
    level?: ELevel;
    isActive?: boolean;
    grade?: Grade | undefined;
    competence?: Competence | undefined;
}

export enum ELevel {
    Pda = "Pda",
    Un = "Un",
    Deux = "Deux",
    Trois = "Trois",
}

export class Competence extends Entity implements ICompetence {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    subCompetences?: SubCompetence[] | undefined;
    evaluationInterviewCompetences?: EvaluationInterviewCompetence[] | undefined;
    gradeCompetences?: GradeCompetence[] | undefined;

    constructor(data?: ICompetence) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["subCompetences"])) {
                this.subCompetences = [] as any;
                for (let item of _data["subCompetences"])
                    this.subCompetences!.push(SubCompetence.fromJS(item));
            }
            if (Array.isArray(_data["evaluationInterviewCompetences"])) {
                this.evaluationInterviewCompetences = [] as any;
                for (let item of _data["evaluationInterviewCompetences"])
                    this.evaluationInterviewCompetences!.push(EvaluationInterviewCompetence.fromJS(item));
            }
            if (Array.isArray(_data["gradeCompetences"])) {
                this.gradeCompetences = [] as any;
                for (let item of _data["gradeCompetences"])
                    this.gradeCompetences!.push(GradeCompetence.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Competence {
        data = typeof data === 'object' ? data : {};
        let result = new Competence();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.subCompetences)) {
            data["subCompetences"] = [];
            for (let item of this.subCompetences)
                data["subCompetences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.evaluationInterviewCompetences)) {
            data["evaluationInterviewCompetences"] = [];
            for (let item of this.evaluationInterviewCompetences)
                data["evaluationInterviewCompetences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gradeCompetences)) {
            data["gradeCompetences"] = [];
            for (let item of this.gradeCompetences)
                data["gradeCompetences"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Competence {
        const json = this.toJSON();
        let result = new Competence();
        result.init(json);
        return result;
    }
}

export interface ICompetence extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    subCompetences?: SubCompetence[] | undefined;
    evaluationInterviewCompetences?: EvaluationInterviewCompetence[] | undefined;
    gradeCompetences?: GradeCompetence[] | undefined;
}

export class SubCompetence extends Entity implements ISubCompetence {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    competenceId?: number;
    competence?: Competence | undefined;
    evaluationInterviewSubCompetences?: EvaluationInterviewSubCompetence[] | undefined;

    constructor(data?: ISubCompetence) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.competenceId = _data["competenceId"];
            this.competence = _data["competence"] ? Competence.fromJS(_data["competence"]) : undefined as any;
            if (Array.isArray(_data["evaluationInterviewSubCompetences"])) {
                this.evaluationInterviewSubCompetences = [] as any;
                for (let item of _data["evaluationInterviewSubCompetences"])
                    this.evaluationInterviewSubCompetences!.push(EvaluationInterviewSubCompetence.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SubCompetence {
        data = typeof data === 'object' ? data : {};
        let result = new SubCompetence();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["competenceId"] = this.competenceId;
        data["competence"] = this.competence ? this.competence.toJSON() : undefined as any;
        if (Array.isArray(this.evaluationInterviewSubCompetences)) {
            data["evaluationInterviewSubCompetences"] = [];
            for (let item of this.evaluationInterviewSubCompetences)
                data["evaluationInterviewSubCompetences"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): SubCompetence {
        const json = this.toJSON();
        let result = new SubCompetence();
        result.init(json);
        return result;
    }
}

export interface ISubCompetence extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    competenceId?: number;
    competence?: Competence | undefined;
    evaluationInterviewSubCompetences?: EvaluationInterviewSubCompetence[] | undefined;
}

export class EvaluationInterviewSubCompetence extends Entity implements IEvaluationInterviewSubCompetence {
    code?: string | undefined;
    title?: string | undefined;
    canBeEdited?: boolean;
    evaluationInterviewCompetenceId?: number;
    level?: ELevel | undefined;
    evaluation?: EEvaluation | undefined;
    evaluationInterviewCompetence?: EvaluationInterviewCompetence | undefined;

    constructor(data?: IEvaluationInterviewSubCompetence) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.title = _data["title"];
            this.canBeEdited = _data["canBeEdited"];
            this.evaluationInterviewCompetenceId = _data["evaluationInterviewCompetenceId"];
            this.level = _data["level"];
            this.evaluation = _data["evaluation"];
            this.evaluationInterviewCompetence = _data["evaluationInterviewCompetence"] ? EvaluationInterviewCompetence.fromJS(_data["evaluationInterviewCompetence"]) : undefined as any;
        }
    }

    static override fromJS(data: any): EvaluationInterviewSubCompetence {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInterviewSubCompetence();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["title"] = this.title;
        data["canBeEdited"] = this.canBeEdited;
        data["evaluationInterviewCompetenceId"] = this.evaluationInterviewCompetenceId;
        data["level"] = this.level;
        data["evaluation"] = this.evaluation;
        data["evaluationInterviewCompetence"] = this.evaluationInterviewCompetence ? this.evaluationInterviewCompetence.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EvaluationInterviewSubCompetence {
        const json = this.toJSON();
        let result = new EvaluationInterviewSubCompetence();
        result.init(json);
        return result;
    }
}

export interface IEvaluationInterviewSubCompetence extends IEntity {
    code?: string | undefined;
    title?: string | undefined;
    canBeEdited?: boolean;
    evaluationInterviewCompetenceId?: number;
    level?: ELevel | undefined;
    evaluation?: EEvaluation | undefined;
    evaluationInterviewCompetence?: EvaluationInterviewCompetence | undefined;
}

export enum EEvaluation {
    Moins = "Moins",
    Plus = "Plus",
    PlusPlus = "PlusPlus",
    PlusPlusPlus = "PlusPlusPlus",
    Pda = "Pda",
}

export class EvaluationInterviewCompetence extends Entity implements IEvaluationInterviewCompetence {
    competenceId?: number;
    evaluationInterviewId?: number;
    level?: ELevel | undefined;
    evaluation?: EEvaluation | undefined;
    competence?: Competence | undefined;
    evaluationInterview?: EvaluationInterview | undefined;
    evaluationInterviewSubCompetences?: EvaluationInterviewSubCompetence[] | undefined;

    constructor(data?: IEvaluationInterviewCompetence) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.competenceId = _data["competenceId"];
            this.evaluationInterviewId = _data["evaluationInterviewId"];
            this.level = _data["level"];
            this.evaluation = _data["evaluation"];
            this.competence = _data["competence"] ? Competence.fromJS(_data["competence"]) : undefined as any;
            this.evaluationInterview = _data["evaluationInterview"] ? EvaluationInterview.fromJS(_data["evaluationInterview"]) : undefined as any;
            if (Array.isArray(_data["evaluationInterviewSubCompetences"])) {
                this.evaluationInterviewSubCompetences = [] as any;
                for (let item of _data["evaluationInterviewSubCompetences"])
                    this.evaluationInterviewSubCompetences!.push(EvaluationInterviewSubCompetence.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EvaluationInterviewCompetence {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInterviewCompetence();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competenceId"] = this.competenceId;
        data["evaluationInterviewId"] = this.evaluationInterviewId;
        data["level"] = this.level;
        data["evaluation"] = this.evaluation;
        data["competence"] = this.competence ? this.competence.toJSON() : undefined as any;
        data["evaluationInterview"] = this.evaluationInterview ? this.evaluationInterview.toJSON() : undefined as any;
        if (Array.isArray(this.evaluationInterviewSubCompetences)) {
            data["evaluationInterviewSubCompetences"] = [];
            for (let item of this.evaluationInterviewSubCompetences)
                data["evaluationInterviewSubCompetences"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EvaluationInterviewCompetence {
        const json = this.toJSON();
        let result = new EvaluationInterviewCompetence();
        result.init(json);
        return result;
    }
}

export interface IEvaluationInterviewCompetence extends IEntity {
    competenceId?: number;
    evaluationInterviewId?: number;
    level?: ELevel | undefined;
    evaluation?: EEvaluation | undefined;
    competence?: Competence | undefined;
    evaluationInterview?: EvaluationInterview | undefined;
    evaluationInterviewSubCompetences?: EvaluationInterviewSubCompetence[] | undefined;
}

export class EvaluationInterview extends Entity implements IEvaluationInterview {
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    date?: Date | undefined;
    assessementDossierId?: number;
    mentionId?: number | undefined;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    strength?: string | undefined;
    weakness?: string | undefined;
    conclusion?: string | undefined;
    sfe?: Agent | undefined;
    agentN2?: Agent | undefined;
    assessementDossier?: AssessementDossier | undefined;
    mention?: Mention | undefined;
    evaluationInterviewObjectiveQuestions?: EvaluationInterviewObjectiveQuestion[] | undefined;
    evaluationInterviewCompetences?: EvaluationInterviewCompetence[] | undefined;

    constructor(data?: IEvaluationInterview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sfeId = _data["sfeId"];
            this.agentN2Id = _data["agentN2Id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.assessementDossierId = _data["assessementDossierId"];
            this.mentionId = _data["mentionId"];
            this.sfeSignatureDate = _data["sfeSignatureDate"] ? new Date(_data["sfeSignatureDate"].toString()) : undefined as any;
            this.mpSignatureDate = _data["mpSignatureDate"] ? new Date(_data["mpSignatureDate"].toString()) : undefined as any;
            this.nPlus2VisaDate = _data["nPlus2VisaDate"] ? new Date(_data["nPlus2VisaDate"].toString()) : undefined as any;
            this.strength = _data["strength"];
            this.weakness = _data["weakness"];
            this.conclusion = _data["conclusion"];
            this.sfe = _data["sfe"] ? Agent.fromJS(_data["sfe"]) : undefined as any;
            this.agentN2 = _data["agentN2"] ? Agent.fromJS(_data["agentN2"]) : undefined as any;
            this.assessementDossier = _data["assessementDossier"] ? AssessementDossier.fromJS(_data["assessementDossier"]) : undefined as any;
            this.mention = _data["mention"] ? Mention.fromJS(_data["mention"]) : undefined as any;
            if (Array.isArray(_data["evaluationInterviewObjectiveQuestions"])) {
                this.evaluationInterviewObjectiveQuestions = [] as any;
                for (let item of _data["evaluationInterviewObjectiveQuestions"])
                    this.evaluationInterviewObjectiveQuestions!.push(EvaluationInterviewObjectiveQuestion.fromJS(item));
            }
            if (Array.isArray(_data["evaluationInterviewCompetences"])) {
                this.evaluationInterviewCompetences = [] as any;
                for (let item of _data["evaluationInterviewCompetences"])
                    this.evaluationInterviewCompetences!.push(EvaluationInterviewCompetence.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EvaluationInterview {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInterview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sfeId"] = this.sfeId;
        data["agentN2Id"] = this.agentN2Id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["assessementDossierId"] = this.assessementDossierId;
        data["mentionId"] = this.mentionId;
        data["sfeSignatureDate"] = this.sfeSignatureDate ? this.sfeSignatureDate.toISOString() : undefined as any;
        data["mpSignatureDate"] = this.mpSignatureDate ? this.mpSignatureDate.toISOString() : undefined as any;
        data["nPlus2VisaDate"] = this.nPlus2VisaDate ? this.nPlus2VisaDate.toISOString() : undefined as any;
        data["strength"] = this.strength;
        data["weakness"] = this.weakness;
        data["conclusion"] = this.conclusion;
        data["sfe"] = this.sfe ? this.sfe.toJSON() : undefined as any;
        data["agentN2"] = this.agentN2 ? this.agentN2.toJSON() : undefined as any;
        data["assessementDossier"] = this.assessementDossier ? this.assessementDossier.toJSON() : undefined as any;
        data["mention"] = this.mention ? this.mention.toJSON() : undefined as any;
        if (Array.isArray(this.evaluationInterviewObjectiveQuestions)) {
            data["evaluationInterviewObjectiveQuestions"] = [];
            for (let item of this.evaluationInterviewObjectiveQuestions)
                data["evaluationInterviewObjectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.evaluationInterviewCompetences)) {
            data["evaluationInterviewCompetences"] = [];
            for (let item of this.evaluationInterviewCompetences)
                data["evaluationInterviewCompetences"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EvaluationInterview {
        const json = this.toJSON();
        let result = new EvaluationInterview();
        result.init(json);
        return result;
    }
}

export interface IEvaluationInterview extends IEntity {
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    date?: Date | undefined;
    assessementDossierId?: number;
    mentionId?: number | undefined;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    strength?: string | undefined;
    weakness?: string | undefined;
    conclusion?: string | undefined;
    sfe?: Agent | undefined;
    agentN2?: Agent | undefined;
    assessementDossier?: AssessementDossier | undefined;
    mention?: Mention | undefined;
    evaluationInterviewObjectiveQuestions?: EvaluationInterviewObjectiveQuestion[] | undefined;
    evaluationInterviewCompetences?: EvaluationInterviewCompetence[] | undefined;
}

export class Mention extends Entity implements IMention {
    code?: EMention;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    isActive?: boolean;
    agents?: Agent[] | undefined;
    assessmentDossiers?: AssessementDossier[] | undefined;
    evaluationInterviews?: EvaluationInterview[] | undefined;

    constructor(data?: IMention) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(Agent.fromJS(item));
            }
            if (Array.isArray(_data["assessmentDossiers"])) {
                this.assessmentDossiers = [] as any;
                for (let item of _data["assessmentDossiers"])
                    this.assessmentDossiers!.push(AssessementDossier.fromJS(item));
            }
            if (Array.isArray(_data["evaluationInterviews"])) {
                this.evaluationInterviews = [] as any;
                for (let item of _data["evaluationInterviews"])
                    this.evaluationInterviews!.push(EvaluationInterview.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Mention {
        data = typeof data === 'object' ? data : {};
        let result = new Mention();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentDossiers)) {
            data["assessmentDossiers"] = [];
            for (let item of this.assessmentDossiers)
                data["assessmentDossiers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.evaluationInterviews)) {
            data["evaluationInterviews"] = [];
            for (let item of this.evaluationInterviews)
                data["evaluationInterviews"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Mention {
        const json = this.toJSON();
        let result = new Mention();
        result.init(json);
        return result;
    }
}

export interface IMention extends IEntity {
    code?: EMention;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    isActive?: boolean;
    agents?: Agent[] | undefined;
    assessmentDossiers?: AssessementDossier[] | undefined;
    evaluationInterviews?: EvaluationInterview[] | undefined;
}

export enum EMention {
    Insatisfaisant = "Insatisfaisant",
    AAmeliorer = "AAmeliorer",
    Satisfaisant = "Satisfaisant",
    Bien = "Bien",
    TresBien = "TresBien",
}

export class EvaluationInterviewObjectiveQuestion extends Entity implements IEvaluationInterviewObjectiveQuestion {
    evaluationInterviewId?: number;
    objectiveQuestionId?: number;
    title?: string | undefined;
    evaluationInterview?: EvaluationInterview | undefined;
    objectiveQuestion?: ObjectiveQuestion | undefined;

    constructor(data?: IEvaluationInterviewObjectiveQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.evaluationInterviewId = _data["evaluationInterviewId"];
            this.objectiveQuestionId = _data["objectiveQuestionId"];
            this.title = _data["title"];
            this.evaluationInterview = _data["evaluationInterview"] ? EvaluationInterview.fromJS(_data["evaluationInterview"]) : undefined as any;
            this.objectiveQuestion = _data["objectiveQuestion"] ? ObjectiveQuestion.fromJS(_data["objectiveQuestion"]) : undefined as any;
        }
    }

    static override fromJS(data: any): EvaluationInterviewObjectiveQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInterviewObjectiveQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationInterviewId"] = this.evaluationInterviewId;
        data["objectiveQuestionId"] = this.objectiveQuestionId;
        data["title"] = this.title;
        data["evaluationInterview"] = this.evaluationInterview ? this.evaluationInterview.toJSON() : undefined as any;
        data["objectiveQuestion"] = this.objectiveQuestion ? this.objectiveQuestion.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EvaluationInterviewObjectiveQuestion {
        const json = this.toJSON();
        let result = new EvaluationInterviewObjectiveQuestion();
        result.init(json);
        return result;
    }
}

export interface IEvaluationInterviewObjectiveQuestion extends IEntity {
    evaluationInterviewId?: number;
    objectiveQuestionId?: number;
    title?: string | undefined;
    evaluationInterview?: EvaluationInterview | undefined;
    objectiveQuestion?: ObjectiveQuestion | undefined;
}

export class ObjectiveQuestion extends Entity implements IObjectiveQuestion {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    canBeEdited?: boolean;
    isActive?: boolean;
    formTypeId?: number | undefined;
    formType?: FormType | undefined;
    jobInterviewObjectiveQuestions?: JobInterviewObjectiveQuestion[] | undefined;
    operationalInterviewObjectiveQuestions?: OperationalInterviewObjectiveQuestion[] | undefined;
    evaluationInterviewObjectiveQuestions?: EvaluationInterviewObjectiveQuestion[] | undefined;

    constructor(data?: IObjectiveQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.canBeEdited = _data["canBeEdited"];
            this.isActive = _data["isActive"];
            this.formTypeId = _data["formTypeId"];
            this.formType = _data["formType"] ? FormType.fromJS(_data["formType"]) : undefined as any;
            if (Array.isArray(_data["jobInterviewObjectiveQuestions"])) {
                this.jobInterviewObjectiveQuestions = [] as any;
                for (let item of _data["jobInterviewObjectiveQuestions"])
                    this.jobInterviewObjectiveQuestions!.push(JobInterviewObjectiveQuestion.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewObjectiveQuestions"])) {
                this.operationalInterviewObjectiveQuestions = [] as any;
                for (let item of _data["operationalInterviewObjectiveQuestions"])
                    this.operationalInterviewObjectiveQuestions!.push(OperationalInterviewObjectiveQuestion.fromJS(item));
            }
            if (Array.isArray(_data["evaluationInterviewObjectiveQuestions"])) {
                this.evaluationInterviewObjectiveQuestions = [] as any;
                for (let item of _data["evaluationInterviewObjectiveQuestions"])
                    this.evaluationInterviewObjectiveQuestions!.push(EvaluationInterviewObjectiveQuestion.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ObjectiveQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["canBeEdited"] = this.canBeEdited;
        data["isActive"] = this.isActive;
        data["formTypeId"] = this.formTypeId;
        data["formType"] = this.formType ? this.formType.toJSON() : undefined as any;
        if (Array.isArray(this.jobInterviewObjectiveQuestions)) {
            data["jobInterviewObjectiveQuestions"] = [];
            for (let item of this.jobInterviewObjectiveQuestions)
                data["jobInterviewObjectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewObjectiveQuestions)) {
            data["operationalInterviewObjectiveQuestions"] = [];
            for (let item of this.operationalInterviewObjectiveQuestions)
                data["operationalInterviewObjectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.evaluationInterviewObjectiveQuestions)) {
            data["evaluationInterviewObjectiveQuestions"] = [];
            for (let item of this.evaluationInterviewObjectiveQuestions)
                data["evaluationInterviewObjectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ObjectiveQuestion {
        const json = this.toJSON();
        let result = new ObjectiveQuestion();
        result.init(json);
        return result;
    }
}

export interface IObjectiveQuestion extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    canBeEdited?: boolean;
    isActive?: boolean;
    formTypeId?: number | undefined;
    formType?: FormType | undefined;
    jobInterviewObjectiveQuestions?: JobInterviewObjectiveQuestion[] | undefined;
    operationalInterviewObjectiveQuestions?: OperationalInterviewObjectiveQuestion[] | undefined;
    evaluationInterviewObjectiveQuestions?: EvaluationInterviewObjectiveQuestion[] | undefined;
}

export class FormType extends Entity implements IFormType {
    code?: EFormType;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    objectiveQuestions?: ObjectiveQuestion[] | undefined;

    constructor(data?: IFormType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["objectiveQuestions"])) {
                this.objectiveQuestions = [] as any;
                for (let item of _data["objectiveQuestions"])
                    this.objectiveQuestions!.push(ObjectiveQuestion.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FormType {
        data = typeof data === 'object' ? data : {};
        let result = new FormType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.objectiveQuestions)) {
            data["objectiveQuestions"] = [];
            for (let item of this.objectiveQuestions)
                data["objectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FormType {
        const json = this.toJSON();
        let result = new FormType();
        result.init(json);
        return result;
    }
}

export interface IFormType extends IEntity {
    code?: EFormType;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    objectiveQuestions?: ObjectiveQuestion[] | undefined;
}

export enum EFormType {
    Fonction = "Fonction",
    Fonctionnement = "Fonctionnement",
    Evaluation = "Evaluation",
}

export class JobInterviewObjectiveQuestion extends Entity implements IJobInterviewObjectiveQuestion {
    jobInterviewId?: number;
    objectiveQuestionId?: number;
    title?: string | undefined;
    who?: string | undefined;
    delay?: string | undefined;
    jobInterview?: JobInterview | undefined;
    objectiveQuestion?: ObjectiveQuestion | undefined;

    constructor(data?: IJobInterviewObjectiveQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobInterviewId = _data["jobInterviewId"];
            this.objectiveQuestionId = _data["objectiveQuestionId"];
            this.title = _data["title"];
            this.who = _data["who"];
            this.delay = _data["delay"];
            this.jobInterview = _data["jobInterview"] ? JobInterview.fromJS(_data["jobInterview"]) : undefined as any;
            this.objectiveQuestion = _data["objectiveQuestion"] ? ObjectiveQuestion.fromJS(_data["objectiveQuestion"]) : undefined as any;
        }
    }

    static override fromJS(data: any): JobInterviewObjectiveQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewObjectiveQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobInterviewId"] = this.jobInterviewId;
        data["objectiveQuestionId"] = this.objectiveQuestionId;
        data["title"] = this.title;
        data["who"] = this.who;
        data["delay"] = this.delay;
        data["jobInterview"] = this.jobInterview ? this.jobInterview.toJSON() : undefined as any;
        data["objectiveQuestion"] = this.objectiveQuestion ? this.objectiveQuestion.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): JobInterviewObjectiveQuestion {
        const json = this.toJSON();
        let result = new JobInterviewObjectiveQuestion();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewObjectiveQuestion extends IEntity {
    jobInterviewId?: number;
    objectiveQuestionId?: number;
    title?: string | undefined;
    who?: string | undefined;
    delay?: string | undefined;
    jobInterview?: JobInterview | undefined;
    objectiveQuestion?: ObjectiveQuestion | undefined;
}

export class OperationalInterviewObjectiveQuestion extends Entity implements IOperationalInterviewObjectiveQuestion {
    operationalInterviewId?: number;
    objectiveQuestionId?: number;
    title?: string | undefined;
    who?: string | undefined;
    delay?: string | undefined;
    operationalInterview?: OperationalInterview | undefined;
    objectiveQuestion?: ObjectiveQuestion | undefined;

    constructor(data?: IOperationalInterviewObjectiveQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operationalInterviewId = _data["operationalInterviewId"];
            this.objectiveQuestionId = _data["objectiveQuestionId"];
            this.title = _data["title"];
            this.who = _data["who"];
            this.delay = _data["delay"];
            this.operationalInterview = _data["operationalInterview"] ? OperationalInterview.fromJS(_data["operationalInterview"]) : undefined as any;
            this.objectiveQuestion = _data["objectiveQuestion"] ? ObjectiveQuestion.fromJS(_data["objectiveQuestion"]) : undefined as any;
        }
    }

    static override fromJS(data: any): OperationalInterviewObjectiveQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewObjectiveQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalInterviewId"] = this.operationalInterviewId;
        data["objectiveQuestionId"] = this.objectiveQuestionId;
        data["title"] = this.title;
        data["who"] = this.who;
        data["delay"] = this.delay;
        data["operationalInterview"] = this.operationalInterview ? this.operationalInterview.toJSON() : undefined as any;
        data["objectiveQuestion"] = this.objectiveQuestion ? this.objectiveQuestion.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): OperationalInterviewObjectiveQuestion {
        const json = this.toJSON();
        let result = new OperationalInterviewObjectiveQuestion();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewObjectiveQuestion extends IEntity {
    operationalInterviewId?: number;
    objectiveQuestionId?: number;
    title?: string | undefined;
    who?: string | undefined;
    delay?: string | undefined;
    operationalInterview?: OperationalInterview | undefined;
    objectiveQuestion?: ObjectiveQuestion | undefined;
}

export class OperationalInterview extends Entity implements IOperationalInterview {
    date?: Date | undefined;
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    mpId?: number;
    dossierId?: number;
    number?: number;
    askingAgentId?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterview[] | undefined;
    operationalInterviewAgentFunctions?: OperationalInterviewAgentFunction[] | undefined;
    operationalInterviewSpecificSubjects?: OperationalInterviewSpecificSubject[] | undefined;
    operationalInterviewObjectiveQuestions?: OperationalInterviewObjectiveQuestion[] | undefined;
    sfe?: Agent | undefined;
    agentN2?: Agent | undefined;
    mp?: Agent | undefined;
    askingAgent?: Agent | undefined;
    dossier?: AssessementDossier | undefined;

    constructor(data?: IOperationalInterview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.sfeId = _data["sfeId"];
            this.agentN2Id = _data["agentN2Id"];
            this.mpId = _data["mpId"];
            this.dossierId = _data["dossierId"];
            this.number = _data["number"];
            this.askingAgentId = _data["askingAgentId"];
            this.sfeSignatureDate = _data["sfeSignatureDate"] ? new Date(_data["sfeSignatureDate"].toString()) : undefined as any;
            this.mpSignatureDate = _data["mpSignatureDate"] ? new Date(_data["mpSignatureDate"].toString()) : undefined as any;
            this.nPlus2VisaDate = _data["nPlus2VisaDate"] ? new Date(_data["nPlus2VisaDate"].toString()) : undefined as any;
            if (Array.isArray(_data["formQuestionOperationalInterviews"])) {
                this.formQuestionOperationalInterviews = [] as any;
                for (let item of _data["formQuestionOperationalInterviews"])
                    this.formQuestionOperationalInterviews!.push(FormQuestionOperationalInterview.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewAgentFunctions"])) {
                this.operationalInterviewAgentFunctions = [] as any;
                for (let item of _data["operationalInterviewAgentFunctions"])
                    this.operationalInterviewAgentFunctions!.push(OperationalInterviewAgentFunction.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewSpecificSubjects"])) {
                this.operationalInterviewSpecificSubjects = [] as any;
                for (let item of _data["operationalInterviewSpecificSubjects"])
                    this.operationalInterviewSpecificSubjects!.push(OperationalInterviewSpecificSubject.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewObjectiveQuestions"])) {
                this.operationalInterviewObjectiveQuestions = [] as any;
                for (let item of _data["operationalInterviewObjectiveQuestions"])
                    this.operationalInterviewObjectiveQuestions!.push(OperationalInterviewObjectiveQuestion.fromJS(item));
            }
            this.sfe = _data["sfe"] ? Agent.fromJS(_data["sfe"]) : undefined as any;
            this.agentN2 = _data["agentN2"] ? Agent.fromJS(_data["agentN2"]) : undefined as any;
            this.mp = _data["mp"] ? Agent.fromJS(_data["mp"]) : undefined as any;
            this.askingAgent = _data["askingAgent"] ? Agent.fromJS(_data["askingAgent"]) : undefined as any;
            this.dossier = _data["dossier"] ? AssessementDossier.fromJS(_data["dossier"]) : undefined as any;
        }
    }

    static override fromJS(data: any): OperationalInterview {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["sfeId"] = this.sfeId;
        data["agentN2Id"] = this.agentN2Id;
        data["mpId"] = this.mpId;
        data["dossierId"] = this.dossierId;
        data["number"] = this.number;
        data["askingAgentId"] = this.askingAgentId;
        data["sfeSignatureDate"] = this.sfeSignatureDate ? this.sfeSignatureDate.toISOString() : undefined as any;
        data["mpSignatureDate"] = this.mpSignatureDate ? this.mpSignatureDate.toISOString() : undefined as any;
        data["nPlus2VisaDate"] = this.nPlus2VisaDate ? this.nPlus2VisaDate.toISOString() : undefined as any;
        if (Array.isArray(this.formQuestionOperationalInterviews)) {
            data["formQuestionOperationalInterviews"] = [];
            for (let item of this.formQuestionOperationalInterviews)
                data["formQuestionOperationalInterviews"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewAgentFunctions)) {
            data["operationalInterviewAgentFunctions"] = [];
            for (let item of this.operationalInterviewAgentFunctions)
                data["operationalInterviewAgentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewSpecificSubjects)) {
            data["operationalInterviewSpecificSubjects"] = [];
            for (let item of this.operationalInterviewSpecificSubjects)
                data["operationalInterviewSpecificSubjects"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewObjectiveQuestions)) {
            data["operationalInterviewObjectiveQuestions"] = [];
            for (let item of this.operationalInterviewObjectiveQuestions)
                data["operationalInterviewObjectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        data["sfe"] = this.sfe ? this.sfe.toJSON() : undefined as any;
        data["agentN2"] = this.agentN2 ? this.agentN2.toJSON() : undefined as any;
        data["mp"] = this.mp ? this.mp.toJSON() : undefined as any;
        data["askingAgent"] = this.askingAgent ? this.askingAgent.toJSON() : undefined as any;
        data["dossier"] = this.dossier ? this.dossier.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): OperationalInterview {
        const json = this.toJSON();
        let result = new OperationalInterview();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterview extends IEntity {
    date?: Date | undefined;
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    mpId?: number;
    dossierId?: number;
    number?: number;
    askingAgentId?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterview[] | undefined;
    operationalInterviewAgentFunctions?: OperationalInterviewAgentFunction[] | undefined;
    operationalInterviewSpecificSubjects?: OperationalInterviewSpecificSubject[] | undefined;
    operationalInterviewObjectiveQuestions?: OperationalInterviewObjectiveQuestion[] | undefined;
    sfe?: Agent | undefined;
    agentN2?: Agent | undefined;
    mp?: Agent | undefined;
    askingAgent?: Agent | undefined;
    dossier?: AssessementDossier | undefined;
}

export class FormQuestionOperationalInterview extends Entity implements IFormQuestionOperationalInterview {
    operationalInterviewId?: number | undefined;
    formQuestionOperationalId?: number | undefined;
    jobInterviewAgentFunctionId?: number | undefined;
    sfRemark?: string | undefined;
    mpRemark?: string | undefined;
    formQuestionOperational?: FormQuestionOperational | undefined;
    operationalInterview?: OperationalInterview | undefined;
    jobInterviewAgentFunction?: JobInterviewAgentFunction | undefined;

    constructor(data?: IFormQuestionOperationalInterview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operationalInterviewId = _data["operationalInterviewId"];
            this.formQuestionOperationalId = _data["formQuestionOperationalId"];
            this.jobInterviewAgentFunctionId = _data["jobInterviewAgentFunctionId"];
            this.sfRemark = _data["sfRemark"];
            this.mpRemark = _data["mpRemark"];
            this.formQuestionOperational = _data["formQuestionOperational"] ? FormQuestionOperational.fromJS(_data["formQuestionOperational"]) : undefined as any;
            this.operationalInterview = _data["operationalInterview"] ? OperationalInterview.fromJS(_data["operationalInterview"]) : undefined as any;
            this.jobInterviewAgentFunction = _data["jobInterviewAgentFunction"] ? JobInterviewAgentFunction.fromJS(_data["jobInterviewAgentFunction"]) : undefined as any;
        }
    }

    static override fromJS(data: any): FormQuestionOperationalInterview {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionOperationalInterview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalInterviewId"] = this.operationalInterviewId;
        data["formQuestionOperationalId"] = this.formQuestionOperationalId;
        data["jobInterviewAgentFunctionId"] = this.jobInterviewAgentFunctionId;
        data["sfRemark"] = this.sfRemark;
        data["mpRemark"] = this.mpRemark;
        data["formQuestionOperational"] = this.formQuestionOperational ? this.formQuestionOperational.toJSON() : undefined as any;
        data["operationalInterview"] = this.operationalInterview ? this.operationalInterview.toJSON() : undefined as any;
        data["jobInterviewAgentFunction"] = this.jobInterviewAgentFunction ? this.jobInterviewAgentFunction.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): FormQuestionOperationalInterview {
        const json = this.toJSON();
        let result = new FormQuestionOperationalInterview();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionOperationalInterview extends IEntity {
    operationalInterviewId?: number | undefined;
    formQuestionOperationalId?: number | undefined;
    jobInterviewAgentFunctionId?: number | undefined;
    sfRemark?: string | undefined;
    mpRemark?: string | undefined;
    formQuestionOperational?: FormQuestionOperational | undefined;
    operationalInterview?: OperationalInterview | undefined;
    jobInterviewAgentFunction?: JobInterviewAgentFunction | undefined;
}

export class FormQuestionOperational extends Entity implements IFormQuestionOperational {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    isActive?: boolean;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterview[] | undefined;

    constructor(data?: IFormQuestionOperational) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["formQuestionOperationalInterviews"])) {
                this.formQuestionOperationalInterviews = [] as any;
                for (let item of _data["formQuestionOperationalInterviews"])
                    this.formQuestionOperationalInterviews!.push(FormQuestionOperationalInterview.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FormQuestionOperational {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionOperational();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.formQuestionOperationalInterviews)) {
            data["formQuestionOperationalInterviews"] = [];
            for (let item of this.formQuestionOperationalInterviews)
                data["formQuestionOperationalInterviews"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FormQuestionOperational {
        const json = this.toJSON();
        let result = new FormQuestionOperational();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionOperational extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    isActive?: boolean;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterview[] | undefined;
}

export class OperationalInterviewAgentFunction extends Entity implements IOperationalInterviewAgentFunction {
    functionId?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    operationalInterviewId?: number;
    requirement?: EFunctionRequirement | undefined;
    remarkSfe?: string | undefined;
    remarkMp?: string | undefined;
    operationalInterview?: OperationalInterview | undefined;
    function?: Function | undefined;
    agent?: Agent | undefined;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterview[] | undefined;
    operationalInterviewAgentFunctionSpeciality?: OperationalInterviewAgentFunctionSpeciality[] | undefined;

    constructor(data?: IOperationalInterviewAgentFunction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.functionId = _data["functionId"];
            this.isPerformed = _data["isPerformed"];
            this.isHasTechAbilities = _data["isHasTechAbilities"];
            this.agentId = _data["agentId"];
            this.operationalInterviewId = _data["operationalInterviewId"];
            this.requirement = _data["requirement"];
            this.remarkSfe = _data["remarkSfe"];
            this.remarkMp = _data["remarkMp"];
            this.operationalInterview = _data["operationalInterview"] ? OperationalInterview.fromJS(_data["operationalInterview"]) : undefined as any;
            this.function = _data["function"] ? Function.fromJS(_data["function"]) : undefined as any;
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            if (Array.isArray(_data["formQuestionOperationalInterviews"])) {
                this.formQuestionOperationalInterviews = [] as any;
                for (let item of _data["formQuestionOperationalInterviews"])
                    this.formQuestionOperationalInterviews!.push(FormQuestionOperationalInterview.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewAgentFunctionSpeciality"])) {
                this.operationalInterviewAgentFunctionSpeciality = [] as any;
                for (let item of _data["operationalInterviewAgentFunctionSpeciality"])
                    this.operationalInterviewAgentFunctionSpeciality!.push(OperationalInterviewAgentFunctionSpeciality.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OperationalInterviewAgentFunction {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewAgentFunction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionId"] = this.functionId;
        data["isPerformed"] = this.isPerformed;
        data["isHasTechAbilities"] = this.isHasTechAbilities;
        data["agentId"] = this.agentId;
        data["operationalInterviewId"] = this.operationalInterviewId;
        data["requirement"] = this.requirement;
        data["remarkSfe"] = this.remarkSfe;
        data["remarkMp"] = this.remarkMp;
        data["operationalInterview"] = this.operationalInterview ? this.operationalInterview.toJSON() : undefined as any;
        data["function"] = this.function ? this.function.toJSON() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        if (Array.isArray(this.formQuestionOperationalInterviews)) {
            data["formQuestionOperationalInterviews"] = [];
            for (let item of this.formQuestionOperationalInterviews)
                data["formQuestionOperationalInterviews"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewAgentFunctionSpeciality)) {
            data["operationalInterviewAgentFunctionSpeciality"] = [];
            for (let item of this.operationalInterviewAgentFunctionSpeciality)
                data["operationalInterviewAgentFunctionSpeciality"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): OperationalInterviewAgentFunction {
        const json = this.toJSON();
        let result = new OperationalInterviewAgentFunction();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewAgentFunction extends IEntity {
    functionId?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    operationalInterviewId?: number;
    requirement?: EFunctionRequirement | undefined;
    remarkSfe?: string | undefined;
    remarkMp?: string | undefined;
    operationalInterview?: OperationalInterview | undefined;
    function?: Function | undefined;
    agent?: Agent | undefined;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterview[] | undefined;
    operationalInterviewAgentFunctionSpeciality?: OperationalInterviewAgentFunctionSpeciality[] | undefined;
}

export class OperationalInterviewAgentFunctionSpeciality extends Entity implements IOperationalInterviewAgentFunctionSpeciality {
    operationalInterviewAgentFunctionId?: number;
    specialityId?: number;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    operationalInterviewAgentFunction?: OperationalInterviewAgentFunction | undefined;
    speciality?: Speciality | undefined;
    functionalDirector?: FunctionalDirector | undefined;
    position?: Position | undefined;

    constructor(data?: IOperationalInterviewAgentFunctionSpeciality) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operationalInterviewAgentFunctionId = _data["operationalInterviewAgentFunctionId"];
            this.specialityId = _data["specialityId"];
            this.isChecked = _data["isChecked"];
            this.functionalDirectorId = _data["functionalDirectorId"];
            this.positionId = _data["positionId"];
            this.operationalInterviewAgentFunction = _data["operationalInterviewAgentFunction"] ? OperationalInterviewAgentFunction.fromJS(_data["operationalInterviewAgentFunction"]) : undefined as any;
            this.speciality = _data["speciality"] ? Speciality.fromJS(_data["speciality"]) : undefined as any;
            this.functionalDirector = _data["functionalDirector"] ? FunctionalDirector.fromJS(_data["functionalDirector"]) : undefined as any;
            this.position = _data["position"] ? Position.fromJS(_data["position"]) : undefined as any;
        }
    }

    static override fromJS(data: any): OperationalInterviewAgentFunctionSpeciality {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewAgentFunctionSpeciality();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalInterviewAgentFunctionId"] = this.operationalInterviewAgentFunctionId;
        data["specialityId"] = this.specialityId;
        data["isChecked"] = this.isChecked;
        data["functionalDirectorId"] = this.functionalDirectorId;
        data["positionId"] = this.positionId;
        data["operationalInterviewAgentFunction"] = this.operationalInterviewAgentFunction ? this.operationalInterviewAgentFunction.toJSON() : undefined as any;
        data["speciality"] = this.speciality ? this.speciality.toJSON() : undefined as any;
        data["functionalDirector"] = this.functionalDirector ? this.functionalDirector.toJSON() : undefined as any;
        data["position"] = this.position ? this.position.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): OperationalInterviewAgentFunctionSpeciality {
        const json = this.toJSON();
        let result = new OperationalInterviewAgentFunctionSpeciality();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewAgentFunctionSpeciality extends IEntity {
    operationalInterviewAgentFunctionId?: number;
    specialityId?: number;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    operationalInterviewAgentFunction?: OperationalInterviewAgentFunction | undefined;
    speciality?: Speciality | undefined;
    functionalDirector?: FunctionalDirector | undefined;
    position?: Position | undefined;
}

export class Speciality extends Entity implements ISpeciality {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    hasDirection?: boolean;
    hasPosition?: boolean;
    functionSpecialities?: FunctionSpeciality[] | undefined;
    jobInterviewAgentFunctionSpeciality?: JobInterviewAgentFunctionSpeciality[] | undefined;
    operationalInterviewAgentFunctionSpeciality?: OperationalInterviewAgentFunctionSpeciality[] | undefined;
    agentFunctionSpecialities?: AgentFunctionSpeciality[] | undefined;

    constructor(data?: ISpeciality) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.hasDirection = _data["hasDirection"];
            this.hasPosition = _data["hasPosition"];
            if (Array.isArray(_data["functionSpecialities"])) {
                this.functionSpecialities = [] as any;
                for (let item of _data["functionSpecialities"])
                    this.functionSpecialities!.push(FunctionSpeciality.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewAgentFunctionSpeciality"])) {
                this.jobInterviewAgentFunctionSpeciality = [] as any;
                for (let item of _data["jobInterviewAgentFunctionSpeciality"])
                    this.jobInterviewAgentFunctionSpeciality!.push(JobInterviewAgentFunctionSpeciality.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewAgentFunctionSpeciality"])) {
                this.operationalInterviewAgentFunctionSpeciality = [] as any;
                for (let item of _data["operationalInterviewAgentFunctionSpeciality"])
                    this.operationalInterviewAgentFunctionSpeciality!.push(OperationalInterviewAgentFunctionSpeciality.fromJS(item));
            }
            if (Array.isArray(_data["agentFunctionSpecialities"])) {
                this.agentFunctionSpecialities = [] as any;
                for (let item of _data["agentFunctionSpecialities"])
                    this.agentFunctionSpecialities!.push(AgentFunctionSpeciality.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Speciality {
        data = typeof data === 'object' ? data : {};
        let result = new Speciality();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["hasDirection"] = this.hasDirection;
        data["hasPosition"] = this.hasPosition;
        if (Array.isArray(this.functionSpecialities)) {
            data["functionSpecialities"] = [];
            for (let item of this.functionSpecialities)
                data["functionSpecialities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewAgentFunctionSpeciality)) {
            data["jobInterviewAgentFunctionSpeciality"] = [];
            for (let item of this.jobInterviewAgentFunctionSpeciality)
                data["jobInterviewAgentFunctionSpeciality"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewAgentFunctionSpeciality)) {
            data["operationalInterviewAgentFunctionSpeciality"] = [];
            for (let item of this.operationalInterviewAgentFunctionSpeciality)
                data["operationalInterviewAgentFunctionSpeciality"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.agentFunctionSpecialities)) {
            data["agentFunctionSpecialities"] = [];
            for (let item of this.agentFunctionSpecialities)
                data["agentFunctionSpecialities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Speciality {
        const json = this.toJSON();
        let result = new Speciality();
        result.init(json);
        return result;
    }
}

export interface ISpeciality extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    hasDirection?: boolean;
    hasPosition?: boolean;
    functionSpecialities?: FunctionSpeciality[] | undefined;
    jobInterviewAgentFunctionSpeciality?: JobInterviewAgentFunctionSpeciality[] | undefined;
    operationalInterviewAgentFunctionSpeciality?: OperationalInterviewAgentFunctionSpeciality[] | undefined;
    agentFunctionSpecialities?: AgentFunctionSpeciality[] | undefined;
}

export class FunctionSpeciality extends Entity implements IFunctionSpeciality {
    functionId?: number;
    specialityId?: number;
    speciality?: Speciality | undefined;
    function?: Function | undefined;

    constructor(data?: IFunctionSpeciality) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.functionId = _data["functionId"];
            this.specialityId = _data["specialityId"];
            this.speciality = _data["speciality"] ? Speciality.fromJS(_data["speciality"]) : undefined as any;
            this.function = _data["function"] ? Function.fromJS(_data["function"]) : undefined as any;
        }
    }

    static override fromJS(data: any): FunctionSpeciality {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionSpeciality();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionId"] = this.functionId;
        data["specialityId"] = this.specialityId;
        data["speciality"] = this.speciality ? this.speciality.toJSON() : undefined as any;
        data["function"] = this.function ? this.function.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): FunctionSpeciality {
        const json = this.toJSON();
        let result = new FunctionSpeciality();
        result.init(json);
        return result;
    }
}

export interface IFunctionSpeciality extends IEntity {
    functionId?: number;
    specialityId?: number;
    speciality?: Speciality | undefined;
    function?: Function | undefined;
}

export class JobInterviewAgentFunctionSpeciality extends Entity implements IJobInterviewAgentFunctionSpeciality {
    jobInterviewAgentFunctionId?: number;
    specialityId?: number;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    jobInterviewAgentFunction?: JobInterviewAgentFunction | undefined;
    speciality?: Speciality | undefined;
    functionalDirector?: FunctionalDirector | undefined;
    position?: Position | undefined;

    constructor(data?: IJobInterviewAgentFunctionSpeciality) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobInterviewAgentFunctionId = _data["jobInterviewAgentFunctionId"];
            this.specialityId = _data["specialityId"];
            this.isChecked = _data["isChecked"];
            this.functionalDirectorId = _data["functionalDirectorId"];
            this.positionId = _data["positionId"];
            this.jobInterviewAgentFunction = _data["jobInterviewAgentFunction"] ? JobInterviewAgentFunction.fromJS(_data["jobInterviewAgentFunction"]) : undefined as any;
            this.speciality = _data["speciality"] ? Speciality.fromJS(_data["speciality"]) : undefined as any;
            this.functionalDirector = _data["functionalDirector"] ? FunctionalDirector.fromJS(_data["functionalDirector"]) : undefined as any;
            this.position = _data["position"] ? Position.fromJS(_data["position"]) : undefined as any;
        }
    }

    static override fromJS(data: any): JobInterviewAgentFunctionSpeciality {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewAgentFunctionSpeciality();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobInterviewAgentFunctionId"] = this.jobInterviewAgentFunctionId;
        data["specialityId"] = this.specialityId;
        data["isChecked"] = this.isChecked;
        data["functionalDirectorId"] = this.functionalDirectorId;
        data["positionId"] = this.positionId;
        data["jobInterviewAgentFunction"] = this.jobInterviewAgentFunction ? this.jobInterviewAgentFunction.toJSON() : undefined as any;
        data["speciality"] = this.speciality ? this.speciality.toJSON() : undefined as any;
        data["functionalDirector"] = this.functionalDirector ? this.functionalDirector.toJSON() : undefined as any;
        data["position"] = this.position ? this.position.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): JobInterviewAgentFunctionSpeciality {
        const json = this.toJSON();
        let result = new JobInterviewAgentFunctionSpeciality();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewAgentFunctionSpeciality extends IEntity {
    jobInterviewAgentFunctionId?: number;
    specialityId?: number;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    jobInterviewAgentFunction?: JobInterviewAgentFunction | undefined;
    speciality?: Speciality | undefined;
    functionalDirector?: FunctionalDirector | undefined;
    position?: Position | undefined;
}

export class Position extends Entity implements IPosition {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    agentFunctionSpecialities?: AgentFunctionSpeciality[] | undefined;
    jobInterviewAgentFunctionSpecialities?: JobInterviewAgentFunctionSpeciality[] | undefined;

    constructor(data?: IPosition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["agentFunctionSpecialities"])) {
                this.agentFunctionSpecialities = [] as any;
                for (let item of _data["agentFunctionSpecialities"])
                    this.agentFunctionSpecialities!.push(AgentFunctionSpeciality.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewAgentFunctionSpecialities"])) {
                this.jobInterviewAgentFunctionSpecialities = [] as any;
                for (let item of _data["jobInterviewAgentFunctionSpecialities"])
                    this.jobInterviewAgentFunctionSpecialities!.push(JobInterviewAgentFunctionSpeciality.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Position {
        data = typeof data === 'object' ? data : {};
        let result = new Position();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.agentFunctionSpecialities)) {
            data["agentFunctionSpecialities"] = [];
            for (let item of this.agentFunctionSpecialities)
                data["agentFunctionSpecialities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewAgentFunctionSpecialities)) {
            data["jobInterviewAgentFunctionSpecialities"] = [];
            for (let item of this.jobInterviewAgentFunctionSpecialities)
                data["jobInterviewAgentFunctionSpecialities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Position {
        const json = this.toJSON();
        let result = new Position();
        result.init(json);
        return result;
    }
}

export interface IPosition extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    agentFunctionSpecialities?: AgentFunctionSpeciality[] | undefined;
    jobInterviewAgentFunctionSpecialities?: JobInterviewAgentFunctionSpeciality[] | undefined;
}

export class AgentFunctionSpeciality extends Entity implements IAgentFunctionSpeciality {
    agentFunctionId?: number;
    specialityId?: number;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    agentFunction?: AgentFunction | undefined;
    speciality?: Speciality | undefined;
    functionalDirector?: FunctionalDirector | undefined;
    position?: Position | undefined;

    constructor(data?: IAgentFunctionSpeciality) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentFunctionId = _data["agentFunctionId"];
            this.specialityId = _data["specialityId"];
            this.isChecked = _data["isChecked"];
            this.functionalDirectorId = _data["functionalDirectorId"];
            this.positionId = _data["positionId"];
            this.agentFunction = _data["agentFunction"] ? AgentFunction.fromJS(_data["agentFunction"]) : undefined as any;
            this.speciality = _data["speciality"] ? Speciality.fromJS(_data["speciality"]) : undefined as any;
            this.functionalDirector = _data["functionalDirector"] ? FunctionalDirector.fromJS(_data["functionalDirector"]) : undefined as any;
            this.position = _data["position"] ? Position.fromJS(_data["position"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AgentFunctionSpeciality {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFunctionSpeciality();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentFunctionId"] = this.agentFunctionId;
        data["specialityId"] = this.specialityId;
        data["isChecked"] = this.isChecked;
        data["functionalDirectorId"] = this.functionalDirectorId;
        data["positionId"] = this.positionId;
        data["agentFunction"] = this.agentFunction ? this.agentFunction.toJSON() : undefined as any;
        data["speciality"] = this.speciality ? this.speciality.toJSON() : undefined as any;
        data["functionalDirector"] = this.functionalDirector ? this.functionalDirector.toJSON() : undefined as any;
        data["position"] = this.position ? this.position.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): AgentFunctionSpeciality {
        const json = this.toJSON();
        let result = new AgentFunctionSpeciality();
        result.init(json);
        return result;
    }
}

export interface IAgentFunctionSpeciality extends IEntity {
    agentFunctionId?: number;
    specialityId?: number;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    agentFunction?: AgentFunction | undefined;
    speciality?: Speciality | undefined;
    functionalDirector?: FunctionalDirector | undefined;
    position?: Position | undefined;
}

export class AgentFunction extends Entity implements IAgentFunction {
    functionId?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    requirement?: EFunctionRequirement | undefined;
    function?: Function | undefined;
    agent?: Agent | undefined;
    agentFunctionSpecialities?: AgentFunctionSpeciality[] | undefined;

    constructor(data?: IAgentFunction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.functionId = _data["functionId"];
            this.isPerformed = _data["isPerformed"];
            this.isHasTechAbilities = _data["isHasTechAbilities"];
            this.agentId = _data["agentId"];
            this.requirement = _data["requirement"];
            this.function = _data["function"] ? Function.fromJS(_data["function"]) : undefined as any;
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            if (Array.isArray(_data["agentFunctionSpecialities"])) {
                this.agentFunctionSpecialities = [] as any;
                for (let item of _data["agentFunctionSpecialities"])
                    this.agentFunctionSpecialities!.push(AgentFunctionSpeciality.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AgentFunction {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFunction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionId"] = this.functionId;
        data["isPerformed"] = this.isPerformed;
        data["isHasTechAbilities"] = this.isHasTechAbilities;
        data["agentId"] = this.agentId;
        data["requirement"] = this.requirement;
        data["function"] = this.function ? this.function.toJSON() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        if (Array.isArray(this.agentFunctionSpecialities)) {
            data["agentFunctionSpecialities"] = [];
            for (let item of this.agentFunctionSpecialities)
                data["agentFunctionSpecialities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AgentFunction {
        const json = this.toJSON();
        let result = new AgentFunction();
        result.init(json);
        return result;
    }
}

export interface IAgentFunction extends IEntity {
    functionId?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    requirement?: EFunctionRequirement | undefined;
    function?: Function | undefined;
    agent?: Agent | undefined;
    agentFunctionSpecialities?: AgentFunctionSpeciality[] | undefined;
}

export class OperationalInterviewSpecificSubject extends Entity implements IOperationalInterviewSpecificSubject {
    name?: string | undefined;
    sfeRemark?: string | undefined;
    mpRemark?: string | undefined;
    operationalInterviewId?: number;
    operationalInterview?: OperationalInterview | undefined;

    constructor(data?: IOperationalInterviewSpecificSubject) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.sfeRemark = _data["sfeRemark"];
            this.mpRemark = _data["mpRemark"];
            this.operationalInterviewId = _data["operationalInterviewId"];
            this.operationalInterview = _data["operationalInterview"] ? OperationalInterview.fromJS(_data["operationalInterview"]) : undefined as any;
        }
    }

    static override fromJS(data: any): OperationalInterviewSpecificSubject {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewSpecificSubject();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sfeRemark"] = this.sfeRemark;
        data["mpRemark"] = this.mpRemark;
        data["operationalInterviewId"] = this.operationalInterviewId;
        data["operationalInterview"] = this.operationalInterview ? this.operationalInterview.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): OperationalInterviewSpecificSubject {
        const json = this.toJSON();
        let result = new OperationalInterviewSpecificSubject();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewSpecificSubject extends IEntity {
    name?: string | undefined;
    sfeRemark?: string | undefined;
    mpRemark?: string | undefined;
    operationalInterviewId?: number;
    operationalInterview?: OperationalInterview | undefined;
}

export class GradeFunction extends Entity implements IGradeFunction {
    gradeId?: number;
    gradeStatusId?: number;
    functionId?: number;
    requirement?: EFunctionRequirement;
    grade?: Grade | undefined;
    gradeStatus?: GradeStatus | undefined;
    function?: Function | undefined;

    constructor(data?: IGradeFunction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.gradeId = _data["gradeId"];
            this.gradeStatusId = _data["gradeStatusId"];
            this.functionId = _data["functionId"];
            this.requirement = _data["requirement"];
            this.grade = _data["grade"] ? Grade.fromJS(_data["grade"]) : undefined as any;
            this.gradeStatus = _data["gradeStatus"] ? GradeStatus.fromJS(_data["gradeStatus"]) : undefined as any;
            this.function = _data["function"] ? Function.fromJS(_data["function"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GradeFunction {
        data = typeof data === 'object' ? data : {};
        let result = new GradeFunction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gradeId"] = this.gradeId;
        data["gradeStatusId"] = this.gradeStatusId;
        data["functionId"] = this.functionId;
        data["requirement"] = this.requirement;
        data["grade"] = this.grade ? this.grade.toJSON() : undefined as any;
        data["gradeStatus"] = this.gradeStatus ? this.gradeStatus.toJSON() : undefined as any;
        data["function"] = this.function ? this.function.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): GradeFunction {
        const json = this.toJSON();
        let result = new GradeFunction();
        result.init(json);
        return result;
    }
}

export interface IGradeFunction extends IEntity {
    gradeId?: number;
    gradeStatusId?: number;
    functionId?: number;
    requirement?: EFunctionRequirement;
    grade?: Grade | undefined;
    gradeStatus?: GradeStatus | undefined;
    function?: Function | undefined;
}

export class GradeStatus extends Entity implements IGradeStatus {
    code?: EGradeStatus;
    dataTranslation?: DataTranslationOfLanguage | undefined;

    constructor(data?: IGradeStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GradeStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GradeStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): GradeStatus {
        const json = this.toJSON();
        let result = new GradeStatus();
        result.init(json);
        return result;
    }
}

export interface IGradeStatus extends IEntity {
    code?: EGradeStatus;
    dataTranslation?: DataTranslationOfLanguage | undefined;
}

export enum EGradeStatus {
    Professional = "Professional",
    Volunteer = "Volunteer",
}

export class Cadre extends Entity implements ICadre {
    code?: ECadre;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    agents?: Agent[] | undefined;

    constructor(data?: ICadre) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(Agent.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Cadre {
        data = typeof data === 'object' ? data : {};
        let result = new Cadre();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Cadre {
        const json = this.toJSON();
        let result = new Cadre();
        result.init(json);
        return result;
    }
}

export interface ICadre extends IEntity {
    code?: ECadre;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    agents?: Agent[] | undefined;
}

export enum ECadre {
    Base = "Base",
    Moyen = "Moyen",
    Superieur = "Superieur",
}

export class GradeSubStatus extends Entity implements IGradeSubStatus {
    code?: EGradeSubStatus;
    dataTranslation?: DataTranslationOfLanguage | undefined;

    constructor(data?: IGradeSubStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GradeSubStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GradeSubStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): GradeSubStatus {
        const json = this.toJSON();
        let result = new GradeSubStatus();
        result.init(json);
        return result;
    }
}

export interface IGradeSubStatus extends IEntity {
    code?: EGradeSubStatus;
    dataTranslation?: DataTranslationOfLanguage | undefined;
}

export enum EGradeSubStatus {
    Fireman = "Fireman",
    NonFireman = "NonFireman",
}

export class DossierTasks extends Entity implements IDossierTasks {
    dossierId?: number;
    tasksId?: number;
    isClosed?: boolean;
    assignedToAgentId?: number;
    operationalInterviewId?: number | undefined;
    assignedToAgent?: Agent | undefined;
    dossier?: AssessementDossier | undefined;
    tasks?: Tasks | undefined;

    constructor(data?: IDossierTasks) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dossierId = _data["dossierId"];
            this.tasksId = _data["tasksId"];
            this.isClosed = _data["isClosed"];
            this.assignedToAgentId = _data["assignedToAgentId"];
            this.operationalInterviewId = _data["operationalInterviewId"];
            this.assignedToAgent = _data["assignedToAgent"] ? Agent.fromJS(_data["assignedToAgent"]) : undefined as any;
            this.dossier = _data["dossier"] ? AssessementDossier.fromJS(_data["dossier"]) : undefined as any;
            this.tasks = _data["tasks"] ? Tasks.fromJS(_data["tasks"]) : undefined as any;
        }
    }

    static override fromJS(data: any): DossierTasks {
        data = typeof data === 'object' ? data : {};
        let result = new DossierTasks();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dossierId"] = this.dossierId;
        data["tasksId"] = this.tasksId;
        data["isClosed"] = this.isClosed;
        data["assignedToAgentId"] = this.assignedToAgentId;
        data["operationalInterviewId"] = this.operationalInterviewId;
        data["assignedToAgent"] = this.assignedToAgent ? this.assignedToAgent.toJSON() : undefined as any;
        data["dossier"] = this.dossier ? this.dossier.toJSON() : undefined as any;
        data["tasks"] = this.tasks ? this.tasks.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DossierTasks {
        const json = this.toJSON();
        let result = new DossierTasks();
        result.init(json);
        return result;
    }
}

export interface IDossierTasks extends IEntity {
    dossierId?: number;
    tasksId?: number;
    isClosed?: boolean;
    assignedToAgentId?: number;
    operationalInterviewId?: number | undefined;
    assignedToAgent?: Agent | undefined;
    dossier?: AssessementDossier | undefined;
    tasks?: Tasks | undefined;
}

export class Tasks extends Entity implements ITasks {
    code?: ETaskCode;
    headerDataTranslation?: DataTranslationOfLanguage | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    dossierTasks?: DossierTasks[] | undefined;

    constructor(data?: ITasks) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.headerDataTranslation = _data["headerDataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["headerDataTranslation"]) : undefined as any;
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["dossierTasks"])) {
                this.dossierTasks = [] as any;
                for (let item of _data["dossierTasks"])
                    this.dossierTasks!.push(DossierTasks.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Tasks {
        data = typeof data === 'object' ? data : {};
        let result = new Tasks();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["headerDataTranslation"] = this.headerDataTranslation ? this.headerDataTranslation.toJSON() : undefined as any;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.dossierTasks)) {
            data["dossierTasks"] = [];
            for (let item of this.dossierTasks)
                data["dossierTasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Tasks {
        const json = this.toJSON();
        let result = new Tasks();
        result.init(json);
        return result;
    }
}

export interface ITasks extends IEntity {
    code?: ETaskCode;
    headerDataTranslation?: DataTranslationOfLanguage | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    dossierTasks?: DossierTasks[] | undefined;
}

export enum ETaskCode {
    RapportEntretienFonctionADiscuter = "RapportEntretienFonctionADiscuter",
    RapportEntretienFonctionEnSignature = "RapportEntretienFonctionEnSignature",
    RapportEntretienFonctionCommentaireAIntegrer = "RapportEntretienFonctionCommentaireAIntegrer",
    RapportEntretienFonctionSignerEtEnvoyerPourSignature = "RapportEntretienFonctionSignerEtEnvoyerPourSignature",
    RapportEntretienFonctionEnSignatureNPlus2 = "RapportEntretienFonctionEnSignatureNPlus2",
    EntretienFonctionnementEnSignature = "EntretienFonctionnementEnSignature",
    EntretienFonctionnementADiscuter = "EntretienFonctionnementADiscuter",
    EntretienFonctionnementCommentaireAIntegrer = "EntretienFonctionnementCommentaireAIntegrer",
    EntretienFonctionnementSignerEtEnvoyerPourSignature = "EntretienFonctionnementSignerEtEnvoyerPourSignature",
    EntretienEvaluationEnSignature = "EntretienEvaluationEnSignature",
    EntretienEvaluationADiscuter = "EntretienEvaluationADiscuter",
    EntretienEvaluationCommentaireAIntegrer = "EntretienEvaluationCommentaireAIntegrer",
    RapportEntretienEvaluationADiscuter = "RapportEntretienEvaluationADiscuter",
    RapportEntretienEvaluationEnSignature = "RapportEntretienEvaluationEnSignature",
    RapportEntretienEvaluationCommentaireAIntegrer = "RapportEntretienEvaluationCommentaireAIntegrer",
    RapportEntretienEvaluationSignerEtEnvoyerPourSignature = "RapportEntretienEvaluationSignerEtEnvoyerPourSignature",
    RapportEntretienEvaluationEnSignatureNPlus2 = "RapportEntretienEvaluationEnSignatureNPlus2",
}

export class FormQuestionJobInterview extends Entity implements IFormQuestionJobInterview {
    formQuestionId?: number;
    jobInterviewId?: number;
    remark?: string | undefined;
    author?: string | undefined;
    formQuestion?: FormQuestion | undefined;
    jobInterview?: JobInterview | undefined;

    constructor(data?: IFormQuestionJobInterview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formQuestionId = _data["formQuestionId"];
            this.jobInterviewId = _data["jobInterviewId"];
            this.remark = _data["remark"];
            this.author = _data["author"];
            this.formQuestion = _data["formQuestion"] ? FormQuestion.fromJS(_data["formQuestion"]) : undefined as any;
            this.jobInterview = _data["jobInterview"] ? JobInterview.fromJS(_data["jobInterview"]) : undefined as any;
        }
    }

    static override fromJS(data: any): FormQuestionJobInterview {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionJobInterview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formQuestionId"] = this.formQuestionId;
        data["jobInterviewId"] = this.jobInterviewId;
        data["remark"] = this.remark;
        data["author"] = this.author;
        data["formQuestion"] = this.formQuestion ? this.formQuestion.toJSON() : undefined as any;
        data["jobInterview"] = this.jobInterview ? this.jobInterview.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): FormQuestionJobInterview {
        const json = this.toJSON();
        let result = new FormQuestionJobInterview();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionJobInterview extends IEntity {
    formQuestionId?: number;
    jobInterviewId?: number;
    remark?: string | undefined;
    author?: string | undefined;
    formQuestion?: FormQuestion | undefined;
    jobInterview?: JobInterview | undefined;
}

export class FormQuestion extends Entity implements IFormQuestion {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    isActive?: boolean;
    formQuestionJobInterviews?: FormQuestionJobInterview[] | undefined;

    constructor(data?: IFormQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["formQuestionJobInterviews"])) {
                this.formQuestionJobInterviews = [] as any;
                for (let item of _data["formQuestionJobInterviews"])
                    this.formQuestionJobInterviews!.push(FormQuestionJobInterview.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FormQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.formQuestionJobInterviews)) {
            data["formQuestionJobInterviews"] = [];
            for (let item of this.formQuestionJobInterviews)
                data["formQuestionJobInterviews"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FormQuestion {
        const json = this.toJSON();
        let result = new FormQuestion();
        result.init(json);
        return result;
    }
}

export interface IFormQuestion extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    isActive?: boolean;
    formQuestionJobInterviews?: FormQuestionJobInterview[] | undefined;
}

export class CancellationReason extends Entity implements ICancellationReason {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    dossiers?: AssessementDossier[] | undefined;

    constructor(data?: ICancellationReason) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationOfLanguage.fromJS(_data["dataTranslation"]) : undefined as any;
            if (Array.isArray(_data["dossiers"])) {
                this.dossiers = [] as any;
                for (let item of _data["dossiers"])
                    this.dossiers!.push(AssessementDossier.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CancellationReason {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationReason();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        if (Array.isArray(this.dossiers)) {
            data["dossiers"] = [];
            for (let item of this.dossiers)
                data["dossiers"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CancellationReason {
        const json = this.toJSON();
        let result = new CancellationReason();
        result.init(json);
        return result;
    }
}

export interface ICancellationReason extends IEntity {
    code?: string | undefined;
    dataTranslation?: DataTranslationOfLanguage | undefined;
    dossiers?: AssessementDossier[] | undefined;
}

export class JobInterviewDate extends Entity implements IJobInterviewDate {
    date?: Date;
    assessmentDossierId?: number;
    isCancelled?: boolean;
    cancelledReason?: string | undefined;
    assessmentDossier?: AssessementDossier | undefined;

    constructor(data?: IJobInterviewDate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.assessmentDossierId = _data["assessmentDossierId"];
            this.isCancelled = _data["isCancelled"];
            this.cancelledReason = _data["cancelledReason"];
            this.assessmentDossier = _data["assessmentDossier"] ? AssessementDossier.fromJS(_data["assessmentDossier"]) : undefined as any;
        }
    }

    static override fromJS(data: any): JobInterviewDate {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewDate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["assessmentDossierId"] = this.assessmentDossierId;
        data["isCancelled"] = this.isCancelled;
        data["cancelledReason"] = this.cancelledReason;
        data["assessmentDossier"] = this.assessmentDossier ? this.assessmentDossier.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): JobInterviewDate {
        const json = this.toJSON();
        let result = new JobInterviewDate();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewDate extends IEntity {
    date?: Date;
    assessmentDossierId?: number;
    isCancelled?: boolean;
    cancelledReason?: string | undefined;
    assessmentDossier?: AssessementDossier | undefined;
}

export class UpdateJobInterviewDateDto implements IUpdateJobInterviewDateDto {
    id?: number;
    assessementDossierId?: number;
    date?: Date;
    cancelledReason?: string | undefined;

    constructor(data?: IUpdateJobInterviewDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessementDossierId = _data["assessementDossierId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.cancelledReason = _data["cancelledReason"];
        }
    }

    static fromJS(data: any): UpdateJobInterviewDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobInterviewDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessementDossierId"] = this.assessementDossierId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["cancelledReason"] = this.cancelledReason;
        return data;
    }

    clone(): UpdateJobInterviewDateDto {
        const json = this.toJSON();
        let result = new UpdateJobInterviewDateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateJobInterviewDateDto {
    id?: number;
    assessementDossierId?: number;
    date?: Date;
    cancelledReason?: string | undefined;
}

export class UpdateOperationalInterviewDateDto implements IUpdateOperationalInterviewDateDto {
    id?: number;
    date?: Date;
    assessmentDossierId?: number;
    reason?: string | undefined;

    constructor(data?: IUpdateOperationalInterviewDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.assessmentDossierId = _data["assessmentDossierId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdateOperationalInterviewDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOperationalInterviewDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["assessmentDossierId"] = this.assessmentDossierId;
        data["reason"] = this.reason;
        return data;
    }

    clone(): UpdateOperationalInterviewDateDto {
        const json = this.toJSON();
        let result = new UpdateOperationalInterviewDateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOperationalInterviewDateDto {
    id?: number;
    date?: Date;
    assessmentDossierId?: number;
    reason?: string | undefined;
}

export class NewCycleInfoDto implements INewCycleInfoDto {
    cycleNumber?: number;
    cycleStartDate?: Date;
    cycleTypeId?: number | undefined;
    lastCycleMentionId?: number | undefined;

    constructor(data?: INewCycleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycleNumber = _data["cycleNumber"];
            this.cycleStartDate = _data["cycleStartDate"] ? new Date(_data["cycleStartDate"].toString()) : undefined as any;
            this.cycleTypeId = _data["cycleTypeId"];
            this.lastCycleMentionId = _data["lastCycleMentionId"];
        }
    }

    static fromJS(data: any): NewCycleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewCycleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycleNumber"] = this.cycleNumber;
        data["cycleStartDate"] = this.cycleStartDate ? this.cycleStartDate.toISOString() : undefined as any;
        data["cycleTypeId"] = this.cycleTypeId;
        data["lastCycleMentionId"] = this.lastCycleMentionId;
        return data;
    }

    clone(): NewCycleInfoDto {
        const json = this.toJSON();
        let result = new NewCycleInfoDto();
        result.init(json);
        return result;
    }
}

export interface INewCycleInfoDto {
    cycleNumber?: number;
    cycleStartDate?: Date;
    cycleTypeId?: number | undefined;
    lastCycleMentionId?: number | undefined;
}

export class CloseDossierDto implements ICloseDossierDto {
    dossierId?: number;
    mentionId?: number | undefined;

    constructor(data?: ICloseDossierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dossierId = _data["dossierId"];
            this.mentionId = _data["mentionId"];
        }
    }

    static fromJS(data: any): CloseDossierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseDossierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dossierId"] = this.dossierId;
        data["mentionId"] = this.mentionId;
        return data;
    }

    clone(): CloseDossierDto {
        const json = this.toJSON();
        let result = new CloseDossierDto();
        result.init(json);
        return result;
    }
}

export interface ICloseDossierDto {
    dossierId?: number;
    mentionId?: number | undefined;
}

export class CancelDossierDto implements ICancelDossierDto {
    dossierId?: number;
    cancellationReasonId?: number | undefined;
    comment?: string | undefined;

    constructor(data?: ICancelDossierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dossierId = _data["dossierId"];
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CancelDossierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelDossierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dossierId"] = this.dossierId;
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["comment"] = this.comment;
        return data;
    }

    clone(): CancelDossierDto {
        const json = this.toJSON();
        let result = new CancelDossierDto();
        result.init(json);
        return result;
    }
}

export interface ICancelDossierDto {
    dossierId?: number;
    cancellationReasonId?: number | undefined;
    comment?: string | undefined;
}

export class MostRecentItwDto implements IMostRecentItwDto {
    mostRecentItwDate?: Date | undefined;

    constructor(data?: IMostRecentItwDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mostRecentItwDate = _data["mostRecentItwDate"] ? new Date(_data["mostRecentItwDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MostRecentItwDto {
        data = typeof data === 'object' ? data : {};
        let result = new MostRecentItwDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mostRecentItwDate"] = this.mostRecentItwDate ? this.mostRecentItwDate.toISOString() : undefined as any;
        return data;
    }

    clone(): MostRecentItwDto {
        const json = this.toJSON();
        let result = new MostRecentItwDto();
        result.init(json);
        return result;
    }
}

export interface IMostRecentItwDto {
    mostRecentItwDate?: Date | undefined;
}

export class SearchQueryOfAssessementDossierCriterias implements ISearchQueryOfAssessementDossierCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AssessementDossierCriterias | undefined;

    constructor(data?: ISearchQueryOfAssessementDossierCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? AssessementDossierCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfAssessementDossierCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfAssessementDossierCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfAssessementDossierCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfAssessementDossierCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfAssessementDossierCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AssessementDossierCriterias | undefined;
}

export class AssessementDossierCriterias extends PaginatedSearchable implements IAssessementDossierCriterias {

    constructor(data?: IAssessementDossierCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AssessementDossierCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new AssessementDossierCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): AssessementDossierCriterias {
        const json = this.toJSON();
        let result = new AssessementDossierCriterias();
        result.init(json);
        return result;
    }
}

export interface IAssessementDossierCriterias extends IPaginatedSearchable {
}

export class PaginatedResultsOfAssessementDossierGridDto implements IPaginatedResultsOfAssessementDossierGridDto {
    totalCount?: number;
    results?: AssessementDossierGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfAssessementDossierGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AssessementDossierGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfAssessementDossierGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfAssessementDossierGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfAssessementDossierGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfAssessementDossierGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfAssessementDossierGridDto {
    totalCount?: number;
    results?: AssessementDossierGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class AssessementDossierGridDto implements IAssessementDossierGridDto {
    id?: number;
    agentName?: string | undefined;
    agentFirstname?: string | undefined;
    agentMatricule?: string | undefined;
    agentGradeId?: string | undefined;
    agentId?: number;
    agentN1?: string | undefined;
    agentN2?: string | undefined;
    cycleStartDate?: Date | undefined;
    assessementInterviewStartDate?: Date | undefined;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    lastCycleMentionId?: number | undefined;
    lastCycleMention?: string | undefined;
    cycleNumber?: number;
    dossierStatusId?: number | undefined;
    dossierStatus?: string | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;

    constructor(data?: IAssessementDossierGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentName = _data["agentName"];
            this.agentFirstname = _data["agentFirstname"];
            this.agentMatricule = _data["agentMatricule"];
            this.agentGradeId = _data["agentGradeId"];
            this.agentId = _data["agentId"];
            this.agentN1 = _data["agentN1"];
            this.agentN2 = _data["agentN2"];
            this.cycleStartDate = _data["cycleStartDate"] ? new Date(_data["cycleStartDate"].toString()) : undefined as any;
            this.assessementInterviewStartDate = _data["assessementInterviewStartDate"] ? new Date(_data["assessementInterviewStartDate"].toString()) : undefined as any;
            this.jobInterviewDate = _data["jobInterviewDate"] ? new Date(_data["jobInterviewDate"].toString()) : undefined as any;
            this.operationalInterviewDate = _data["operationalInterviewDate"] ? new Date(_data["operationalInterviewDate"].toString()) : undefined as any;
            this.lastCycleMentionId = _data["lastCycleMentionId"];
            this.lastCycleMention = _data["lastCycleMention"];
            this.cycleNumber = _data["cycleNumber"];
            this.dossierStatusId = _data["dossierStatusId"];
            this.dossierStatus = _data["dossierStatus"];
            this.agentN1Id = _data["agentN1Id"];
            this.agentN2Id = _data["agentN2Id"];
        }
    }

    static fromJS(data: any): AssessementDossierGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessementDossierGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentName"] = this.agentName;
        data["agentFirstname"] = this.agentFirstname;
        data["agentMatricule"] = this.agentMatricule;
        data["agentGradeId"] = this.agentGradeId;
        data["agentId"] = this.agentId;
        data["agentN1"] = this.agentN1;
        data["agentN2"] = this.agentN2;
        data["cycleStartDate"] = this.cycleStartDate ? this.cycleStartDate.toISOString() : undefined as any;
        data["assessementInterviewStartDate"] = this.assessementInterviewStartDate ? this.assessementInterviewStartDate.toISOString() : undefined as any;
        data["jobInterviewDate"] = this.jobInterviewDate ? this.jobInterviewDate.toISOString() : undefined as any;
        data["operationalInterviewDate"] = this.operationalInterviewDate ? this.operationalInterviewDate.toISOString() : undefined as any;
        data["lastCycleMentionId"] = this.lastCycleMentionId;
        data["lastCycleMention"] = this.lastCycleMention;
        data["cycleNumber"] = this.cycleNumber;
        data["dossierStatusId"] = this.dossierStatusId;
        data["dossierStatus"] = this.dossierStatus;
        data["agentN1Id"] = this.agentN1Id;
        data["agentN2Id"] = this.agentN2Id;
        return data;
    }

    clone(): AssessementDossierGridDto {
        const json = this.toJSON();
        let result = new AssessementDossierGridDto();
        result.init(json);
        return result;
    }
}

export interface IAssessementDossierGridDto {
    id?: number;
    agentName?: string | undefined;
    agentFirstname?: string | undefined;
    agentMatricule?: string | undefined;
    agentGradeId?: string | undefined;
    agentId?: number;
    agentN1?: string | undefined;
    agentN2?: string | undefined;
    cycleStartDate?: Date | undefined;
    assessementInterviewStartDate?: Date | undefined;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    lastCycleMentionId?: number | undefined;
    lastCycleMention?: string | undefined;
    cycleNumber?: number;
    dossierStatusId?: number | undefined;
    dossierStatus?: string | undefined;
    agentN1Id?: number | undefined;
    agentN2Id?: number | undefined;
}

export class CancellationReasonEditDto implements ICancellationReasonEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;

    constructor(data?: ICancellationReasonEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
        }
    }

    static fromJS(data: any): CancellationReasonEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationReasonEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        return data;
    }

    clone(): CancellationReasonEditDto {
        const json = this.toJSON();
        let result = new CancellationReasonEditDto();
        result.init(json);
        return result;
    }
}

export interface ICancellationReasonEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
}

export class PaginatedResultsOfCancellationReasonGridDto implements IPaginatedResultsOfCancellationReasonGridDto {
    totalCount?: number;
    results?: CancellationReasonGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCancellationReasonGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CancellationReasonGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCancellationReasonGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCancellationReasonGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfCancellationReasonGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfCancellationReasonGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfCancellationReasonGridDto {
    totalCount?: number;
    results?: CancellationReasonGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class CancellationReasonGridDto implements ICancellationReasonGridDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;

    constructor(data?: ICancellationReasonGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CancellationReasonGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationReasonGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["text"] = this.text;
        return data;
    }

    clone(): CancellationReasonGridDto {
        const json = this.toJSON();
        let result = new CancellationReasonGridDto();
        result.init(json);
        return result;
    }
}

export interface ICancellationReasonGridDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;
}

export class SearchQueryOfCancellationReasonSearchCriterias implements ISearchQueryOfCancellationReasonSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: CancellationReasonSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfCancellationReasonSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? CancellationReasonSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfCancellationReasonSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfCancellationReasonSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfCancellationReasonSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfCancellationReasonSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfCancellationReasonSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: CancellationReasonSearchCriterias | undefined;
}

export class CancellationReasonSearchCriterias extends PaginatedSearchable implements ICancellationReasonSearchCriterias {

    constructor(data?: ICancellationReasonSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CancellationReasonSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationReasonSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): CancellationReasonSearchCriterias {
        const json = this.toJSON();
        let result = new CancellationReasonSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ICancellationReasonSearchCriterias extends IPaginatedSearchable {
}

export class SearchQueryOfDashboardSearchCriteria implements ISearchQueryOfDashboardSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DashboardSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfDashboardSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? DashboardSearchCriteria.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfDashboardSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfDashboardSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfDashboardSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfDashboardSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfDashboardSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DashboardSearchCriteria | undefined;
}

export class DashboardSearchCriteria extends PaginatedSearchable implements IDashboardSearchCriteria {
    agentN2Id?: number | undefined;

    constructor(data?: IDashboardSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentN2Id = _data["agentN2Id"];
        }
    }

    static override fromJS(data: any): DashboardSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentN2Id"] = this.agentN2Id;
        super.toJSON(data);
        return data;
    }

    clone(): DashboardSearchCriteria {
        const json = this.toJSON();
        let result = new DashboardSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IDashboardSearchCriteria extends IPaginatedSearchable {
    agentN2Id?: number | undefined;
}

export class PaginatedResultsOfDashboardGridDto implements IPaginatedResultsOfDashboardGridDto {
    totalCount?: number;
    results?: DashboardGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDashboardGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DashboardGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDashboardGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDashboardGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfDashboardGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfDashboardGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfDashboardGridDto {
    totalCount?: number;
    results?: DashboardGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class DashboardGridDto implements IDashboardGridDto {
    id?: number;
    agentId?: number;
    agentName?: string | undefined;
    agentFirstname?: string | undefined;
    cycleStartDate?: Date;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    assessementInterviewStartDate?: Date | undefined;
    jobSfeSignatureDate?: Date | undefined;
    operationalSfeSignatureDate?: Date | undefined;
    evaluationSfeSignatureDate?: Date | undefined;
    lastJobInterviewReportReminder?: Date | undefined;
    lastJobInterviewSigningReminder?: Date | undefined;
    lastOperationalInterviewReminder?: Date | undefined;
    lastOperationalInterviewReportReminder?: Date | undefined;
    lastEvaluationInterviewReminder?: Date | undefined;
    lastEvaluationInterviewReportReminder?: Date | undefined;
    dossierStatusId?: number | undefined;
    dossierStatus?: string | undefined;
    agentN1Id?: number | undefined;
    agentN1Name?: string | undefined;
    agentN2Id?: number | undefined;
    agentN2Name?: string | undefined;
    gradeId?: number;
    gradeName?: string | undefined;
    cycleNumber?: number;
    cycleTypeId?: number | undefined;
    cycleTypeName?: string | undefined;

    constructor(data?: IDashboardGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.agentFirstname = _data["agentFirstname"];
            this.cycleStartDate = _data["cycleStartDate"] ? new Date(_data["cycleStartDate"].toString()) : undefined as any;
            this.jobInterviewDate = _data["jobInterviewDate"] ? new Date(_data["jobInterviewDate"].toString()) : undefined as any;
            this.operationalInterviewDate = _data["operationalInterviewDate"] ? new Date(_data["operationalInterviewDate"].toString()) : undefined as any;
            this.assessementInterviewStartDate = _data["assessementInterviewStartDate"] ? new Date(_data["assessementInterviewStartDate"].toString()) : undefined as any;
            this.jobSfeSignatureDate = _data["jobSfeSignatureDate"] ? new Date(_data["jobSfeSignatureDate"].toString()) : undefined as any;
            this.operationalSfeSignatureDate = _data["operationalSfeSignatureDate"] ? new Date(_data["operationalSfeSignatureDate"].toString()) : undefined as any;
            this.evaluationSfeSignatureDate = _data["evaluationSfeSignatureDate"] ? new Date(_data["evaluationSfeSignatureDate"].toString()) : undefined as any;
            this.lastJobInterviewReportReminder = _data["lastJobInterviewReportReminder"] ? new Date(_data["lastJobInterviewReportReminder"].toString()) : undefined as any;
            this.lastJobInterviewSigningReminder = _data["lastJobInterviewSigningReminder"] ? new Date(_data["lastJobInterviewSigningReminder"].toString()) : undefined as any;
            this.lastOperationalInterviewReminder = _data["lastOperationalInterviewReminder"] ? new Date(_data["lastOperationalInterviewReminder"].toString()) : undefined as any;
            this.lastOperationalInterviewReportReminder = _data["lastOperationalInterviewReportReminder"] ? new Date(_data["lastOperationalInterviewReportReminder"].toString()) : undefined as any;
            this.lastEvaluationInterviewReminder = _data["lastEvaluationInterviewReminder"] ? new Date(_data["lastEvaluationInterviewReminder"].toString()) : undefined as any;
            this.lastEvaluationInterviewReportReminder = _data["lastEvaluationInterviewReportReminder"] ? new Date(_data["lastEvaluationInterviewReportReminder"].toString()) : undefined as any;
            this.dossierStatusId = _data["dossierStatusId"];
            this.dossierStatus = _data["dossierStatus"];
            this.agentN1Id = _data["agentN1Id"];
            this.agentN1Name = _data["agentN1Name"];
            this.agentN2Id = _data["agentN2Id"];
            this.agentN2Name = _data["agentN2Name"];
            this.gradeId = _data["gradeId"];
            this.gradeName = _data["gradeName"];
            this.cycleNumber = _data["cycleNumber"];
            this.cycleTypeId = _data["cycleTypeId"];
            this.cycleTypeName = _data["cycleTypeName"];
        }
    }

    static fromJS(data: any): DashboardGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["agentFirstname"] = this.agentFirstname;
        data["cycleStartDate"] = this.cycleStartDate ? this.cycleStartDate.toISOString() : undefined as any;
        data["jobInterviewDate"] = this.jobInterviewDate ? this.jobInterviewDate.toISOString() : undefined as any;
        data["operationalInterviewDate"] = this.operationalInterviewDate ? this.operationalInterviewDate.toISOString() : undefined as any;
        data["assessementInterviewStartDate"] = this.assessementInterviewStartDate ? this.assessementInterviewStartDate.toISOString() : undefined as any;
        data["jobSfeSignatureDate"] = this.jobSfeSignatureDate ? this.jobSfeSignatureDate.toISOString() : undefined as any;
        data["operationalSfeSignatureDate"] = this.operationalSfeSignatureDate ? this.operationalSfeSignatureDate.toISOString() : undefined as any;
        data["evaluationSfeSignatureDate"] = this.evaluationSfeSignatureDate ? this.evaluationSfeSignatureDate.toISOString() : undefined as any;
        data["lastJobInterviewReportReminder"] = this.lastJobInterviewReportReminder ? this.lastJobInterviewReportReminder.toISOString() : undefined as any;
        data["lastJobInterviewSigningReminder"] = this.lastJobInterviewSigningReminder ? this.lastJobInterviewSigningReminder.toISOString() : undefined as any;
        data["lastOperationalInterviewReminder"] = this.lastOperationalInterviewReminder ? this.lastOperationalInterviewReminder.toISOString() : undefined as any;
        data["lastOperationalInterviewReportReminder"] = this.lastOperationalInterviewReportReminder ? this.lastOperationalInterviewReportReminder.toISOString() : undefined as any;
        data["lastEvaluationInterviewReminder"] = this.lastEvaluationInterviewReminder ? this.lastEvaluationInterviewReminder.toISOString() : undefined as any;
        data["lastEvaluationInterviewReportReminder"] = this.lastEvaluationInterviewReportReminder ? this.lastEvaluationInterviewReportReminder.toISOString() : undefined as any;
        data["dossierStatusId"] = this.dossierStatusId;
        data["dossierStatus"] = this.dossierStatus;
        data["agentN1Id"] = this.agentN1Id;
        data["agentN1Name"] = this.agentN1Name;
        data["agentN2Id"] = this.agentN2Id;
        data["agentN2Name"] = this.agentN2Name;
        data["gradeId"] = this.gradeId;
        data["gradeName"] = this.gradeName;
        data["cycleNumber"] = this.cycleNumber;
        data["cycleTypeId"] = this.cycleTypeId;
        data["cycleTypeName"] = this.cycleTypeName;
        return data;
    }

    clone(): DashboardGridDto {
        const json = this.toJSON();
        let result = new DashboardGridDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardGridDto {
    id?: number;
    agentId?: number;
    agentName?: string | undefined;
    agentFirstname?: string | undefined;
    cycleStartDate?: Date;
    jobInterviewDate?: Date | undefined;
    operationalInterviewDate?: Date | undefined;
    assessementInterviewStartDate?: Date | undefined;
    jobSfeSignatureDate?: Date | undefined;
    operationalSfeSignatureDate?: Date | undefined;
    evaluationSfeSignatureDate?: Date | undefined;
    lastJobInterviewReportReminder?: Date | undefined;
    lastJobInterviewSigningReminder?: Date | undefined;
    lastOperationalInterviewReminder?: Date | undefined;
    lastOperationalInterviewReportReminder?: Date | undefined;
    lastEvaluationInterviewReminder?: Date | undefined;
    lastEvaluationInterviewReportReminder?: Date | undefined;
    dossierStatusId?: number | undefined;
    dossierStatus?: string | undefined;
    agentN1Id?: number | undefined;
    agentN1Name?: string | undefined;
    agentN2Id?: number | undefined;
    agentN2Name?: string | undefined;
    gradeId?: number;
    gradeName?: string | undefined;
    cycleNumber?: number;
    cycleTypeId?: number | undefined;
    cycleTypeName?: string | undefined;
}

export class UpdateDataTranslationCommand implements IUpdateDataTranslationCommand {
    updateDataTranslationDto?: UpdateDataTranslationDto | undefined;

    constructor(data?: IUpdateDataTranslationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateDataTranslationDto = _data["updateDataTranslationDto"] ? UpdateDataTranslationDto.fromJS(_data["updateDataTranslationDto"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateDataTranslationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataTranslationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateDataTranslationDto"] = this.updateDataTranslationDto ? this.updateDataTranslationDto.toJSON() : undefined as any;
        return data;
    }

    clone(): UpdateDataTranslationCommand {
        const json = this.toJSON();
        let result = new UpdateDataTranslationCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateDataTranslationCommand {
    updateDataTranslationDto?: UpdateDataTranslationDto | undefined;
}

export class UpdateDataTranslationDto implements IUpdateDataTranslationDto {
    dataTranslationValueId?: number | undefined;
    dataTranslationId?: number;
    languageCode?: string | undefined;
    text?: string | undefined;

    constructor(data?: IUpdateDataTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataTranslationValueId = _data["dataTranslationValueId"];
            this.dataTranslationId = _data["dataTranslationId"];
            this.languageCode = _data["languageCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UpdateDataTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataTranslationValueId"] = this.dataTranslationValueId;
        data["dataTranslationId"] = this.dataTranslationId;
        data["languageCode"] = this.languageCode;
        data["text"] = this.text;
        return data;
    }

    clone(): UpdateDataTranslationDto {
        const json = this.toJSON();
        let result = new UpdateDataTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDataTranslationDto {
    dataTranslationValueId?: number | undefined;
    dataTranslationId?: number;
    languageCode?: string | undefined;
    text?: string | undefined;
}

export class Result implements IResult {
    status?: ResultStatus;
    errors?: ResultError[] | undefined;
    isFailure?: boolean;
    isSuccess?: boolean;
    isNone?: boolean;
    isInvalid?: boolean;
    isNotFound?: boolean;
    rawValue?: MaybeOfObject;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ResultError.fromJS(item));
            }
            this.isFailure = _data["isFailure"];
            this.isSuccess = _data["isSuccess"];
            this.isNone = _data["isNone"];
            this.isInvalid = _data["isInvalid"];
            this.isNotFound = _data["isNotFound"];
            this.rawValue = _data["rawValue"] ? MaybeOfObject.fromJS(_data["rawValue"]) : undefined as any;
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["isFailure"] = this.isFailure;
        data["isSuccess"] = this.isSuccess;
        data["isNone"] = this.isNone;
        data["isInvalid"] = this.isInvalid;
        data["isNotFound"] = this.isNotFound;
        data["rawValue"] = this.rawValue ? this.rawValue.toJSON() : undefined as any;
        return data;
    }

    clone(): Result {
        const json = this.toJSON();
        let result = new Result();
        result.init(json);
        return result;
    }
}

export interface IResult {
    status?: ResultStatus;
    errors?: ResultError[] | undefined;
    isFailure?: boolean;
    isSuccess?: boolean;
    isNone?: boolean;
    isInvalid?: boolean;
    isNotFound?: boolean;
    rawValue?: MaybeOfObject;
}

export enum ResultStatus {
    Success = "Success",
    Invalid = "Invalid",
    NotFound = "NotFound",
    None = "None",
}

export class ResultError extends ValueObject implements IResultError {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;

    constructor(data?: IResultError) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.hasPropertyName = _data["hasPropertyName"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorLevel = _data["errorLevel"];
            this.invalidValue = _data["invalidValue"];
        }
    }

    static override fromJS(data: any): ResultError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultError();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["hasPropertyName"] = this.hasPropertyName;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorLevel"] = this.errorLevel;
        data["invalidValue"] = this.invalidValue;
        super.toJSON(data);
        return data;
    }

    clone(): ResultError {
        const json = this.toJSON();
        let result = new ResultError();
        result.init(json);
        return result;
    }
}

export interface IResultError extends IValueObject {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;
}

export enum ResultErrorLevel {
    None = "None",
    Info = "Info",
    Warning = "Warning",
    NotFound = "NotFound",
    Error = "Error",
}

export class MaybeOfObject implements IMaybeOfObject {
    value?: any | undefined;
    hasValue?: boolean;
    hasNoValue?: boolean;

    constructor(data?: IMaybeOfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.hasValue = _data["hasValue"];
            this.hasNoValue = _data["hasNoValue"];
        }
    }

    static fromJS(data: any): MaybeOfObject {
        data = typeof data === 'object' ? data : {};
        let result = new MaybeOfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["hasValue"] = this.hasValue;
        data["hasNoValue"] = this.hasNoValue;
        return data;
    }

    clone(): MaybeOfObject {
        const json = this.toJSON();
        let result = new MaybeOfObject();
        result.init(json);
        return result;
    }
}

export interface IMaybeOfObject {
    value?: any | undefined;
    hasValue?: boolean;
    hasNoValue?: boolean;
}

export class PaginatedResultsOfDataTranslationGridDto implements IPaginatedResultsOfDataTranslationGridDto {
    totalCount?: number;
    results?: DataTranslationGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDataTranslationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DataTranslationGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDataTranslationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDataTranslationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfDataTranslationGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfDataTranslationGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfDataTranslationGridDto {
    totalCount?: number;
    results?: DataTranslationGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class DataTranslationGridDto implements IDataTranslationGridDto {
    dataTranslationId?: number;
    entityName?: string | undefined;
    entityId?: number;
    fieldName?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    dataTranslationText?: string | undefined;

    constructor(data?: IDataTranslationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataTranslationId = _data["dataTranslationId"];
            this.entityName = _data["entityName"];
            this.entityId = _data["entityId"];
            this.fieldName = _data["fieldName"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
            this.dataTranslationText = _data["dataTranslationText"];
        }
    }

    static fromJS(data: any): DataTranslationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataTranslationId"] = this.dataTranslationId;
        data["entityName"] = this.entityName;
        data["entityId"] = this.entityId;
        data["fieldName"] = this.fieldName;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["dataTranslationText"] = this.dataTranslationText;
        return data;
    }

    clone(): DataTranslationGridDto {
        const json = this.toJSON();
        let result = new DataTranslationGridDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationGridDto {
    dataTranslationId?: number;
    entityName?: string | undefined;
    entityId?: number;
    fieldName?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    dataTranslationText?: string | undefined;
}

export class SearchQueryOfDataTranslationInfoSearchCriteria implements ISearchQueryOfDataTranslationInfoSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DataTranslationInfoSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfDataTranslationInfoSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? DataTranslationInfoSearchCriteria.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfDataTranslationInfoSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfDataTranslationInfoSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfDataTranslationInfoSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfDataTranslationInfoSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfDataTranslationInfoSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DataTranslationInfoSearchCriteria | undefined;
}

export class DataTranslationInfoSearchCriteria extends PaginatedSearchable implements IDataTranslationInfoSearchCriteria {

    constructor(data?: IDataTranslationInfoSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DataTranslationInfoSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationInfoSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationInfoSearchCriteria {
        const json = this.toJSON();
        let result = new DataTranslationInfoSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationInfoSearchCriteria extends IPaginatedSearchable {
}

export class SharepointFileDto implements ISharepointFileDto {
    fileName?: string | undefined;
    sharepointUrl?: string | undefined;
    timeLastModified?: Date;

    constructor(data?: ISharepointFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.sharepointUrl = _data["sharepointUrl"];
            this.timeLastModified = _data["timeLastModified"] ? new Date(_data["timeLastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SharepointFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SharepointFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["sharepointUrl"] = this.sharepointUrl;
        data["timeLastModified"] = this.timeLastModified ? this.timeLastModified.toISOString() : undefined as any;
        return data;
    }

    clone(): SharepointFileDto {
        const json = this.toJSON();
        let result = new SharepointFileDto();
        result.init(json);
        return result;
    }
}

export interface ISharepointFileDto {
    fileName?: string | undefined;
    sharepointUrl?: string | undefined;
    timeLastModified?: Date;
}

export class DossierDocumentGridDto extends SharepointFileDto implements IDossierDocumentGridDto {

    constructor(data?: IDossierDocumentGridDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DossierDocumentGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DossierDocumentGridDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DossierDocumentGridDto {
        const json = this.toJSON();
        let result = new DossierDocumentGridDto();
        result.init(json);
        return result;
    }
}

export interface IDossierDocumentGridDto extends ISharepointFileDto {
}

export class DocumentDto implements IDocumentDto {
    fileName?: string | undefined;
    content?: string | undefined;
    contentB64?: string | undefined;
    mimeType?: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.content = _data["content"];
            this.contentB64 = _data["contentB64"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["contentB64"] = this.contentB64;
        data["mimeType"] = this.mimeType;
        return data;
    }

    clone(): DocumentDto {
        const json = this.toJSON();
        let result = new DocumentDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDto {
    fileName?: string | undefined;
    content?: string | undefined;
    contentB64?: string | undefined;
    mimeType?: string | undefined;
}

export class DossierTaskEditDto implements IDossierTaskEditDto {
    id?: number;
    dossierId?: number;
    tasksId?: number;
    isClosed?: boolean;
    assignedToAgentId?: number;
    description?: string | undefined;
    headerText?: string | undefined;
    agentName?: string | undefined;
    cycleNumber?: number;
    jobInterviewDate?: Date;
    sfeName?: string | undefined;
    code?: ETaskCode;
    dossierCycleStartDate?: Date;
    gradeName?: string | undefined;
    operationalInterviewId?: number | undefined;
    dossierName?: string | undefined;

    constructor(data?: IDossierTaskEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dossierId = _data["dossierId"];
            this.tasksId = _data["tasksId"];
            this.isClosed = _data["isClosed"];
            this.assignedToAgentId = _data["assignedToAgentId"];
            this.description = _data["description"];
            this.headerText = _data["headerText"];
            this.agentName = _data["agentName"];
            this.cycleNumber = _data["cycleNumber"];
            this.jobInterviewDate = _data["jobInterviewDate"] ? new Date(_data["jobInterviewDate"].toString()) : undefined as any;
            this.sfeName = _data["sfeName"];
            this.code = _data["code"];
            this.dossierCycleStartDate = _data["dossierCycleStartDate"] ? new Date(_data["dossierCycleStartDate"].toString()) : undefined as any;
            this.gradeName = _data["gradeName"];
            this.operationalInterviewId = _data["operationalInterviewId"];
            this.dossierName = _data["dossierName"];
        }
    }

    static fromJS(data: any): DossierTaskEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new DossierTaskEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dossierId"] = this.dossierId;
        data["tasksId"] = this.tasksId;
        data["isClosed"] = this.isClosed;
        data["assignedToAgentId"] = this.assignedToAgentId;
        data["description"] = this.description;
        data["headerText"] = this.headerText;
        data["agentName"] = this.agentName;
        data["cycleNumber"] = this.cycleNumber;
        data["jobInterviewDate"] = this.jobInterviewDate ? this.jobInterviewDate.toISOString() : undefined as any;
        data["sfeName"] = this.sfeName;
        data["code"] = this.code;
        data["dossierCycleStartDate"] = this.dossierCycleStartDate ? this.dossierCycleStartDate.toISOString() : undefined as any;
        data["gradeName"] = this.gradeName;
        data["operationalInterviewId"] = this.operationalInterviewId;
        data["dossierName"] = this.dossierName;
        return data;
    }

    clone(): DossierTaskEditDto {
        const json = this.toJSON();
        let result = new DossierTaskEditDto();
        result.init(json);
        return result;
    }
}

export interface IDossierTaskEditDto {
    id?: number;
    dossierId?: number;
    tasksId?: number;
    isClosed?: boolean;
    assignedToAgentId?: number;
    description?: string | undefined;
    headerText?: string | undefined;
    agentName?: string | undefined;
    cycleNumber?: number;
    jobInterviewDate?: Date;
    sfeName?: string | undefined;
    code?: ETaskCode;
    dossierCycleStartDate?: Date;
    gradeName?: string | undefined;
    operationalInterviewId?: number | undefined;
    dossierName?: string | undefined;
}

export class PaginatedResultsOfDossierTaskGridDto implements IPaginatedResultsOfDossierTaskGridDto {
    totalCount?: number;
    results?: DossierTaskGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDossierTaskGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DossierTaskGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDossierTaskGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDossierTaskGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfDossierTaskGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfDossierTaskGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfDossierTaskGridDto {
    totalCount?: number;
    results?: DossierTaskGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class DossierTaskGridDto implements IDossierTaskGridDto {
    id?: number;
    dossierId?: number;
    tasksId?: number;
    isClosed?: boolean;
    assignedToAgentId?: number;
    headerText?: string | undefined;
    text?: string | undefined;
    taskCode?: ETaskCode;
    cycleNumber?: number;
    agentId?: number;
    agent?: string | undefined;

    constructor(data?: IDossierTaskGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dossierId = _data["dossierId"];
            this.tasksId = _data["tasksId"];
            this.isClosed = _data["isClosed"];
            this.assignedToAgentId = _data["assignedToAgentId"];
            this.headerText = _data["headerText"];
            this.text = _data["text"];
            this.taskCode = _data["taskCode"];
            this.cycleNumber = _data["cycleNumber"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"];
        }
    }

    static fromJS(data: any): DossierTaskGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DossierTaskGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dossierId"] = this.dossierId;
        data["tasksId"] = this.tasksId;
        data["isClosed"] = this.isClosed;
        data["assignedToAgentId"] = this.assignedToAgentId;
        data["headerText"] = this.headerText;
        data["text"] = this.text;
        data["taskCode"] = this.taskCode;
        data["cycleNumber"] = this.cycleNumber;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent;
        return data;
    }

    clone(): DossierTaskGridDto {
        const json = this.toJSON();
        let result = new DossierTaskGridDto();
        result.init(json);
        return result;
    }
}

export interface IDossierTaskGridDto {
    id?: number;
    dossierId?: number;
    tasksId?: number;
    isClosed?: boolean;
    assignedToAgentId?: number;
    headerText?: string | undefined;
    text?: string | undefined;
    taskCode?: ETaskCode;
    cycleNumber?: number;
    agentId?: number;
    agent?: string | undefined;
}

export class SearchQueryOfDossierTaskSearchCriterias implements ISearchQueryOfDossierTaskSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DossierTaskSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfDossierTaskSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? DossierTaskSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfDossierTaskSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfDossierTaskSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfDossierTaskSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfDossierTaskSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfDossierTaskSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DossierTaskSearchCriterias | undefined;
}

export class DossierTaskSearchCriterias extends PaginatedSearchable implements IDossierTaskSearchCriterias {
    agentId?: number | undefined;
    onlyUser?: boolean;

    constructor(data?: IDossierTaskSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentId = _data["agentId"];
            this.onlyUser = _data["onlyUser"];
        }
    }

    static override fromJS(data: any): DossierTaskSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new DossierTaskSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["onlyUser"] = this.onlyUser;
        super.toJSON(data);
        return data;
    }

    clone(): DossierTaskSearchCriterias {
        const json = this.toJSON();
        let result = new DossierTaskSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IDossierTaskSearchCriterias extends IPaginatedSearchable {
    agentId?: number | undefined;
    onlyUser?: boolean;
}

export class EvaluationInterviewEditDto implements IEvaluationInterviewEditDto {
    id?: number;
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    date?: Date | undefined;
    assessementDossierId?: number;
    mentionId?: number | undefined;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    strength?: string | undefined;
    weakness?: string | undefined;
    conclusion?: string | undefined;
    dossierStatus?: string | undefined;
    dossierStatusCode?: EDossierStatus;
    evaluationInterviewObjectiveQuestions?: EvaluationInterviewObjectiveQuestionDto[] | undefined;
    evaluationInterviewCompetences?: EvaluationInterviewCompetenceDto[] | undefined;

    constructor(data?: IEvaluationInterviewEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sfeId = _data["sfeId"];
            this.agentN2Id = _data["agentN2Id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.assessementDossierId = _data["assessementDossierId"];
            this.mentionId = _data["mentionId"];
            this.sfeSignatureDate = _data["sfeSignatureDate"] ? new Date(_data["sfeSignatureDate"].toString()) : undefined as any;
            this.mpSignatureDate = _data["mpSignatureDate"] ? new Date(_data["mpSignatureDate"].toString()) : undefined as any;
            this.nPlus2VisaDate = _data["nPlus2VisaDate"] ? new Date(_data["nPlus2VisaDate"].toString()) : undefined as any;
            this.strength = _data["strength"];
            this.weakness = _data["weakness"];
            this.conclusion = _data["conclusion"];
            this.dossierStatus = _data["dossierStatus"];
            this.dossierStatusCode = _data["dossierStatusCode"];
            if (Array.isArray(_data["evaluationInterviewObjectiveQuestions"])) {
                this.evaluationInterviewObjectiveQuestions = [] as any;
                for (let item of _data["evaluationInterviewObjectiveQuestions"])
                    this.evaluationInterviewObjectiveQuestions!.push(EvaluationInterviewObjectiveQuestionDto.fromJS(item));
            }
            if (Array.isArray(_data["evaluationInterviewCompetences"])) {
                this.evaluationInterviewCompetences = [] as any;
                for (let item of _data["evaluationInterviewCompetences"])
                    this.evaluationInterviewCompetences!.push(EvaluationInterviewCompetenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EvaluationInterviewEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInterviewEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sfeId"] = this.sfeId;
        data["agentN2Id"] = this.agentN2Id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["assessementDossierId"] = this.assessementDossierId;
        data["mentionId"] = this.mentionId;
        data["sfeSignatureDate"] = this.sfeSignatureDate ? this.sfeSignatureDate.toISOString() : undefined as any;
        data["mpSignatureDate"] = this.mpSignatureDate ? this.mpSignatureDate.toISOString() : undefined as any;
        data["nPlus2VisaDate"] = this.nPlus2VisaDate ? this.nPlus2VisaDate.toISOString() : undefined as any;
        data["strength"] = this.strength;
        data["weakness"] = this.weakness;
        data["conclusion"] = this.conclusion;
        data["dossierStatus"] = this.dossierStatus;
        data["dossierStatusCode"] = this.dossierStatusCode;
        if (Array.isArray(this.evaluationInterviewObjectiveQuestions)) {
            data["evaluationInterviewObjectiveQuestions"] = [];
            for (let item of this.evaluationInterviewObjectiveQuestions)
                data["evaluationInterviewObjectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.evaluationInterviewCompetences)) {
            data["evaluationInterviewCompetences"] = [];
            for (let item of this.evaluationInterviewCompetences)
                data["evaluationInterviewCompetences"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EvaluationInterviewEditDto {
        const json = this.toJSON();
        let result = new EvaluationInterviewEditDto();
        result.init(json);
        return result;
    }
}

export interface IEvaluationInterviewEditDto {
    id?: number;
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    date?: Date | undefined;
    assessementDossierId?: number;
    mentionId?: number | undefined;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    strength?: string | undefined;
    weakness?: string | undefined;
    conclusion?: string | undefined;
    dossierStatus?: string | undefined;
    dossierStatusCode?: EDossierStatus;
    evaluationInterviewObjectiveQuestions?: EvaluationInterviewObjectiveQuestionDto[] | undefined;
    evaluationInterviewCompetences?: EvaluationInterviewCompetenceDto[] | undefined;
}

export class EvaluationInterviewObjectiveQuestionDto implements IEvaluationInterviewObjectiveQuestionDto {
    id?: number;
    index?: number;
    evaluationInterviewId?: number;
    objectiveQuestionId?: number;
    title?: string | undefined;
    canBeEdited?: boolean;

    constructor(data?: IEvaluationInterviewObjectiveQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.index = _data["index"];
            this.evaluationInterviewId = _data["evaluationInterviewId"];
            this.objectiveQuestionId = _data["objectiveQuestionId"];
            this.title = _data["title"];
            this.canBeEdited = _data["canBeEdited"];
        }
    }

    static fromJS(data: any): EvaluationInterviewObjectiveQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInterviewObjectiveQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["index"] = this.index;
        data["evaluationInterviewId"] = this.evaluationInterviewId;
        data["objectiveQuestionId"] = this.objectiveQuestionId;
        data["title"] = this.title;
        data["canBeEdited"] = this.canBeEdited;
        return data;
    }

    clone(): EvaluationInterviewObjectiveQuestionDto {
        const json = this.toJSON();
        let result = new EvaluationInterviewObjectiveQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IEvaluationInterviewObjectiveQuestionDto {
    id?: number;
    index?: number;
    evaluationInterviewId?: number;
    objectiveQuestionId?: number;
    title?: string | undefined;
    canBeEdited?: boolean;
}

export class EvaluationInterviewCompetenceDto implements IEvaluationInterviewCompetenceDto {
    id?: number;
    index?: number;
    competenceId?: number;
    competenceTitle?: string | undefined;
    evaluationInterviewId?: number;
    level?: string | undefined;
    evaluation?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    evaluationInterviewSubCompetenceDtos?: EvaluationInterviewSubCompetenceDto[] | undefined;
    competenceCode?: string | undefined;
    hasEvaluation?: boolean;

    constructor(data?: IEvaluationInterviewCompetenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.index = _data["index"];
            this.competenceId = _data["competenceId"];
            this.competenceTitle = _data["competenceTitle"];
            this.evaluationInterviewId = _data["evaluationInterviewId"];
            this.level = _data["level"];
            this.evaluation = _data["evaluation"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["evaluationInterviewSubCompetenceDtos"])) {
                this.evaluationInterviewSubCompetenceDtos = [] as any;
                for (let item of _data["evaluationInterviewSubCompetenceDtos"])
                    this.evaluationInterviewSubCompetenceDtos!.push(EvaluationInterviewSubCompetenceDto.fromJS(item));
            }
            this.competenceCode = _data["competenceCode"];
            this.hasEvaluation = _data["hasEvaluation"];
        }
    }

    static fromJS(data: any): EvaluationInterviewCompetenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInterviewCompetenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["index"] = this.index;
        data["competenceId"] = this.competenceId;
        data["competenceTitle"] = this.competenceTitle;
        data["evaluationInterviewId"] = this.evaluationInterviewId;
        data["level"] = this.level;
        data["evaluation"] = this.evaluation;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.evaluationInterviewSubCompetenceDtos)) {
            data["evaluationInterviewSubCompetenceDtos"] = [];
            for (let item of this.evaluationInterviewSubCompetenceDtos)
                data["evaluationInterviewSubCompetenceDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["competenceCode"] = this.competenceCode;
        data["hasEvaluation"] = this.hasEvaluation;
        return data;
    }

    clone(): EvaluationInterviewCompetenceDto {
        const json = this.toJSON();
        let result = new EvaluationInterviewCompetenceDto();
        result.init(json);
        return result;
    }
}

export interface IEvaluationInterviewCompetenceDto {
    id?: number;
    index?: number;
    competenceId?: number;
    competenceTitle?: string | undefined;
    evaluationInterviewId?: number;
    level?: string | undefined;
    evaluation?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    evaluationInterviewSubCompetenceDtos?: EvaluationInterviewSubCompetenceDto[] | undefined;
    competenceCode?: string | undefined;
    hasEvaluation?: boolean;
}

export class EvaluationInterviewSubCompetenceDto implements IEvaluationInterviewSubCompetenceDto {
    id?: number;
    code?: string | undefined;
    title?: string | undefined;
    evaluationInterviewCompetenceId?: number;
    canBeEdited?: boolean;
    level?: string | undefined;
    evaluation?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    competenceCode?: string | undefined;
    hasLevelAndEvaluation?: boolean;

    constructor(data?: IEvaluationInterviewSubCompetenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.title = _data["title"];
            this.evaluationInterviewCompetenceId = _data["evaluationInterviewCompetenceId"];
            this.canBeEdited = _data["canBeEdited"];
            this.level = _data["level"];
            this.evaluation = _data["evaluation"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.competenceCode = _data["competenceCode"];
            this.hasLevelAndEvaluation = _data["hasLevelAndEvaluation"];
        }
    }

    static fromJS(data: any): EvaluationInterviewSubCompetenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInterviewSubCompetenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title;
        data["evaluationInterviewCompetenceId"] = this.evaluationInterviewCompetenceId;
        data["canBeEdited"] = this.canBeEdited;
        data["level"] = this.level;
        data["evaluation"] = this.evaluation;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["competenceCode"] = this.competenceCode;
        data["hasLevelAndEvaluation"] = this.hasLevelAndEvaluation;
        return data;
    }

    clone(): EvaluationInterviewSubCompetenceDto {
        const json = this.toJSON();
        let result = new EvaluationInterviewSubCompetenceDto();
        result.init(json);
        return result;
    }
}

export interface IEvaluationInterviewSubCompetenceDto {
    id?: number;
    code?: string | undefined;
    title?: string | undefined;
    evaluationInterviewCompetenceId?: number;
    canBeEdited?: boolean;
    level?: string | undefined;
    evaluation?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    competenceCode?: string | undefined;
    hasLevelAndEvaluation?: boolean;
}

export class FormQuestionEditDto implements IFormQuestionEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    isActive?: boolean;

    constructor(data?: IFormQuestionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): FormQuestionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): FormQuestionEditDto {
        const json = this.toJSON();
        let result = new FormQuestionEditDto();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    isActive?: boolean;
}

export class PaginatedResultsOfFormQuestionGridDto implements IPaginatedResultsOfFormQuestionGridDto {
    totalCount?: number;
    results?: FormQuestionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfFormQuestionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FormQuestionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfFormQuestionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfFormQuestionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfFormQuestionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfFormQuestionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfFormQuestionGridDto {
    totalCount?: number;
    results?: FormQuestionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class FormQuestionGridDto implements IFormQuestionGridDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;
    isActive?: boolean;

    constructor(data?: IFormQuestionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.text = _data["text"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): FormQuestionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["text"] = this.text;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): FormQuestionGridDto {
        const json = this.toJSON();
        let result = new FormQuestionGridDto();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionGridDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;
    isActive?: boolean;
}

export class SearchQueryOfFormQuestionSearchCriterias implements ISearchQueryOfFormQuestionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FormQuestionSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfFormQuestionSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? FormQuestionSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfFormQuestionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfFormQuestionSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfFormQuestionSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfFormQuestionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfFormQuestionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FormQuestionSearchCriterias | undefined;
}

export class FormQuestionSearchCriterias extends PaginatedSearchable implements IFormQuestionSearchCriterias {

    constructor(data?: IFormQuestionSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FormQuestionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): FormQuestionSearchCriterias {
        const json = this.toJSON();
        let result = new FormQuestionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionSearchCriterias extends IPaginatedSearchable {
}

export class FormQuestionOperationalEditDto implements IFormQuestionOperationalEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    isActive?: boolean;

    constructor(data?: IFormQuestionOperationalEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): FormQuestionOperationalEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionOperationalEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): FormQuestionOperationalEditDto {
        const json = this.toJSON();
        let result = new FormQuestionOperationalEditDto();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionOperationalEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    isActive?: boolean;
}

export class PaginatedResultsOfFormQuestionOperationalGridDto implements IPaginatedResultsOfFormQuestionOperationalGridDto {
    totalCount?: number;
    results?: FormQuestionOperationalGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfFormQuestionOperationalGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FormQuestionOperationalGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfFormQuestionOperationalGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfFormQuestionOperationalGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfFormQuestionOperationalGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfFormQuestionOperationalGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfFormQuestionOperationalGridDto {
    totalCount?: number;
    results?: FormQuestionOperationalGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class FormQuestionOperationalGridDto implements IFormQuestionOperationalGridDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;
    isActive?: boolean;

    constructor(data?: IFormQuestionOperationalGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.text = _data["text"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): FormQuestionOperationalGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionOperationalGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["text"] = this.text;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): FormQuestionOperationalGridDto {
        const json = this.toJSON();
        let result = new FormQuestionOperationalGridDto();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionOperationalGridDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;
    isActive?: boolean;
}

export class SearchQueryOfFormQuestionOperationalSearchCriterias implements ISearchQueryOfFormQuestionOperationalSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FormQuestionOperationalSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfFormQuestionOperationalSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? FormQuestionOperationalSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfFormQuestionOperationalSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfFormQuestionOperationalSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfFormQuestionOperationalSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfFormQuestionOperationalSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfFormQuestionOperationalSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FormQuestionOperationalSearchCriterias | undefined;
}

export class FormQuestionOperationalSearchCriterias extends PaginatedSearchable implements IFormQuestionOperationalSearchCriterias {

    constructor(data?: IFormQuestionOperationalSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FormQuestionOperationalSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionOperationalSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): FormQuestionOperationalSearchCriterias {
        const json = this.toJSON();
        let result = new FormQuestionOperationalSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionOperationalSearchCriterias extends IPaginatedSearchable {
}

export class FunctionalDirectorEditDto implements IFunctionalDirectorEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    agentId?: number | undefined;

    constructor(data?: IFunctionalDirectorEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
            this.agentId = _data["agentId"];
        }
    }

    static fromJS(data: any): FunctionalDirectorEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalDirectorEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["agentId"] = this.agentId;
        return data;
    }

    clone(): FunctionalDirectorEditDto {
        const json = this.toJSON();
        let result = new FunctionalDirectorEditDto();
        result.init(json);
        return result;
    }
}

export interface IFunctionalDirectorEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    agentId?: number | undefined;
}

export class PaginatedResultsOfFunctionalDirectorGridDto implements IPaginatedResultsOfFunctionalDirectorGridDto {
    totalCount?: number;
    results?: FunctionalDirectorGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfFunctionalDirectorGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FunctionalDirectorGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfFunctionalDirectorGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfFunctionalDirectorGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfFunctionalDirectorGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfFunctionalDirectorGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfFunctionalDirectorGridDto {
    totalCount?: number;
    results?: FunctionalDirectorGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class FunctionalDirectorGridDto implements IFunctionalDirectorGridDto {
    id?: number;
    functionalDirectorName?: string | undefined;
    code?: string | undefined;
    agentId?: number | undefined;
    agent?: string | undefined;

    constructor(data?: IFunctionalDirectorGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.functionalDirectorName = _data["functionalDirectorName"];
            this.code = _data["code"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"];
        }
    }

    static fromJS(data: any): FunctionalDirectorGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalDirectorGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["functionalDirectorName"] = this.functionalDirectorName;
        data["code"] = this.code;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent;
        return data;
    }

    clone(): FunctionalDirectorGridDto {
        const json = this.toJSON();
        let result = new FunctionalDirectorGridDto();
        result.init(json);
        return result;
    }
}

export interface IFunctionalDirectorGridDto {
    id?: number;
    functionalDirectorName?: string | undefined;
    code?: string | undefined;
    agentId?: number | undefined;
    agent?: string | undefined;
}

export class SearchQueryOfFunctionalDirectorSearchCriterias implements ISearchQueryOfFunctionalDirectorSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FunctionalDirectorSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfFunctionalDirectorSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? FunctionalDirectorSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfFunctionalDirectorSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfFunctionalDirectorSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfFunctionalDirectorSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfFunctionalDirectorSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfFunctionalDirectorSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FunctionalDirectorSearchCriterias | undefined;
}

export class FunctionalDirectorSearchCriterias extends PaginatedSearchable implements IFunctionalDirectorSearchCriterias {

    constructor(data?: IFunctionalDirectorSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FunctionalDirectorSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalDirectorSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): FunctionalDirectorSearchCriterias {
        const json = this.toJSON();
        let result = new FunctionalDirectorSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IFunctionalDirectorSearchCriterias extends IPaginatedSearchable {
}

export class EditFunctionDto implements IEditFunctionDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    functionalDirectorId?: number | undefined;
    agentId?: number | undefined;
    fileName?: string | undefined;
    sharepointUrl?: string | undefined;
    note?: string | undefined;
    file?: DocumentDto | undefined;

    constructor(data?: IEditFunctionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
            this.functionalDirectorId = _data["functionalDirectorId"];
            this.agentId = _data["agentId"];
            this.fileName = _data["fileName"];
            this.sharepointUrl = _data["sharepointUrl"];
            this.note = _data["note"];
            this.file = _data["file"] ? DocumentDto.fromJS(_data["file"]) : undefined as any;
        }
    }

    static fromJS(data: any): EditFunctionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditFunctionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["functionalDirectorId"] = this.functionalDirectorId;
        data["agentId"] = this.agentId;
        data["fileName"] = this.fileName;
        data["sharepointUrl"] = this.sharepointUrl;
        data["note"] = this.note;
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        return data;
    }

    clone(): EditFunctionDto {
        const json = this.toJSON();
        let result = new EditFunctionDto();
        result.init(json);
        return result;
    }
}

export interface IEditFunctionDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    functionalDirectorId?: number | undefined;
    agentId?: number | undefined;
    fileName?: string | undefined;
    sharepointUrl?: string | undefined;
    note?: string | undefined;
    file?: DocumentDto | undefined;
}

export class PaginatedResultsOfFunctionGridDto implements IPaginatedResultsOfFunctionGridDto {
    totalCount?: number;
    results?: FunctionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FunctionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfFunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfFunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfFunctionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfFunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfFunctionGridDto {
    totalCount?: number;
    results?: FunctionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class FunctionGridDto implements IFunctionGridDto {
    id?: number;
    functionId?: number;
    name?: string | undefined;
    functionalDirectorName?: string | undefined;
    functionalDirectorId?: number | undefined;
    agentId?: number | undefined;
    fileName?: string | undefined;
    note?: string | undefined;

    constructor(data?: IFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.functionId = _data["functionId"];
            this.name = _data["name"];
            this.functionalDirectorName = _data["functionalDirectorName"];
            this.functionalDirectorId = _data["functionalDirectorId"];
            this.agentId = _data["agentId"];
            this.fileName = _data["fileName"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): FunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["functionId"] = this.functionId;
        data["name"] = this.name;
        data["functionalDirectorName"] = this.functionalDirectorName;
        data["functionalDirectorId"] = this.functionalDirectorId;
        data["agentId"] = this.agentId;
        data["fileName"] = this.fileName;
        data["note"] = this.note;
        return data;
    }

    clone(): FunctionGridDto {
        const json = this.toJSON();
        let result = new FunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IFunctionGridDto {
    id?: number;
    functionId?: number;
    name?: string | undefined;
    functionalDirectorName?: string | undefined;
    functionalDirectorId?: number | undefined;
    agentId?: number | undefined;
    fileName?: string | undefined;
    note?: string | undefined;
}

export class SearchQueryOfFunctionSearchCrtieria implements ISearchQueryOfFunctionSearchCrtieria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FunctionSearchCrtieria | undefined;

    constructor(data?: ISearchQueryOfFunctionSearchCrtieria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? FunctionSearchCrtieria.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfFunctionSearchCrtieria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfFunctionSearchCrtieria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfFunctionSearchCrtieria {
        const json = this.toJSON();
        let result = new SearchQueryOfFunctionSearchCrtieria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfFunctionSearchCrtieria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FunctionSearchCrtieria | undefined;
}

export class FunctionSearchCrtieria extends PaginatedSearchable implements IFunctionSearchCrtieria {

    constructor(data?: IFunctionSearchCrtieria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FunctionSearchCrtieria {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionSearchCrtieria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): FunctionSearchCrtieria {
        const json = this.toJSON();
        let result = new FunctionSearchCrtieria();
        result.init(json);
        return result;
    }
}

export interface IFunctionSearchCrtieria extends IPaginatedSearchable {
}

export class PaginatedResultsOfGradeFunctionGridDto implements IPaginatedResultsOfGradeFunctionGridDto {
    totalCount?: number;
    results?: GradeFunctionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfGradeFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(GradeFunctionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfGradeFunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfGradeFunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfGradeFunctionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfGradeFunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfGradeFunctionGridDto {
    totalCount?: number;
    results?: GradeFunctionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class GradeFunctionGridDto implements IGradeFunctionGridDto {
    id?: number;
    gradeId?: number;
    gradeStatusId?: number;
    functionId?: number;
    grade?: string | undefined;
    gradeStatus?: string | undefined;
    function?: string | undefined;
    requirement?: EFunctionRequirement;

    constructor(data?: IGradeFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gradeId = _data["gradeId"];
            this.gradeStatusId = _data["gradeStatusId"];
            this.functionId = _data["functionId"];
            this.grade = _data["grade"];
            this.gradeStatus = _data["gradeStatus"];
            this.function = _data["function"];
            this.requirement = _data["requirement"];
        }
    }

    static fromJS(data: any): GradeFunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new GradeFunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gradeId"] = this.gradeId;
        data["gradeStatusId"] = this.gradeStatusId;
        data["functionId"] = this.functionId;
        data["grade"] = this.grade;
        data["gradeStatus"] = this.gradeStatus;
        data["function"] = this.function;
        data["requirement"] = this.requirement;
        return data;
    }

    clone(): GradeFunctionGridDto {
        const json = this.toJSON();
        let result = new GradeFunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IGradeFunctionGridDto {
    id?: number;
    gradeId?: number;
    gradeStatusId?: number;
    functionId?: number;
    grade?: string | undefined;
    gradeStatus?: string | undefined;
    function?: string | undefined;
    requirement?: EFunctionRequirement;
}

export class SearchQueryOfGradeFunctionSearchCriterias implements ISearchQueryOfGradeFunctionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: GradeFunctionSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfGradeFunctionSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? GradeFunctionSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfGradeFunctionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfGradeFunctionSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfGradeFunctionSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfGradeFunctionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfGradeFunctionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: GradeFunctionSearchCriterias | undefined;
}

export class GradeFunctionSearchCriterias extends PaginatedSearchable implements IGradeFunctionSearchCriterias {

    constructor(data?: IGradeFunctionSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GradeFunctionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new GradeFunctionSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): GradeFunctionSearchCriterias {
        const json = this.toJSON();
        let result = new GradeFunctionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IGradeFunctionSearchCriterias extends IPaginatedSearchable {
}

export class JobInterviewEditDto implements IJobInterviewEditDto {
    id?: number;
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    date?: Date | undefined;
    dossierId?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    n2Comment?: string | undefined;
    questions?: JobInterviewFormQuestionGridDto[] | undefined;
    jobInterviewAgentFunctions?: JobInterviewAgentFunctionGridDto[] | undefined;
    jobInterviewObjectiveQuestions?: JobInterviewObjectiveQuestionGridDto[] | undefined;
    dossierStatus?: string | undefined;
    dossierStatusCode?: EDossierStatus;
    cannotShowN2Comment?: boolean;

    constructor(data?: IJobInterviewEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sfeId = _data["sfeId"];
            this.agentN2Id = _data["agentN2Id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.dossierId = _data["dossierId"];
            this.sfeSignatureDate = _data["sfeSignatureDate"] ? new Date(_data["sfeSignatureDate"].toString()) : undefined as any;
            this.mpSignatureDate = _data["mpSignatureDate"] ? new Date(_data["mpSignatureDate"].toString()) : undefined as any;
            this.nPlus2VisaDate = _data["nPlus2VisaDate"] ? new Date(_data["nPlus2VisaDate"].toString()) : undefined as any;
            this.n2Comment = _data["n2Comment"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(JobInterviewFormQuestionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewAgentFunctions"])) {
                this.jobInterviewAgentFunctions = [] as any;
                for (let item of _data["jobInterviewAgentFunctions"])
                    this.jobInterviewAgentFunctions!.push(JobInterviewAgentFunctionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["jobInterviewObjectiveQuestions"])) {
                this.jobInterviewObjectiveQuestions = [] as any;
                for (let item of _data["jobInterviewObjectiveQuestions"])
                    this.jobInterviewObjectiveQuestions!.push(JobInterviewObjectiveQuestionGridDto.fromJS(item));
            }
            this.dossierStatus = _data["dossierStatus"];
            this.dossierStatusCode = _data["dossierStatusCode"];
            this.cannotShowN2Comment = _data["cannotShowN2Comment"];
        }
    }

    static fromJS(data: any): JobInterviewEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sfeId"] = this.sfeId;
        data["agentN2Id"] = this.agentN2Id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["dossierId"] = this.dossierId;
        data["sfeSignatureDate"] = this.sfeSignatureDate ? this.sfeSignatureDate.toISOString() : undefined as any;
        data["mpSignatureDate"] = this.mpSignatureDate ? this.mpSignatureDate.toISOString() : undefined as any;
        data["nPlus2VisaDate"] = this.nPlus2VisaDate ? this.nPlus2VisaDate.toISOString() : undefined as any;
        data["n2Comment"] = this.n2Comment;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewAgentFunctions)) {
            data["jobInterviewAgentFunctions"] = [];
            for (let item of this.jobInterviewAgentFunctions)
                data["jobInterviewAgentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobInterviewObjectiveQuestions)) {
            data["jobInterviewObjectiveQuestions"] = [];
            for (let item of this.jobInterviewObjectiveQuestions)
                data["jobInterviewObjectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        data["dossierStatus"] = this.dossierStatus;
        data["dossierStatusCode"] = this.dossierStatusCode;
        data["cannotShowN2Comment"] = this.cannotShowN2Comment;
        return data;
    }

    clone(): JobInterviewEditDto {
        const json = this.toJSON();
        let result = new JobInterviewEditDto();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewEditDto {
    id?: number;
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    date?: Date | undefined;
    dossierId?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    n2Comment?: string | undefined;
    questions?: JobInterviewFormQuestionGridDto[] | undefined;
    jobInterviewAgentFunctions?: JobInterviewAgentFunctionGridDto[] | undefined;
    jobInterviewObjectiveQuestions?: JobInterviewObjectiveQuestionGridDto[] | undefined;
    dossierStatus?: string | undefined;
    dossierStatusCode?: EDossierStatus;
    cannotShowN2Comment?: boolean;
}

export class JobInterviewFormQuestionGridDto implements IJobInterviewFormQuestionGridDto {
    id?: number;
    index?: number;
    text?: string | undefined;
    remark?: string | undefined;
    author?: string | undefined;
    formQuestionId?: number;
    jobInterviewId?: number;

    constructor(data?: IJobInterviewFormQuestionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.index = _data["index"];
            this.text = _data["text"];
            this.remark = _data["remark"];
            this.author = _data["author"];
            this.formQuestionId = _data["formQuestionId"];
            this.jobInterviewId = _data["jobInterviewId"];
        }
    }

    static fromJS(data: any): JobInterviewFormQuestionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewFormQuestionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["index"] = this.index;
        data["text"] = this.text;
        data["remark"] = this.remark;
        data["author"] = this.author;
        data["formQuestionId"] = this.formQuestionId;
        data["jobInterviewId"] = this.jobInterviewId;
        return data;
    }

    clone(): JobInterviewFormQuestionGridDto {
        const json = this.toJSON();
        let result = new JobInterviewFormQuestionGridDto();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewFormQuestionGridDto {
    id?: number;
    index?: number;
    text?: string | undefined;
    remark?: string | undefined;
    author?: string | undefined;
    formQuestionId?: number;
    jobInterviewId?: number;
}

export class JobInterviewAgentFunctionGridDto implements IJobInterviewAgentFunctionGridDto {
    id?: number;
    jobInterviewId?: number;
    functionId?: number;
    function?: string | undefined;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    agent?: string | undefined;
    requirement?: EFunctionRequirement;
    specialities?: JobInterviewAgentFunctionSpecialityDto[] | undefined;
    index?: number;
    order?: number;
    note?: string | undefined;
    sharepointUrl?: string | undefined;
    functionalDirector?: string | undefined;

    constructor(data?: IJobInterviewAgentFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobInterviewId = _data["jobInterviewId"];
            this.functionId = _data["functionId"];
            this.function = _data["function"];
            this.isPerformed = _data["isPerformed"];
            this.isHasTechAbilities = _data["isHasTechAbilities"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"];
            this.requirement = _data["requirement"];
            if (Array.isArray(_data["specialities"])) {
                this.specialities = [] as any;
                for (let item of _data["specialities"])
                    this.specialities!.push(JobInterviewAgentFunctionSpecialityDto.fromJS(item));
            }
            this.index = _data["index"];
            this.order = _data["order"];
            this.note = _data["note"];
            this.sharepointUrl = _data["sharepointUrl"];
            this.functionalDirector = _data["functionalDirector"];
        }
    }

    static fromJS(data: any): JobInterviewAgentFunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewAgentFunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobInterviewId"] = this.jobInterviewId;
        data["functionId"] = this.functionId;
        data["function"] = this.function;
        data["isPerformed"] = this.isPerformed;
        data["isHasTechAbilities"] = this.isHasTechAbilities;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent;
        data["requirement"] = this.requirement;
        if (Array.isArray(this.specialities)) {
            data["specialities"] = [];
            for (let item of this.specialities)
                data["specialities"].push(item ? item.toJSON() : undefined as any);
        }
        data["index"] = this.index;
        data["order"] = this.order;
        data["note"] = this.note;
        data["sharepointUrl"] = this.sharepointUrl;
        data["functionalDirector"] = this.functionalDirector;
        return data;
    }

    clone(): JobInterviewAgentFunctionGridDto {
        const json = this.toJSON();
        let result = new JobInterviewAgentFunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewAgentFunctionGridDto {
    id?: number;
    jobInterviewId?: number;
    functionId?: number;
    function?: string | undefined;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    agent?: string | undefined;
    requirement?: EFunctionRequirement;
    specialities?: JobInterviewAgentFunctionSpecialityDto[] | undefined;
    index?: number;
    order?: number;
    note?: string | undefined;
    sharepointUrl?: string | undefined;
    functionalDirector?: string | undefined;
}

export class JobInterviewAgentFunctionSpecialityDto implements IJobInterviewAgentFunctionSpecialityDto {
    id?: number;
    jobInterviewAgentFunctionId?: number;
    specialityId?: number;
    name?: string | undefined;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    hasDirection?: boolean;
    hasPosition?: boolean;

    constructor(data?: IJobInterviewAgentFunctionSpecialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobInterviewAgentFunctionId = _data["jobInterviewAgentFunctionId"];
            this.specialityId = _data["specialityId"];
            this.name = _data["name"];
            this.isChecked = _data["isChecked"];
            this.functionalDirectorId = _data["functionalDirectorId"];
            this.positionId = _data["positionId"];
            this.hasDirection = _data["hasDirection"];
            this.hasPosition = _data["hasPosition"];
        }
    }

    static fromJS(data: any): JobInterviewAgentFunctionSpecialityDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewAgentFunctionSpecialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobInterviewAgentFunctionId"] = this.jobInterviewAgentFunctionId;
        data["specialityId"] = this.specialityId;
        data["name"] = this.name;
        data["isChecked"] = this.isChecked;
        data["functionalDirectorId"] = this.functionalDirectorId;
        data["positionId"] = this.positionId;
        data["hasDirection"] = this.hasDirection;
        data["hasPosition"] = this.hasPosition;
        return data;
    }

    clone(): JobInterviewAgentFunctionSpecialityDto {
        const json = this.toJSON();
        let result = new JobInterviewAgentFunctionSpecialityDto();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewAgentFunctionSpecialityDto {
    id?: number;
    jobInterviewAgentFunctionId?: number;
    specialityId?: number;
    name?: string | undefined;
    isChecked?: boolean;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    hasDirection?: boolean;
    hasPosition?: boolean;
}

export class JobInterviewObjectiveQuestionGridDto implements IJobInterviewObjectiveQuestionGridDto {
    id?: number;
    index?: number;
    title?: string | undefined;
    who?: string | undefined;
    delay?: string | undefined;
    jobInterviewId?: number;
    objectiveQuestionId?: number;
    canBeEdited?: boolean;

    constructor(data?: IJobInterviewObjectiveQuestionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.index = _data["index"];
            this.title = _data["title"];
            this.who = _data["who"];
            this.delay = _data["delay"];
            this.jobInterviewId = _data["jobInterviewId"];
            this.objectiveQuestionId = _data["objectiveQuestionId"];
            this.canBeEdited = _data["canBeEdited"];
        }
    }

    static fromJS(data: any): JobInterviewObjectiveQuestionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewObjectiveQuestionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["index"] = this.index;
        data["title"] = this.title;
        data["who"] = this.who;
        data["delay"] = this.delay;
        data["jobInterviewId"] = this.jobInterviewId;
        data["objectiveQuestionId"] = this.objectiveQuestionId;
        data["canBeEdited"] = this.canBeEdited;
        return data;
    }

    clone(): JobInterviewObjectiveQuestionGridDto {
        const json = this.toJSON();
        let result = new JobInterviewObjectiveQuestionGridDto();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewObjectiveQuestionGridDto {
    id?: number;
    index?: number;
    title?: string | undefined;
    who?: string | undefined;
    delay?: string | undefined;
    jobInterviewId?: number;
    objectiveQuestionId?: number;
    canBeEdited?: boolean;
}

export class JobInterviewCommentDto implements IJobInterviewCommentDto {
    jobInterviewId?: number;
    comment?: string | undefined;

    constructor(data?: IJobInterviewCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobInterviewId = _data["jobInterviewId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): JobInterviewCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobInterviewId"] = this.jobInterviewId;
        data["comment"] = this.comment;
        return data;
    }

    clone(): JobInterviewCommentDto {
        const json = this.toJSON();
        let result = new JobInterviewCommentDto();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewCommentDto {
    jobInterviewId?: number;
    comment?: string | undefined;
}

export class PaginatedResultsOfJobInterviewDateGridDto implements IPaginatedResultsOfJobInterviewDateGridDto {
    totalCount?: number;
    results?: JobInterviewDateGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfJobInterviewDateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(JobInterviewDateGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfJobInterviewDateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfJobInterviewDateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfJobInterviewDateGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfJobInterviewDateGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfJobInterviewDateGridDto {
    totalCount?: number;
    results?: JobInterviewDateGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class JobInterviewDateGridDto implements IJobInterviewDateGridDto {
    id?: number;
    date?: Date;
    assessmentDossierId?: number;
    isCancelled?: boolean;
    cancelledReason?: string | undefined;
    createdOn?: Date;

    constructor(data?: IJobInterviewDateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.assessmentDossierId = _data["assessmentDossierId"];
            this.isCancelled = _data["isCancelled"];
            this.cancelledReason = _data["cancelledReason"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): JobInterviewDateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewDateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["assessmentDossierId"] = this.assessmentDossierId;
        data["isCancelled"] = this.isCancelled;
        data["cancelledReason"] = this.cancelledReason;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }

    clone(): JobInterviewDateGridDto {
        const json = this.toJSON();
        let result = new JobInterviewDateGridDto();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewDateGridDto {
    id?: number;
    date?: Date;
    assessmentDossierId?: number;
    isCancelled?: boolean;
    cancelledReason?: string | undefined;
    createdOn?: Date;
}

export class SearchQueryOfJobInterviewDateSearchCriterias implements ISearchQueryOfJobInterviewDateSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: JobInterviewDateSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfJobInterviewDateSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? JobInterviewDateSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfJobInterviewDateSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfJobInterviewDateSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfJobInterviewDateSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfJobInterviewDateSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfJobInterviewDateSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: JobInterviewDateSearchCriterias | undefined;
}

export class JobInterviewDateSearchCriterias extends PaginatedSearchable implements IJobInterviewDateSearchCriterias {
    assessementDossierId?: number | undefined;

    constructor(data?: IJobInterviewDateSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assessementDossierId = _data["assessementDossierId"];
        }
    }

    static override fromJS(data: any): JobInterviewDateSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewDateSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessementDossierId"] = this.assessementDossierId;
        super.toJSON(data);
        return data;
    }

    clone(): JobInterviewDateSearchCriterias {
        const json = this.toJSON();
        let result = new JobInterviewDateSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewDateSearchCriterias extends IPaginatedSearchable {
    assessementDossierId?: number | undefined;
}

export class PaginatedResultsOfJobInterviewFormQuestionGridDto implements IPaginatedResultsOfJobInterviewFormQuestionGridDto {
    totalCount?: number;
    results?: JobInterviewFormQuestionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfJobInterviewFormQuestionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(JobInterviewFormQuestionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfJobInterviewFormQuestionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfJobInterviewFormQuestionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfJobInterviewFormQuestionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfJobInterviewFormQuestionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfJobInterviewFormQuestionGridDto {
    totalCount?: number;
    results?: JobInterviewFormQuestionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SearchQueryOfJobInterviewFormQuestionSearchCriterias implements ISearchQueryOfJobInterviewFormQuestionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: JobInterviewFormQuestionSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfJobInterviewFormQuestionSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? JobInterviewFormQuestionSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfJobInterviewFormQuestionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfJobInterviewFormQuestionSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfJobInterviewFormQuestionSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfJobInterviewFormQuestionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfJobInterviewFormQuestionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: JobInterviewFormQuestionSearchCriterias | undefined;
}

export class JobInterviewFormQuestionSearchCriterias extends PaginatedSearchable implements IJobInterviewFormQuestionSearchCriterias {
    jobInterviewId?: number;

    constructor(data?: IJobInterviewFormQuestionSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobInterviewId = _data["jobInterviewId"];
        }
    }

    static override fromJS(data: any): JobInterviewFormQuestionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new JobInterviewFormQuestionSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobInterviewId"] = this.jobInterviewId;
        super.toJSON(data);
        return data;
    }

    clone(): JobInterviewFormQuestionSearchCriterias {
        const json = this.toJSON();
        let result = new JobInterviewFormQuestionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IJobInterviewFormQuestionSearchCriterias extends IPaginatedSearchable {
    jobInterviewId?: number;
}

export class LanguageDto implements ILanguageDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;
    orderIndex?: number;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
            this.isActive = _data["isActive"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        data["isActive"] = this.isActive;
        data["orderIndex"] = this.orderIndex;
        return data;
    }

    clone(): LanguageDto {
        const json = this.toJSON();
        let result = new LanguageDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;
    orderIndex?: number;
}

export class MentionEditDto implements IMentionEditDto {
    id?: number;
    code?: EMention;
    dataTranslation?: DataTranslationDto | undefined;
    isActive?: boolean;

    constructor(data?: IMentionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MentionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MentionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): MentionEditDto {
        const json = this.toJSON();
        let result = new MentionEditDto();
        result.init(json);
        return result;
    }
}

export interface IMentionEditDto {
    id?: number;
    code?: EMention;
    dataTranslation?: DataTranslationDto | undefined;
    isActive?: boolean;
}

export class PaginatedResultsOfMentionGridDto implements IPaginatedResultsOfMentionGridDto {
    totalCount?: number;
    results?: MentionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfMentionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MentionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfMentionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfMentionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfMentionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfMentionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfMentionGridDto {
    totalCount?: number;
    results?: MentionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class MentionGridDto implements IMentionGridDto {
    id?: number;
    code?: EMention;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IMentionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MentionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MentionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): MentionGridDto {
        const json = this.toJSON();
        let result = new MentionGridDto();
        result.init(json);
        return result;
    }
}

export interface IMentionGridDto {
    id?: number;
    code?: EMention;
    description?: string | undefined;
    isActive?: boolean;
}

export class SearchQueryOfMentionSearchCriterias implements ISearchQueryOfMentionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MentionSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfMentionSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? MentionSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfMentionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfMentionSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfMentionSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfMentionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfMentionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MentionSearchCriterias | undefined;
}

export class MentionSearchCriterias extends PaginatedSearchable implements IMentionSearchCriterias {

    constructor(data?: IMentionSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MentionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new MentionSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MentionSearchCriterias {
        const json = this.toJSON();
        let result = new MentionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IMentionSearchCriterias extends IPaginatedSearchable {
}

export class ObjectiveQuestionEditDto implements IObjectiveQuestionEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    isActive?: boolean;
    canBeEdited?: boolean;
    formTypeId?: number | undefined;

    constructor(data?: IObjectiveQuestionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : undefined as any;
            this.isActive = _data["isActive"];
            this.canBeEdited = _data["canBeEdited"];
            this.formTypeId = _data["formTypeId"];
        }
    }

    static fromJS(data: any): ObjectiveQuestionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveQuestionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        data["canBeEdited"] = this.canBeEdited;
        data["formTypeId"] = this.formTypeId;
        return data;
    }

    clone(): ObjectiveQuestionEditDto {
        const json = this.toJSON();
        let result = new ObjectiveQuestionEditDto();
        result.init(json);
        return result;
    }
}

export interface IObjectiveQuestionEditDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    isActive?: boolean;
    canBeEdited?: boolean;
    formTypeId?: number | undefined;
}

export class PaginatedResultsOfObjectiveQuestionGridDto implements IPaginatedResultsOfObjectiveQuestionGridDto {
    totalCount?: number;
    results?: ObjectiveQuestionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfObjectiveQuestionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ObjectiveQuestionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfObjectiveQuestionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfObjectiveQuestionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfObjectiveQuestionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfObjectiveQuestionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfObjectiveQuestionGridDto {
    totalCount?: number;
    results?: ObjectiveQuestionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ObjectiveQuestionGridDto implements IObjectiveQuestionGridDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;
    isActive?: boolean;
    canBeEdited?: boolean;
    formType?: string | undefined;

    constructor(data?: IObjectiveQuestionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.text = _data["text"];
            this.isActive = _data["isActive"];
            this.canBeEdited = _data["canBeEdited"];
            this.formType = _data["formType"];
        }
    }

    static fromJS(data: any): ObjectiveQuestionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveQuestionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["text"] = this.text;
        data["isActive"] = this.isActive;
        data["canBeEdited"] = this.canBeEdited;
        data["formType"] = this.formType;
        return data;
    }

    clone(): ObjectiveQuestionGridDto {
        const json = this.toJSON();
        let result = new ObjectiveQuestionGridDto();
        result.init(json);
        return result;
    }
}

export interface IObjectiveQuestionGridDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;
    isActive?: boolean;
    canBeEdited?: boolean;
    formType?: string | undefined;
}

export class SearchQueryOfObjectiveQuestionSearchCriterias implements ISearchQueryOfObjectiveQuestionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ObjectiveQuestionSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfObjectiveQuestionSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? ObjectiveQuestionSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfObjectiveQuestionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfObjectiveQuestionSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfObjectiveQuestionSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfObjectiveQuestionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfObjectiveQuestionSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ObjectiveQuestionSearchCriterias | undefined;
}

export class ObjectiveQuestionSearchCriterias extends PaginatedSearchable implements IObjectiveQuestionSearchCriterias {

    constructor(data?: IObjectiveQuestionSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ObjectiveQuestionSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveQuestionSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ObjectiveQuestionSearchCriterias {
        const json = this.toJSON();
        let result = new ObjectiveQuestionSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IObjectiveQuestionSearchCriterias extends IPaginatedSearchable {
}

export class OperationalInterviewEditDto implements IOperationalInterviewEditDto {
    id?: number;
    date?: Date | undefined;
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    mpId?: number;
    dossierId?: number;
    askingAgentId?: number;
    number?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    operationalInterviewAgentFunctions?: OperationalInterviewAgentFunctionGridDto[] | undefined;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterviewGridDto[] | undefined;
    operationalInterviewSpecificSubjects?: OperationalInterviewSpecificSubjectEditDto[] | undefined;
    operationalInterviewObjectiveQuestions?: OperationalInterviewObjectiveQuestionGridDto[] | undefined;
    selectedRequired?: number[] | undefined;
    selectedOptional?: number[] | undefined;

    constructor(data?: IOperationalInterviewEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.sfeId = _data["sfeId"];
            this.agentN2Id = _data["agentN2Id"];
            this.mpId = _data["mpId"];
            this.dossierId = _data["dossierId"];
            this.askingAgentId = _data["askingAgentId"];
            this.number = _data["number"];
            this.sfeSignatureDate = _data["sfeSignatureDate"] ? new Date(_data["sfeSignatureDate"].toString()) : undefined as any;
            this.mpSignatureDate = _data["mpSignatureDate"] ? new Date(_data["mpSignatureDate"].toString()) : undefined as any;
            this.nPlus2VisaDate = _data["nPlus2VisaDate"] ? new Date(_data["nPlus2VisaDate"].toString()) : undefined as any;
            if (Array.isArray(_data["operationalInterviewAgentFunctions"])) {
                this.operationalInterviewAgentFunctions = [] as any;
                for (let item of _data["operationalInterviewAgentFunctions"])
                    this.operationalInterviewAgentFunctions!.push(OperationalInterviewAgentFunctionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["formQuestionOperationalInterviews"])) {
                this.formQuestionOperationalInterviews = [] as any;
                for (let item of _data["formQuestionOperationalInterviews"])
                    this.formQuestionOperationalInterviews!.push(FormQuestionOperationalInterviewGridDto.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewSpecificSubjects"])) {
                this.operationalInterviewSpecificSubjects = [] as any;
                for (let item of _data["operationalInterviewSpecificSubjects"])
                    this.operationalInterviewSpecificSubjects!.push(OperationalInterviewSpecificSubjectEditDto.fromJS(item));
            }
            if (Array.isArray(_data["operationalInterviewObjectiveQuestions"])) {
                this.operationalInterviewObjectiveQuestions = [] as any;
                for (let item of _data["operationalInterviewObjectiveQuestions"])
                    this.operationalInterviewObjectiveQuestions!.push(OperationalInterviewObjectiveQuestionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedRequired"])) {
                this.selectedRequired = [] as any;
                for (let item of _data["selectedRequired"])
                    this.selectedRequired!.push(item);
            }
            if (Array.isArray(_data["selectedOptional"])) {
                this.selectedOptional = [] as any;
                for (let item of _data["selectedOptional"])
                    this.selectedOptional!.push(item);
            }
        }
    }

    static fromJS(data: any): OperationalInterviewEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["sfeId"] = this.sfeId;
        data["agentN2Id"] = this.agentN2Id;
        data["mpId"] = this.mpId;
        data["dossierId"] = this.dossierId;
        data["askingAgentId"] = this.askingAgentId;
        data["number"] = this.number;
        data["sfeSignatureDate"] = this.sfeSignatureDate ? this.sfeSignatureDate.toISOString() : undefined as any;
        data["mpSignatureDate"] = this.mpSignatureDate ? this.mpSignatureDate.toISOString() : undefined as any;
        data["nPlus2VisaDate"] = this.nPlus2VisaDate ? this.nPlus2VisaDate.toISOString() : undefined as any;
        if (Array.isArray(this.operationalInterviewAgentFunctions)) {
            data["operationalInterviewAgentFunctions"] = [];
            for (let item of this.operationalInterviewAgentFunctions)
                data["operationalInterviewAgentFunctions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formQuestionOperationalInterviews)) {
            data["formQuestionOperationalInterviews"] = [];
            for (let item of this.formQuestionOperationalInterviews)
                data["formQuestionOperationalInterviews"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewSpecificSubjects)) {
            data["operationalInterviewSpecificSubjects"] = [];
            for (let item of this.operationalInterviewSpecificSubjects)
                data["operationalInterviewSpecificSubjects"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.operationalInterviewObjectiveQuestions)) {
            data["operationalInterviewObjectiveQuestions"] = [];
            for (let item of this.operationalInterviewObjectiveQuestions)
                data["operationalInterviewObjectiveQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.selectedRequired)) {
            data["selectedRequired"] = [];
            for (let item of this.selectedRequired)
                data["selectedRequired"].push(item);
        }
        if (Array.isArray(this.selectedOptional)) {
            data["selectedOptional"] = [];
            for (let item of this.selectedOptional)
                data["selectedOptional"].push(item);
        }
        return data;
    }

    clone(): OperationalInterviewEditDto {
        const json = this.toJSON();
        let result = new OperationalInterviewEditDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewEditDto {
    id?: number;
    date?: Date | undefined;
    sfeId?: number | undefined;
    agentN2Id?: number | undefined;
    mpId?: number;
    dossierId?: number;
    askingAgentId?: number;
    number?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    operationalInterviewAgentFunctions?: OperationalInterviewAgentFunctionGridDto[] | undefined;
    formQuestionOperationalInterviews?: FormQuestionOperationalInterviewGridDto[] | undefined;
    operationalInterviewSpecificSubjects?: OperationalInterviewSpecificSubjectEditDto[] | undefined;
    operationalInterviewObjectiveQuestions?: OperationalInterviewObjectiveQuestionGridDto[] | undefined;
    selectedRequired?: number[] | undefined;
    selectedOptional?: number[] | undefined;
}

export class OperationalInterviewAgentFunctionGridDto implements IOperationalInterviewAgentFunctionGridDto {
    id?: number;
    function?: string | undefined;
    functionId?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    operationalInterviewId?: number;
    requirement?: EFunctionRequirement | undefined;
    remarkSfe?: string | undefined;
    remarkMp?: string | undefined;
    index?: number;
    order?: number;
    note?: string | undefined;
    specialities?: OperationalInterviewAgentFunctionSpecialityDto[] | undefined;

    constructor(data?: IOperationalInterviewAgentFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.function = _data["function"];
            this.functionId = _data["functionId"];
            this.isPerformed = _data["isPerformed"];
            this.isHasTechAbilities = _data["isHasTechAbilities"];
            this.agentId = _data["agentId"];
            this.operationalInterviewId = _data["operationalInterviewId"];
            this.requirement = _data["requirement"];
            this.remarkSfe = _data["remarkSfe"];
            this.remarkMp = _data["remarkMp"];
            this.index = _data["index"];
            this.order = _data["order"];
            this.note = _data["note"];
            if (Array.isArray(_data["specialities"])) {
                this.specialities = [] as any;
                for (let item of _data["specialities"])
                    this.specialities!.push(OperationalInterviewAgentFunctionSpecialityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperationalInterviewAgentFunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewAgentFunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["function"] = this.function;
        data["functionId"] = this.functionId;
        data["isPerformed"] = this.isPerformed;
        data["isHasTechAbilities"] = this.isHasTechAbilities;
        data["agentId"] = this.agentId;
        data["operationalInterviewId"] = this.operationalInterviewId;
        data["requirement"] = this.requirement;
        data["remarkSfe"] = this.remarkSfe;
        data["remarkMp"] = this.remarkMp;
        data["index"] = this.index;
        data["order"] = this.order;
        data["note"] = this.note;
        if (Array.isArray(this.specialities)) {
            data["specialities"] = [];
            for (let item of this.specialities)
                data["specialities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): OperationalInterviewAgentFunctionGridDto {
        const json = this.toJSON();
        let result = new OperationalInterviewAgentFunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewAgentFunctionGridDto {
    id?: number;
    function?: string | undefined;
    functionId?: number;
    isPerformed?: boolean;
    isHasTechAbilities?: boolean;
    agentId?: number;
    operationalInterviewId?: number;
    requirement?: EFunctionRequirement | undefined;
    remarkSfe?: string | undefined;
    remarkMp?: string | undefined;
    index?: number;
    order?: number;
    note?: string | undefined;
    specialities?: OperationalInterviewAgentFunctionSpecialityDto[] | undefined;
}

export class OperationalInterviewAgentFunctionSpecialityDto implements IOperationalInterviewAgentFunctionSpecialityDto {
    id?: number;
    operationalInterviewAgentFunctionId?: number;
    specialityId?: number;
    name?: string | undefined;
    isChecked?: boolean;
    index?: number;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    hasDirection?: boolean;
    hasPosition?: boolean;

    constructor(data?: IOperationalInterviewAgentFunctionSpecialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operationalInterviewAgentFunctionId = _data["operationalInterviewAgentFunctionId"];
            this.specialityId = _data["specialityId"];
            this.name = _data["name"];
            this.isChecked = _data["isChecked"];
            this.index = _data["index"];
            this.functionalDirectorId = _data["functionalDirectorId"];
            this.positionId = _data["positionId"];
            this.hasDirection = _data["hasDirection"];
            this.hasPosition = _data["hasPosition"];
        }
    }

    static fromJS(data: any): OperationalInterviewAgentFunctionSpecialityDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewAgentFunctionSpecialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operationalInterviewAgentFunctionId"] = this.operationalInterviewAgentFunctionId;
        data["specialityId"] = this.specialityId;
        data["name"] = this.name;
        data["isChecked"] = this.isChecked;
        data["index"] = this.index;
        data["functionalDirectorId"] = this.functionalDirectorId;
        data["positionId"] = this.positionId;
        data["hasDirection"] = this.hasDirection;
        data["hasPosition"] = this.hasPosition;
        return data;
    }

    clone(): OperationalInterviewAgentFunctionSpecialityDto {
        const json = this.toJSON();
        let result = new OperationalInterviewAgentFunctionSpecialityDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewAgentFunctionSpecialityDto {
    id?: number;
    operationalInterviewAgentFunctionId?: number;
    specialityId?: number;
    name?: string | undefined;
    isChecked?: boolean;
    index?: number;
    functionalDirectorId?: number | undefined;
    positionId?: number | undefined;
    hasDirection?: boolean;
    hasPosition?: boolean;
}

export class FormQuestionOperationalInterviewGridDto implements IFormQuestionOperationalInterviewGridDto {
    id?: number;
    operationalInterviewId?: number | undefined;
    formQuestionOperationalId?: number | undefined;
    jobInterviewAgentFunctionId?: number | undefined;
    text?: string | undefined;
    formQuestionText?: string | undefined;
    agentFunctionText?: string | undefined;
    sfRemark?: string | undefined;
    mpRemark?: string | undefined;
    index?: number;

    constructor(data?: IFormQuestionOperationalInterviewGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operationalInterviewId = _data["operationalInterviewId"];
            this.formQuestionOperationalId = _data["formQuestionOperationalId"];
            this.jobInterviewAgentFunctionId = _data["jobInterviewAgentFunctionId"];
            this.text = _data["text"];
            this.formQuestionText = _data["formQuestionText"];
            this.agentFunctionText = _data["agentFunctionText"];
            this.sfRemark = _data["sfRemark"];
            this.mpRemark = _data["mpRemark"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): FormQuestionOperationalInterviewGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionOperationalInterviewGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operationalInterviewId"] = this.operationalInterviewId;
        data["formQuestionOperationalId"] = this.formQuestionOperationalId;
        data["jobInterviewAgentFunctionId"] = this.jobInterviewAgentFunctionId;
        data["text"] = this.text;
        data["formQuestionText"] = this.formQuestionText;
        data["agentFunctionText"] = this.agentFunctionText;
        data["sfRemark"] = this.sfRemark;
        data["mpRemark"] = this.mpRemark;
        data["index"] = this.index;
        return data;
    }

    clone(): FormQuestionOperationalInterviewGridDto {
        const json = this.toJSON();
        let result = new FormQuestionOperationalInterviewGridDto();
        result.init(json);
        return result;
    }
}

export interface IFormQuestionOperationalInterviewGridDto {
    id?: number;
    operationalInterviewId?: number | undefined;
    formQuestionOperationalId?: number | undefined;
    jobInterviewAgentFunctionId?: number | undefined;
    text?: string | undefined;
    formQuestionText?: string | undefined;
    agentFunctionText?: string | undefined;
    sfRemark?: string | undefined;
    mpRemark?: string | undefined;
    index?: number;
}

export class OperationalInterviewSpecificSubjectEditDto implements IOperationalInterviewSpecificSubjectEditDto {
    id?: number;
    name?: string | undefined;
    sfeRemark?: string | undefined;
    mpRemark?: string | undefined;
    index?: number;
    operationalInterviewId?: number;

    constructor(data?: IOperationalInterviewSpecificSubjectEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sfeRemark = _data["sfeRemark"];
            this.mpRemark = _data["mpRemark"];
            this.index = _data["index"];
            this.operationalInterviewId = _data["operationalInterviewId"];
        }
    }

    static fromJS(data: any): OperationalInterviewSpecificSubjectEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewSpecificSubjectEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sfeRemark"] = this.sfeRemark;
        data["mpRemark"] = this.mpRemark;
        data["index"] = this.index;
        data["operationalInterviewId"] = this.operationalInterviewId;
        return data;
    }

    clone(): OperationalInterviewSpecificSubjectEditDto {
        const json = this.toJSON();
        let result = new OperationalInterviewSpecificSubjectEditDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewSpecificSubjectEditDto {
    id?: number;
    name?: string | undefined;
    sfeRemark?: string | undefined;
    mpRemark?: string | undefined;
    index?: number;
    operationalInterviewId?: number;
}

export class OperationalInterviewObjectiveQuestionGridDto implements IOperationalInterviewObjectiveQuestionGridDto {
    id?: number;
    index?: number;
    title?: string | undefined;
    who?: string | undefined;
    delay?: string | undefined;
    operationalInterviewId?: number;
    objectiveQuestionId?: number;
    canBeEdited?: boolean;

    constructor(data?: IOperationalInterviewObjectiveQuestionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.index = _data["index"];
            this.title = _data["title"];
            this.who = _data["who"];
            this.delay = _data["delay"];
            this.operationalInterviewId = _data["operationalInterviewId"];
            this.objectiveQuestionId = _data["objectiveQuestionId"];
            this.canBeEdited = _data["canBeEdited"];
        }
    }

    static fromJS(data: any): OperationalInterviewObjectiveQuestionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewObjectiveQuestionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["index"] = this.index;
        data["title"] = this.title;
        data["who"] = this.who;
        data["delay"] = this.delay;
        data["operationalInterviewId"] = this.operationalInterviewId;
        data["objectiveQuestionId"] = this.objectiveQuestionId;
        data["canBeEdited"] = this.canBeEdited;
        return data;
    }

    clone(): OperationalInterviewObjectiveQuestionGridDto {
        const json = this.toJSON();
        let result = new OperationalInterviewObjectiveQuestionGridDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewObjectiveQuestionGridDto {
    id?: number;
    index?: number;
    title?: string | undefined;
    who?: string | undefined;
    delay?: string | undefined;
    operationalInterviewId?: number;
    objectiveQuestionId?: number;
    canBeEdited?: boolean;
}

export class PaginatedResultsOfOperationalInterviewGridDto implements IPaginatedResultsOfOperationalInterviewGridDto {
    totalCount?: number;
    results?: OperationalInterviewGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfOperationalInterviewGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OperationalInterviewGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfOperationalInterviewGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfOperationalInterviewGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfOperationalInterviewGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfOperationalInterviewGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfOperationalInterviewGridDto {
    totalCount?: number;
    results?: OperationalInterviewGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class OperationalInterviewGridDto implements IOperationalInterviewGridDto {
    id?: number;
    date?: Date;
    sfeId?: number;
    mpId?: number;
    dossierId?: number;
    number?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    askingAgent?: string | undefined;

    constructor(data?: IOperationalInterviewGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.sfeId = _data["sfeId"];
            this.mpId = _data["mpId"];
            this.dossierId = _data["dossierId"];
            this.number = _data["number"];
            this.sfeSignatureDate = _data["sfeSignatureDate"] ? new Date(_data["sfeSignatureDate"].toString()) : undefined as any;
            this.mpSignatureDate = _data["mpSignatureDate"] ? new Date(_data["mpSignatureDate"].toString()) : undefined as any;
            this.nPlus2VisaDate = _data["nPlus2VisaDate"] ? new Date(_data["nPlus2VisaDate"].toString()) : undefined as any;
            this.askingAgent = _data["askingAgent"];
        }
    }

    static fromJS(data: any): OperationalInterviewGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["sfeId"] = this.sfeId;
        data["mpId"] = this.mpId;
        data["dossierId"] = this.dossierId;
        data["number"] = this.number;
        data["sfeSignatureDate"] = this.sfeSignatureDate ? this.sfeSignatureDate.toISOString() : undefined as any;
        data["mpSignatureDate"] = this.mpSignatureDate ? this.mpSignatureDate.toISOString() : undefined as any;
        data["nPlus2VisaDate"] = this.nPlus2VisaDate ? this.nPlus2VisaDate.toISOString() : undefined as any;
        data["askingAgent"] = this.askingAgent;
        return data;
    }

    clone(): OperationalInterviewGridDto {
        const json = this.toJSON();
        let result = new OperationalInterviewGridDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewGridDto {
    id?: number;
    date?: Date;
    sfeId?: number;
    mpId?: number;
    dossierId?: number;
    number?: number;
    sfeSignatureDate?: Date | undefined;
    mpSignatureDate?: Date | undefined;
    nPlus2VisaDate?: Date | undefined;
    askingAgent?: string | undefined;
}

export class SearchQueryOfOperationalInterviewSearchCriterias implements ISearchQueryOfOperationalInterviewSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: OperationalInterviewSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfOperationalInterviewSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? OperationalInterviewSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfOperationalInterviewSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfOperationalInterviewSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfOperationalInterviewSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfOperationalInterviewSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfOperationalInterviewSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: OperationalInterviewSearchCriterias | undefined;
}

export class OperationalInterviewSearchCriterias extends PaginatedSearchable implements IOperationalInterviewSearchCriterias {
    dossierId?: number;

    constructor(data?: IOperationalInterviewSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dossierId = _data["dossierId"];
        }
    }

    static override fromJS(data: any): OperationalInterviewSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dossierId"] = this.dossierId;
        super.toJSON(data);
        return data;
    }

    clone(): OperationalInterviewSearchCriterias {
        const json = this.toJSON();
        let result = new OperationalInterviewSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewSearchCriterias extends IPaginatedSearchable {
    dossierId?: number;
}

export class PaginatedResultsOfOperationalInterviewDateGridDto implements IPaginatedResultsOfOperationalInterviewDateGridDto {
    totalCount?: number;
    results?: OperationalInterviewDateGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfOperationalInterviewDateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OperationalInterviewDateGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfOperationalInterviewDateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfOperationalInterviewDateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfOperationalInterviewDateGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfOperationalInterviewDateGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfOperationalInterviewDateGridDto {
    totalCount?: number;
    results?: OperationalInterviewDateGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class OperationalInterviewDateGridDto implements IOperationalInterviewDateGridDto {
    id?: number;
    date?: Date;
    assessmentDossierId?: number;
    reason?: string | undefined;
    createdOn?: Date;

    constructor(data?: IOperationalInterviewDateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.assessmentDossierId = _data["assessmentDossierId"];
            this.reason = _data["reason"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OperationalInterviewDateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewDateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["assessmentDossierId"] = this.assessmentDossierId;
        data["reason"] = this.reason;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }

    clone(): OperationalInterviewDateGridDto {
        const json = this.toJSON();
        let result = new OperationalInterviewDateGridDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewDateGridDto {
    id?: number;
    date?: Date;
    assessmentDossierId?: number;
    reason?: string | undefined;
    createdOn?: Date;
}

export class SearchQueryOfOperationalInterviewDateSearchCriterias implements ISearchQueryOfOperationalInterviewDateSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: OperationalInterviewDateSearchCriterias | undefined;

    constructor(data?: ISearchQueryOfOperationalInterviewDateSearchCriterias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? OperationalInterviewDateSearchCriterias.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfOperationalInterviewDateSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfOperationalInterviewDateSearchCriterias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfOperationalInterviewDateSearchCriterias {
        const json = this.toJSON();
        let result = new SearchQueryOfOperationalInterviewDateSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfOperationalInterviewDateSearchCriterias {
    expression?: AbstractSearchExpression | undefined;
    criteria?: OperationalInterviewDateSearchCriterias | undefined;
}

export class OperationalInterviewDateSearchCriterias extends PaginatedSearchable implements IOperationalInterviewDateSearchCriterias {
    assessementDossierId?: number | undefined;

    constructor(data?: IOperationalInterviewDateSearchCriterias) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assessementDossierId = _data["assessementDossierId"];
        }
    }

    static override fromJS(data: any): OperationalInterviewDateSearchCriterias {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalInterviewDateSearchCriterias();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessementDossierId"] = this.assessementDossierId;
        super.toJSON(data);
        return data;
    }

    clone(): OperationalInterviewDateSearchCriterias {
        const json = this.toJSON();
        let result = new OperationalInterviewDateSearchCriterias();
        result.init(json);
        return result;
    }
}

export interface IOperationalInterviewDateSearchCriterias extends IPaginatedSearchable {
    assessementDossierId?: number | undefined;
}

export class EditSearchCriteriaDto implements IEditSearchCriteriaDto {
    searchCriteriaId?: number;
    searchName?: string | undefined;
    jsonCriteria?: string | undefined;
    advanced?: boolean;
    userId?: number | undefined;

    constructor(data?: IEditSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaId = _data["searchCriteriaId"];
            this.searchName = _data["searchName"];
            this.jsonCriteria = _data["jsonCriteria"];
            this.advanced = _data["advanced"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): EditSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaId"] = this.searchCriteriaId;
        data["searchName"] = this.searchName;
        data["jsonCriteria"] = this.jsonCriteria;
        data["advanced"] = this.advanced;
        data["userId"] = this.userId;
        return data;
    }

    clone(): EditSearchCriteriaDto {
        const json = this.toJSON();
        let result = new EditSearchCriteriaDto();
        result.init(json);
        return result;
    }
}

export interface IEditSearchCriteriaDto {
    searchCriteriaId?: number;
    searchName?: string | undefined;
    jsonCriteria?: string | undefined;
    advanced?: boolean;
    userId?: number | undefined;
}

export class SubstitutionEditDto implements ISubstitutionEditDto {
    id?: number;
    agentId?: number;
    substituteId?: number;
    substitutionStartDate?: Date;
    substitutionEndDate?: Date | undefined;

    constructor(data?: ISubstitutionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.substituteId = _data["substituteId"];
            this.substitutionStartDate = _data["substitutionStartDate"] ? new Date(_data["substitutionStartDate"].toString()) : undefined as any;
            this.substitutionEndDate = _data["substitutionEndDate"] ? new Date(_data["substitutionEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SubstitutionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubstitutionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["substituteId"] = this.substituteId;
        data["substitutionStartDate"] = this.substitutionStartDate ? this.substitutionStartDate.toISOString() : undefined as any;
        data["substitutionEndDate"] = this.substitutionEndDate ? this.substitutionEndDate.toISOString() : undefined as any;
        return data;
    }

    clone(): SubstitutionEditDto {
        const json = this.toJSON();
        let result = new SubstitutionEditDto();
        result.init(json);
        return result;
    }
}

export interface ISubstitutionEditDto {
    id?: number;
    agentId?: number;
    substituteId?: number;
    substitutionStartDate?: Date;
    substitutionEndDate?: Date | undefined;
}

export class PaginatedResultsOfSubstitutionGridDto implements IPaginatedResultsOfSubstitutionGridDto {
    totalCount?: number;
    results?: SubstitutionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSubstitutionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SubstitutionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSubstitutionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSubstitutionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfSubstitutionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfSubstitutionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfSubstitutionGridDto {
    totalCount?: number;
    results?: SubstitutionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SubstitutionGridDto implements ISubstitutionGridDto {
    agentId?: number;
    substituteId?: number;
    substitutionStartDate?: Date;
    substitutionEndDate?: Date | undefined;
    agentName?: string | undefined;
    substituteName?: string | undefined;

    constructor(data?: ISubstitutionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.substituteId = _data["substituteId"];
            this.substitutionStartDate = _data["substitutionStartDate"] ? new Date(_data["substitutionStartDate"].toString()) : undefined as any;
            this.substitutionEndDate = _data["substitutionEndDate"] ? new Date(_data["substitutionEndDate"].toString()) : undefined as any;
            this.agentName = _data["agentName"];
            this.substituteName = _data["substituteName"];
        }
    }

    static fromJS(data: any): SubstitutionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubstitutionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["substituteId"] = this.substituteId;
        data["substitutionStartDate"] = this.substitutionStartDate ? this.substitutionStartDate.toISOString() : undefined as any;
        data["substitutionEndDate"] = this.substitutionEndDate ? this.substitutionEndDate.toISOString() : undefined as any;
        data["agentName"] = this.agentName;
        data["substituteName"] = this.substituteName;
        return data;
    }

    clone(): SubstitutionGridDto {
        const json = this.toJSON();
        let result = new SubstitutionGridDto();
        result.init(json);
        return result;
    }
}

export interface ISubstitutionGridDto {
    agentId?: number;
    substituteId?: number;
    substitutionStartDate?: Date;
    substitutionEndDate?: Date | undefined;
    agentName?: string | undefined;
    substituteName?: string | undefined;
}

export class SearchQueryOfSubstitutionSearchCriteria implements ISearchQueryOfSubstitutionSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SubstitutionSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfSubstitutionSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? SubstitutionSearchCriteria.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfSubstitutionSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfSubstitutionSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfSubstitutionSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfSubstitutionSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfSubstitutionSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SubstitutionSearchCriteria | undefined;
}

export class SubstitutionSearchCriteria extends PaginatedSearchable implements ISubstitutionSearchCriteria {

    constructor(data?: ISubstitutionSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SubstitutionSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SubstitutionSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): SubstitutionSearchCriteria {
        const json = this.toJSON();
        let result = new SubstitutionSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISubstitutionSearchCriteria extends IPaginatedSearchable {
}

export class SystemInfoDto implements ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;

    constructor(data?: ISystemInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.applicationVersion = _data["applicationVersion"];
            this.environment = _data["environment"];
            this.database = _data["database"];
        }
    }

    static fromJS(data: any): SystemInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["applicationVersion"] = this.applicationVersion;
        data["environment"] = this.environment;
        data["database"] = this.database;
        return data;
    }

    clone(): SystemInfoDto {
        const json = this.toJSON();
        let result = new SystemInfoDto();
        result.init(json);
        return result;
    }
}

export interface ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;
}

export class ExposedTypes implements IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
    dataTranslationDto?: DataTranslationDto | undefined;
    resultErrors?: ResultError[] | undefined;

    constructor(data?: IExposedTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionCode = _data["actionCode"];
            this.errorDetails = _data["errorDetails"] ? ErrorDetails.fromJS(_data["errorDetails"]) : undefined as any;
            this.errorResult = _data["errorResult"] ? ResultError.fromJS(_data["errorResult"]) : undefined as any;
            this.dataTranslationDto = _data["dataTranslationDto"] ? DataTranslationDto.fromJS(_data["dataTranslationDto"]) : undefined as any;
            if (Array.isArray(_data["resultErrors"])) {
                this.resultErrors = [] as any;
                for (let item of _data["resultErrors"])
                    this.resultErrors!.push(ResultError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExposedTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ExposedTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["errorDetails"] = this.errorDetails ? this.errorDetails.toJSON() : undefined as any;
        data["errorResult"] = this.errorResult ? this.errorResult.toJSON() : undefined as any;
        data["dataTranslationDto"] = this.dataTranslationDto ? this.dataTranslationDto.toJSON() : undefined as any;
        if (Array.isArray(this.resultErrors)) {
            data["resultErrors"] = [];
            for (let item of this.resultErrors)
                data["resultErrors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ExposedTypes {
        const json = this.toJSON();
        let result = new ExposedTypes();
        result.init(json);
        return result;
    }
}

export interface IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
    dataTranslationDto?: DataTranslationDto | undefined;
    resultErrors?: ResultError[] | undefined;
}

export class ErrorDetails implements IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.stackTrace = _data["stackTrace"];
            this.exceptionType = _data["exceptionType"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["stackTrace"] = this.stackTrace;
        data["exceptionType"] = this.exceptionType;
        data["errorCode"] = this.errorCode;
        return data;
    }

    clone(): ErrorDetails {
        const json = this.toJSON();
        let result = new ErrorDetails();
        result.init(json);
        return result;
    }
}

export interface IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;
}

export class FrontendSettings implements IFrontendSettings {
    azureClientId?: string | undefined;
    azureAuthority?: string | undefined;
    azureApiScope?: string | undefined;

    constructor(data?: IFrontendSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureClientId = _data["azureClientId"];
            this.azureAuthority = _data["azureAuthority"];
            this.azureApiScope = _data["azureApiScope"];
        }
    }

    static fromJS(data: any): FrontendSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureClientId"] = this.azureClientId;
        data["azureAuthority"] = this.azureAuthority;
        data["azureApiScope"] = this.azureApiScope;
        return data;
    }

    clone(): FrontendSettings {
        const json = this.toJSON();
        let result = new FrontendSettings();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettings {
    azureClientId?: string | undefined;
    azureAuthority?: string | undefined;
    azureApiScope?: string | undefined;
}

export class PaginatedResultsOfTranslationCodeDto implements IPaginatedResultsOfTranslationCodeDto {
    totalCount?: number;
    results?: TranslationCodeDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTranslationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TranslationCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTranslationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTranslationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfTranslationCodeDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfTranslationCodeDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfTranslationCodeDto {
    totalCount?: number;
    results?: TranslationCodeDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class TranslationCodeDto implements ITranslationCodeDto {
    id?: number;
    translationCode?: string | undefined;
    toTranslate?: boolean;
    dataTranslationValues?: TranslationValueDto[] | undefined;

    constructor(data?: ITranslationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.translationCode = _data["translationCode"];
            this.toTranslate = _data["toTranslate"];
            if (Array.isArray(_data["dataTranslationValues"])) {
                this.dataTranslationValues = [] as any;
                for (let item of _data["dataTranslationValues"])
                    this.dataTranslationValues!.push(TranslationValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranslationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["translationCode"] = this.translationCode;
        data["toTranslate"] = this.toTranslate;
        if (Array.isArray(this.dataTranslationValues)) {
            data["dataTranslationValues"] = [];
            for (let item of this.dataTranslationValues)
                data["dataTranslationValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TranslationCodeDto {
        const json = this.toJSON();
        let result = new TranslationCodeDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationCodeDto {
    id?: number;
    translationCode?: string | undefined;
    toTranslate?: boolean;
    dataTranslationValues?: TranslationValueDto[] | undefined;
}

export class TranslationValueDto implements ITranslationValueDto {
    id?: number;
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;

    constructor(data?: ITranslationValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): TranslationValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        return data;
    }

    clone(): TranslationValueDto {
        const json = this.toJSON();
        let result = new TranslationValueDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationValueDto {
    id?: number;
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;
}

export class SearchQueryOfTranslationCodeSearchCriteria implements ISearchQueryOfTranslationCodeSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationCodeSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfTranslationCodeSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? TranslationCodeSearchCriteria.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfTranslationCodeSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfTranslationCodeSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfTranslationCodeSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfTranslationCodeSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfTranslationCodeSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationCodeSearchCriteria | undefined;
}

export class TranslationCodeSearchCriteria extends PaginatedSearchable implements ITranslationCodeSearchCriteria {

    constructor(data?: ITranslationCodeSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TranslationCodeSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationCodeSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TranslationCodeSearchCriteria {
        const json = this.toJSON();
        let result = new TranslationCodeSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ITranslationCodeSearchCriteria extends IPaginatedSearchable {
}

export class TranslationDto implements ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;
    createdOn?: Date;
    updatedOn?: Date;
    toTranslate?: boolean;

    constructor(data?: ITranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.translationCode = _data["translationCode"];
            this.text = _data["text"];
            this.translationId = _data["translationId"];
            this.languageId = _data["languageId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.toTranslate = _data["toTranslate"];
        }
    }

    static fromJS(data: any): TranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["translationCode"] = this.translationCode;
        data["text"] = this.text;
        data["translationId"] = this.translationId;
        data["languageId"] = this.languageId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["toTranslate"] = this.toTranslate;
        return data;
    }

    clone(): TranslationDto {
        const json = this.toJSON();
        let result = new TranslationDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;
    createdOn?: Date;
    updatedOn?: Date;
    toTranslate?: boolean;
}

export class SearchQueryOfTranslationSearchCriteria implements ISearchQueryOfTranslationSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfTranslationSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? TranslationSearchCriteria.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfTranslationSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfTranslationSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfTranslationSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfTranslationSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfTranslationSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationSearchCriteria | undefined;
}

export class TranslationSearchCriteria extends PaginatedSearchable implements ITranslationSearchCriteria {
    languageCode?: string | undefined;

    constructor(data?: ITranslationSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
        }
    }

    static override fromJS(data: any): TranslationSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        super.toJSON(data);
        return data;
    }

    clone(): TranslationSearchCriteria {
        const json = this.toJSON();
        let result = new TranslationSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ITranslationSearchCriteria extends IPaginatedSearchable {
    languageCode?: string | undefined;
}

export class SaveTranslationDto implements ISaveTranslationDto {
    translationCode?: string | undefined;
    languageCode?: string | undefined;
    text?: string | undefined;

    constructor(data?: ISaveTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationCode = _data["translationCode"];
            this.languageCode = _data["languageCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SaveTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationCode"] = this.translationCode;
        data["languageCode"] = this.languageCode;
        data["text"] = this.text;
        return data;
    }

    clone(): SaveTranslationDto {
        const json = this.toJSON();
        let result = new SaveTranslationDto();
        result.init(json);
        return result;
    }
}

export interface ISaveTranslationDto {
    translationCode?: string | undefined;
    languageCode?: string | undefined;
    text?: string | undefined;
}

export class UpdateTranslationCommand implements IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;

    constructor(data?: IUpdateTranslationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationId = _data["translationId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UpdateTranslationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranslationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationId"] = this.translationId;
        data["text"] = this.text;
        return data;
    }

    clone(): UpdateTranslationCommand {
        const json = this.toJSON();
        let result = new UpdateTranslationCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;
}

export class PaginatedResultsOfTranslationDto implements IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfTranslationDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class PaginatedResultsOfUserActionGridDto implements IPaginatedResultsOfUserActionGridDto {
    totalCount?: number;
    results?: UserActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfUserActionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfUserActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfUserActionGridDto {
    totalCount?: number;
    results?: UserActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class UserActionGridDto implements IUserActionGridDto {
    contactId?: number;
    fullName?: string | undefined;
    login?: string | undefined;
    roles?: string[] | undefined;
    permissions?: number;

    constructor(data?: IUserActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.fullName = _data["fullName"];
            this.login = _data["login"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.permissions = _data["permissions"];
        }
    }

    static fromJS(data: any): UserActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["fullName"] = this.fullName;
        data["login"] = this.login;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["permissions"] = this.permissions;
        return data;
    }

    clone(): UserActionGridDto {
        const json = this.toJSON();
        let result = new UserActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IUserActionGridDto {
    contactId?: number;
    fullName?: string | undefined;
    login?: string | undefined;
    roles?: string[] | undefined;
    permissions?: number;
}

export class UserActionSearchDto extends PaginatedSearch implements IUserActionSearchDto {
    fullName?: TextSearch | undefined;
    login?: TextSearch | undefined;

    constructor(data?: IUserActionSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["fullName"] ? TextSearch.fromJS(_data["fullName"]) : undefined as any;
            this.login = _data["login"] ? TextSearch.fromJS(_data["login"]) : undefined as any;
        }
    }

    static override fromJS(data: any): UserActionSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActionSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName ? this.fullName.toJSON() : undefined as any;
        data["login"] = this.login ? this.login.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): UserActionSearchDto {
        const json = this.toJSON();
        let result = new UserActionSearchDto();
        result.init(json);
        return result;
    }
}

export interface IUserActionSearchDto extends IPaginatedSearch {
    fullName?: TextSearch | undefined;
    login?: TextSearch | undefined;
}

export abstract class FilterCriteriaBaseOfETextSearchTypeAndString implements IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfETextSearchTypeAndString.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfETextSearchTypeAndString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item ? item.toJSON() : undefined as any);
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }

    clone(): FilterCriteriaBaseOfETextSearchTypeAndString {
        throw new Error("The abstract class 'FilterCriteriaBaseOfETextSearchTypeAndString' cannot be instantiated.");
    }
}

export interface IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class TextSearch extends FilterCriteriaBaseOfETextSearchTypeAndString implements ITextSearch {

    constructor(data?: ITextSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TextSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TextSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TextSearch {
        const json = this.toJSON();
        let result = new TextSearch();
        result.init(json);
        return result;
    }
}

export interface ITextSearch extends IFilterCriteriaBaseOfETextSearchTypeAndString {
}

export class CombinableCriteriaOfETextSearchTypeAndString implements ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;

    constructor(data?: ICombinableCriteriaOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfETextSearchTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }

    clone(): CombinableCriteriaOfETextSearchTypeAndString {
        const json = this.toJSON();
        let result = new CombinableCriteriaOfETextSearchTypeAndString();
        result.init(json);
        return result;
    }
}

export interface ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
}

export enum ETextSearchType {
    StartWith = "StartWith",
    EndWith = "EndWith",
    Contains = "Contains",
    NotContains = "NotContains",
    Equals = "Equals",
    NotEquals = "NotEquals",
}

export class EditUserDto implements IEditUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    id?: number;
    roles?: number[] | undefined;
    rolesToString?: string[] | undefined;
    isActive?: boolean;
    fullName?: string | undefined;
    agentId?: number | undefined;
    roleName?: UserRoles;
    isGp?: boolean;

    constructor(data?: IEditUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.login = _data["login"];
            this.id = _data["id"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["rolesToString"])) {
                this.rolesToString = [] as any;
                for (let item of _data["rolesToString"])
                    this.rolesToString!.push(item);
            }
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.agentId = _data["agentId"];
            this.roleName = _data["roleName"];
            this.isGp = _data["isGp"];
        }
    }

    static fromJS(data: any): EditUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["login"] = this.login;
        data["id"] = this.id;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.rolesToString)) {
            data["rolesToString"] = [];
            for (let item of this.rolesToString)
                data["rolesToString"].push(item);
        }
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["agentId"] = this.agentId;
        data["roleName"] = this.roleName;
        data["isGp"] = this.isGp;
        return data;
    }

    clone(): EditUserDto {
        const json = this.toJSON();
        let result = new EditUserDto();
        result.init(json);
        return result;
    }
}

export interface IEditUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    id?: number;
    roles?: number[] | undefined;
    rolesToString?: string[] | undefined;
    isActive?: boolean;
    fullName?: string | undefined;
    agentId?: number | undefined;
    roleName?: UserRoles;
    isGp?: boolean;
}

export class UserProfileDto implements IUserProfileDto {
    userId?: string | undefined;
    login?: string | undefined;
    languageCode?: string | undefined;
    agentId?: number | undefined;
    roles?: UserRoles[] | undefined;
    actions?: ActionCode[] | undefined;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.login = _data["login"];
            this.languageCode = _data["languageCode"];
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["login"] = this.login;
        data["languageCode"] = this.languageCode;
        data["agentId"] = this.agentId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        return data;
    }

    clone(): UserProfileDto {
        const json = this.toJSON();
        let result = new UserProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfileDto {
    userId?: string | undefined;
    login?: string | undefined;
    languageCode?: string | undefined;
    agentId?: number | undefined;
    roles?: UserRoles[] | undefined;
    actions?: ActionCode[] | undefined;
}

export class SearchQueryOfUserSearchCriteria implements ISearchQueryOfUserSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: UserSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfUserSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : undefined as any;
            this.criteria = _data["criteria"] ? UserSearchCriteria.fromJS(_data["criteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchQueryOfUserSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfUserSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined as any;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        return data;
    }

    clone(): SearchQueryOfUserSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfUserSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfUserSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: UserSearchCriteria | undefined;
}

export class UserSearchCriteria extends PaginatedSearchable implements IUserSearchCriteria {
    customerId?: number | undefined;

    constructor(data?: IUserSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static override fromJS(data: any): UserSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        super.toJSON(data);
        return data;
    }

    clone(): UserSearchCriteria {
        const json = this.toJSON();
        let result = new UserSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IUserSearchCriteria extends IPaginatedSearchable {
    customerId?: number | undefined;
}

export class PaginatedResultsOfUserGridDto implements IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaginatedResultsOfUserGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfUserGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class UserGridDto implements IUserGridDto {
    id?: number;
    contactId?: number;
    role?: string[] | undefined;
    hasSpecificPermissions?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    roles?: string | undefined;
    language?: string | undefined;
    isActive?: boolean;
    ensureMfa?: boolean;

    constructor(data?: IUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            if (Array.isArray(_data["role"])) {
                this.role = [] as any;
                for (let item of _data["role"])
                    this.role!.push(item);
            }
            this.hasSpecificPermissions = _data["hasSpecificPermissions"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.login = _data["login"];
            this.roles = _data["roles"];
            this.language = _data["language"];
            this.isActive = _data["isActive"];
            this.ensureMfa = _data["ensureMfa"];
        }
    }

    static fromJS(data: any): UserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        if (Array.isArray(this.role)) {
            data["role"] = [];
            for (let item of this.role)
                data["role"].push(item);
        }
        data["hasSpecificPermissions"] = this.hasSpecificPermissions;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["login"] = this.login;
        data["roles"] = this.roles;
        data["language"] = this.language;
        data["isActive"] = this.isActive;
        data["ensureMfa"] = this.ensureMfa;
        return data;
    }

    clone(): UserGridDto {
        const json = this.toJSON();
        let result = new UserGridDto();
        result.init(json);
        return result;
    }
}

export interface IUserGridDto {
    id?: number;
    contactId?: number;
    role?: string[] | undefined;
    hasSpecificPermissions?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    roles?: string | undefined;
    language?: string | undefined;
    isActive?: boolean;
    ensureMfa?: boolean;
}

export class HealthCheckViewModel implements IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;

    constructor(data?: IHealthCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalStatus = _data["globalStatus"];
            this.checkTime = _data["checkTime"] ? new Date(_data["checkTime"].toString()) : undefined as any;
            this.worstExecutionTime = _data["worstExecutionTime"];
            this.totalExecutionTime = _data["totalExecutionTime"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(HealthCheckEntryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalStatus"] = this.globalStatus;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : undefined as any;
        data["worstExecutionTime"] = this.worstExecutionTime;
        data["totalExecutionTime"] = this.totalExecutionTime;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): HealthCheckViewModel {
        const json = this.toJSON();
        let result = new HealthCheckViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;
}

export class HealthCheckEntryViewModel implements IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;

    constructor(data?: IHealthCheckEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.statusDescription = _data["statusDescription"];
            this.executionTime = _data["executionTime"];
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (this.context as any)![key] = _data["context"][key] !== undefined ? _data["context"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HealthCheckEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["statusDescription"] = this.statusDescription;
        data["executionTime"] = this.executionTime;
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (data["context"] as any)[key] = (this.context as any)[key];
            }
        }
        return data;
    }

    clone(): HealthCheckEntryViewModel {
        const json = this.toJSON();
        let result = new HealthCheckEntryViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;
}

export class ClientApiKey implements IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;

    constructor(data?: IClientApiKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.apiKey = _data["apiKey"];
            this.hashedApiKey = _data["hashedApiKey"];
        }
    }

    static fromJS(data: any): ClientApiKey {
        data = typeof data === 'object' ? data : {};
        let result = new ClientApiKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["apiKey"] = this.apiKey;
        data["hashedApiKey"] = this.hashedApiKey;
        return data;
    }

    clone(): ClientApiKey {
        const json = this.toJSON();
        let result = new ClientApiKey();
        result.init(json);
        return result;
    }
}

export interface IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export interface Middleware {
  pre?(context: RequestInit): Promise<RequestInit | void>;

  post?(response: Response): Promise<Response | void>;
}

export interface Configuration {
  basePath?: string; // override base path
  apiKey?: string; // parameter for apiKey security
  apiKeyPromise?: () => Promise<string>;
  headers?: HTTPHeaders; //header params we want to use on every request
  credentials?: RequestCredentials; //value for the credentials param we want to use on each request
  middlewares?: Middleware[];
}

export type Json = any;
export type HTTPMethod =
  | "GET"
  | "POST"
  | "PUT"
  | "PATCH"
  | "DELETE"
  | "OPTIONS";
export type HTTPHeaders = { [key: string]: string };